import _isFunction from 'lodash/isFunction';
import React__default, { createContext, forwardRef, createElement, Component, Fragment as Fragment$1, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import _without from 'lodash/without';
import { helpers, modules, util } from 'veritone-redux-common';
import { bindActionCreators, combineReducers, compose, applyMiddleware, createStore } from 'redux';
import createSagaMiddleware, { channel, buffers, END } from 'redux-saga';
import { apiMiddleware } from 'redux-api-middleware-fixed';
import thunkMiddleware from 'redux-thunk';
import { playerReducer, operationReducer, playerActions, videoActions, ControlBar, ReplayControl, ForwardControl, PlayToggle, CurrentTimeDisplay, TimeDivider, DurationDisplay, ProgressControl, VolumeMenuButton, FullscreenToggle } from 'video-react';
import PropTypes, { func, object, string, bool, oneOf, arrayOf, shape, number, any, objectOf, oneOfType } from 'prop-types';
import _toPath from 'lodash/toPath';
import _isNil from 'lodash/isNil';
import _isEqualWith from 'lodash/isEqualWith';
import _get from 'lodash/get';
import _mapValues from 'lodash/mapValues';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import _merge from 'lodash/merge';
import _isArray$1 from 'lodash/isArray';
import _isNaN from 'lodash/isNaN';
import _mean from 'lodash/mean';
import _clamp from 'lodash/clamp';
import update from 'immutability-helper';
import _uniqWith from 'lodash/uniqWith';
import _pick from 'lodash/pick';
import _intersection from 'lodash/intersection';
import _isNumber from 'lodash/isNumber';
import _difference from 'lodash/difference';
import _union from 'lodash/union';
import _omit from 'lodash/omit';
import _set from 'lodash/set';
import _forEach from 'lodash/forEach';
import { call, select, takeEvery, put, all, fork, takeLatest, putResolve, take } from 'redux-saga/effects';
import includes from 'lodash/includes';
import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';
import toLower from 'lodash/toLower';
import _noop from 'lodash/noop';
import { VeritoneSDKThemeProvider, FilePicker as FilePicker$1, FileProgressDialog, RaisedTextField, formComponents, Avatar, AppBar as AppBar$2, OAuthLoginButton as OAuthLoginButton$1, SearchBox, LoadingState, FolderNullState, FolderTree as FolderTree$1, DeleteFolder, EditFolder, CreateFolder, DataPicker as DataPicker$1, DiscoverySideBarPure, Lozenge, Truncate, PaginatedTable, Table as Table$1, MenuColumn, Column, MediaPlayer as MediaPlayer$1, RestartMediaButton, Lightbox, ExpandableInputField, SelectionButton } from 'veritone-react-common';
export { appBarHeight, defaultAppBarZIndex } from 'veritone-react-common';
import _forOwn from 'lodash/forOwn';
import _startCase from 'lodash/startCase';
import { withPropsOnChange, branch, renderNothing, withProps } from 'recompose';
import Dialog from '@material-ui/core/Dialog';
import AppBar$1 from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';
import Slide from '@material-ui/core/Slide';
import { makeStyles, withStyles } from '@material-ui/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import _flattenDeep from 'lodash/flattenDeep';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import _debounce from 'lodash/debounce';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import TextField$1 from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import _isString from 'lodash/isString';
import _sortBy from 'lodash/sortBy';
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@material-ui/core/Radio';
import { InfiniteLoader, AutoSizer, List as List$1 } from 'react-virtualized';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import List$2 from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import _kebabCase from 'lodash/kebabCase';
import _find from 'lodash/find';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Table$2 from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode:  'pure' ,
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$1 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$1
};

var f$2 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$2
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 19.1.2.1 Object.assign(target, source, ...)





var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign = _core.Object.assign;

var assign$1 = createCommonjsModule(function (module) {
module.exports = { "default": assign, __esModule: true };
});

var _Object$assign = unwrapExports(assign$1);

var _extends = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _assign2 = _interopRequireDefault(assign$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
});

var _extends$1 = unwrapExports(_extends);

const { createReducer } = helpers;

const namespace = 'veritoneApp';

const WIDGET_ADDED = 'vtn/veritoneApp/WIDGET_ADDED';
const WIDGET_REMOVED = 'vtn/veritoneApp/WIDGET_REMOVED';

const defaultState = {
  widgets: []
};

const reducer = createReducer(defaultState, {
  [WIDGET_ADDED](state, { payload: widget }) {
    return _extends$1({}, state, {
      widgets: [...state.widgets, widget]
    });
  },

  [WIDGET_REMOVED](state, { payload: widget }) {
    return _extends$1({}, state, {
      widgets: _without(state.widgets, widget)
    });
  }
});

function local(state) {
  return state[namespace];
}

function widgetAdded(widget) {
  return {
    type: WIDGET_ADDED,
    payload: widget
  };
}

function widgetRemoved(widget) {
  return {
    type: WIDGET_REMOVED,
    payload: widget
  };
}

const widgets = state => local(state).widgets;

var apiRoot = "https://api.veritone.com";
var switchAppRoute = "https://app.veritone.com/switch-app";
var graphQLEndpoint = "v3/graphql";
var appConfig = {
	apiRoot: apiRoot,
	switchAppRoute: switchAppRoute,
	graphQLEndpoint: graphQLEndpoint
};

const { promiseMiddleware } = helpers;

const getBaseMiddlewares = () => [apiMiddleware(fetch), promiseMiddleware.main(), thunkMiddleware];

const getDevOnlyMiddlewares = () => {
  return  [];
};

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var prefix = '@@redux-form/';
var ARRAY_INSERT = prefix + "ARRAY_INSERT";
var ARRAY_MOVE = prefix + "ARRAY_MOVE";
var ARRAY_POP = prefix + "ARRAY_POP";
var ARRAY_PUSH = prefix + "ARRAY_PUSH";
var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
var ARRAY_SWAP = prefix + "ARRAY_SWAP";
var AUTOFILL = prefix + "AUTOFILL";
var BLUR = prefix + "BLUR";
var CHANGE = prefix + "CHANGE";
var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
var DESTROY = prefix + "DESTROY";
var FOCUS = prefix + "FOCUS";
var INITIALIZE = prefix + "INITIALIZE";
var REGISTER_FIELD = prefix + "REGISTER_FIELD";
var RESET = prefix + "RESET";
var RESET_SECTION = prefix + "RESET_SECTION";
var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
var START_SUBMIT = prefix + "START_SUBMIT";
var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
var STOP_SUBMIT = prefix + "STOP_SUBMIT";
var SUBMIT = prefix + "SUBMIT";
var TOUCH = prefix + "TOUCH";
var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
var UNTOUCH = prefix + "UNTOUCH";
var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";

var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: ARRAY_INSERT,
    meta: {
      form: form,
      field: field,
      index: index
    },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: ARRAY_MOVE,
    meta: {
      form: form,
      field: field,
      from: from,
      to: to
    }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: ARRAY_POP,
    meta: {
      form: form,
      field: field
    }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: ARRAY_PUSH,
    meta: {
      form: form,
      field: field
    },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: ARRAY_REMOVE,
    meta: {
      form: form,
      field: field,
      index: index
    }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: ARRAY_REMOVE_ALL,
    meta: {
      form: form,
      field: field
    }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: ARRAY_SHIFT,
    meta: {
      form: form,
      field: field
    }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: ARRAY_SPLICE,
    meta: {
      form: form,
      field: field,
      index: index,
      removeNum: removeNum
    }
  };

  if (value !== undefined) {
    action.payload = value;
  }

  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }

  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }

  return {
    type: ARRAY_SWAP,
    meta: {
      form: form,
      field: field,
      indexA: indexA,
      indexB: indexB
    }
  };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: ARRAY_UNSHIFT,
    meta: {
      form: form,
      field: field
    },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: AUTOFILL,
    meta: {
      form: form,
      field: field
    },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: BLUR,
    meta: {
      form: form,
      field: field,
      touch: touch
    },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: CHANGE,
    meta: {
      form: form,
      field: field,
      touch: touch,
      persistentSubmitErrors: persistentSubmitErrors
    },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: CLEAR_SUBMIT,
    meta: {
      form: form
    }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: CLEAR_SUBMIT_ERRORS,
    meta: {
      form: form
    }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: CLEAR_ASYNC_ERROR,
    meta: {
      form: form,
      field: field
    }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: CLEAR_FIELDS,
    meta: {
      form: form,
      keepTouched: keepTouched,
      persistentSubmitErrors: persistentSubmitErrors,
      fields: fields
    }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: DESTROY,
    meta: {
      form: form
    }
  };
};

var focus = function focus(form, field) {
  return {
    type: FOCUS,
    meta: {
      form: form,
      field: field
    }
  };
};

var initialize = function initialize(form, values, keepDirty, otherMeta) {
  if (otherMeta === void 0) {
    otherMeta = {};
  }

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }

  return {
    type: INITIALIZE,
    meta: _extends_1({
      form: form,
      keepDirty: keepDirty
    }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: REGISTER_FIELD,
    meta: {
      form: form
    },
    payload: {
      name: name,
      type: type
    }
  };
};

var reset = function reset(form) {
  return {
    type: RESET,
    meta: {
      form: form
    }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: RESET_SECTION,
    meta: {
      form: form,
      sections: sections
    }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: START_ASYNC_VALIDATION,
    meta: {
      form: form,
      field: field
    }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: START_SUBMIT,
    meta: {
      form: form
    }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: STOP_ASYNC_VALIDATION,
    meta: {
      form: form
    },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: STOP_SUBMIT,
    meta: {
      form: form
    },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: SUBMIT,
    meta: {
      form: form
    }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: SET_SUBMIT_FAILED,
    meta: {
      form: form,
      fields: fields
    },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: SET_SUBMIT_SUCCEEDED,
    meta: {
      form: form,
      fields: fields
    },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: TOUCH,
    meta: {
      form: form,
      fields: fields
    }
  };
};

var unregisterField = function unregisterField(form, name, destroyOnUnmount) {
  if (destroyOnUnmount === void 0) {
    destroyOnUnmount = true;
  }

  return {
    type: UNREGISTER_FIELD,
    meta: {
      form: form
    },
    payload: {
      name: name,
      destroyOnUnmount: destroyOnUnmount
    }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: UNTOUCH,
    meta: {
      form: form,
      fields: fields
    }
  };
};

var updateSyncErrors = function updateSyncErrors(form, syncErrors, error) {
  if (syncErrors === void 0) {
    syncErrors = {};
  }

  return {
    type: UPDATE_SYNC_ERRORS,
    meta: {
      form: form
    },
    payload: {
      syncErrors: syncErrors,
      error: error
    }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form, syncWarnings, warning) {
  if (syncWarnings === void 0) {
    syncWarnings = {};
  }

  return {
    type: UPDATE_SYNC_WARNINGS,
    meta: {
      form: form
    },
    payload: {
      syncWarnings: syncWarnings,
      warning: warning
    }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var ReduxFormContext = createContext(null);
var renderChildren = function renderChildren(Component, _ref) {
  var forwardedRef = _ref.forwardedRef,
      rest = objectWithoutPropertiesLoose(_ref, ["forwardedRef"]);

  return function (_reduxForm) {
    return createElement(Component, _extends_1({}, rest, {
      _reduxForm: _reduxForm,
      ref: forwardedRef
    }));
  };
};
var withReduxForm = function withReduxForm(Component$1) {
  var Hoc =
  /*#__PURE__*/
  function (_React$Component) {
    inheritsLoose(Hoc, _React$Component);

    function Hoc() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = Hoc.prototype;

    _proto.render = function render() {
      return createElement(ReduxFormContext.Consumer, {
        children: renderChildren(Component$1, this.props)
      });
    };

    return Hoc;
  }(Component);

  var ref = forwardRef(function (props, ref) {
    return createElement(Hoc, _extends_1({}, props, {
      forwardedRef: ref
    }));
  });
  ref.displayName = Component$1.displayName || Component$1.name || 'Component';
  return ref;
};

var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }

  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;

    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;

    default:
      return false;
  }
};

var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }

  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }

  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }

  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var Form =
/*#__PURE__*/
function (_Component) {
  inheritsLoose(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    if (!props._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }

    return _this;
  }

  var _proto = Form.prototype;

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _reduxForm = _this$props._reduxForm,
        rest = objectWithoutPropertiesLoose(_this$props, ["_reduxForm"]);

    return React__default.createElement("form", rest);
  };

  return Form;
}(Component);

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  _reduxForm: PropTypes.object
};
polyfill(Form);
var Form$1 = withReduxForm(Form);

var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + "." + name : name;
};

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_production_min;
}
});
var reactIs_1 = reactIs.isElement;
var reactIs_2 = reactIs.isValidElementType;

var validateComponentProp = function validateComponentProp(props, propName, componentName) {
  if (!reactIs_2(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
  }

  return null;
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

var SubmissionError =
/*#__PURE__*/
function (_ExtendableError) {
  inheritsLoose(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    var _this;

    _this = _ExtendableError.call(this, 'Submit Validation Failed') || this;
    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(ExtendableError);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var browser = invariant;

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends_1({}, props, {
      checked: !!value
    });
  }

  if (type === 'radio') {
    return _extends_1({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }

  if (type === 'select-multiple') {
    return _extends_1({}, props, {
      value: value || []
    });
  }

  if (type === 'file') {
    return _extends_1({}, props, {
      value: value || undefined
    });
  }

  return props;
};

var createFieldProps = function createFieldProps(_ref, name, _ref2) {
  var getIn = _ref.getIn,
      toJS = _ref.toJS,
      deepEqual = _ref.deepEqual;

  var asyncError = _ref2.asyncError,
      asyncValidating = _ref2.asyncValidating,
      onBlur = _ref2.onBlur,
      onChange = _ref2.onChange,
      onDrop = _ref2.onDrop,
      onDragStart = _ref2.onDragStart,
      dirty = _ref2.dirty,
      dispatch = _ref2.dispatch,
      onFocus = _ref2.onFocus,
      form = _ref2.form,
      format = _ref2.format,
      initial = _ref2.initial,
      parse = _ref2.parse,
      pristine = _ref2.pristine,
      props = _ref2.props,
      state = _ref2.state,
      submitError = _ref2.submitError,
      submitFailed = _ref2.submitFailed,
      submitting = _ref2.submitting,
      syncError = _ref2.syncError,
      syncWarning = _ref2.syncWarning,
      validate = _ref2.validate,
      value = _ref2.value,
      _value = _ref2._value,
      warn = _ref2.warn,
      custom = objectWithoutPropertiesLoose(_ref2, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"]);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }

    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);
  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends_1({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends_1({}, custom, {}, props)
  };
};

var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

var getSelectedValues = function getSelectedValues(options) {
  var result = [];

  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];

      if (option.selected) {
        result.push(option.value);
      }
    }
  }

  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (isEvent(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }

    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }

    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }

    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }

    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }

    return value;
  }

  return event;
};

var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;
  // read value from input
  var value = getValue(event, isReactNative); // parse value if we have a parser

  if (parse) {
    value = parse(value, name);
  } // normalize value


  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

var dataKey = 'text';

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(array);

      _copy2.splice(index, 0, true); // temporary placeholder


      _copy2[index] = undefined; // set to undefined

      return _copy2;
    }

    if (value != null) {
      var _copy3 = [].concat(array);

      _copy3.splice(index, removeNum, value); // removing and adding


      return _copy3;
    }

    var _copy = [].concat(array);

    _copy.splice(index, removeNum); // removing


    return _copy;
  }

  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  } // trying to add outside of range: just set value


  var copy = [].concat(array);
  copy[index] = value;
  return copy;
};

var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = _toPath(field);

  var length = path.length;

  if (!length) {
    return undefined;
  }

  var result = state;

  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

var _extends_1$1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  var _extends2;

  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      var _ref;

      return _ref = {}, _ref[first] = next, _ref;
    }

    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends_1$1({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, _toPath(field), 0);
};

var isEmpty = function isEmpty(obj) {
  return _isNil(obj) || obj === '' || isNaN(obj);
};

var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    return isEmpty(obj) === isEmpty(other);
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (React__default.isValidElement(obj) || React__default.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return _isEqualWith(a, b, customizer);
};

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error("Must access array elements with a number, not \"" + String(first) + "\".");
      }

      var firstIndex = Number(first);

      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(rest));

        if (result !== state[firstIndex]) {
          var copy = [].concat(state);
          copy[firstIndex] = result;
          return copy;
        }
      }

      return state;
    }

    if (first in state) {
      var _extends2;

      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(rest));

      return state[first] === _result ? state : _extends_1$1({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
    }

    return state;
  }

  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error("Cannot delete non-numerical index from an array. Given: \"" + String(first));
    }

    var _firstIndex = Number(first);

    if (_firstIndex < state.length) {
      var _copy = [].concat(state);

      _copy.splice(_firstIndex, 1);

      return _copy;
    }

    return state;
  }

  if (first in state) {
    var _copy2 = _extends_1$1({}, state);

    delete _copy2[first];
    return _copy2;
  }

  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(void 0, [state].concat(_toPath(field)));
};

function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}

var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: getIn,
  setIn: setIn,
  deepEqual: deepEqual,
  deleteIn: deleteIn,
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: keys,
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: splice,
  equals: function equals(a, b) {
    return b.every(function (val) {
      return ~a.indexOf(val);
    });
  },
  orderChanged: function orderChanged(a, b) {
    return b.some(function (val, index) {
      return val !== a[index];
    });
  },
  toJS: function toJS(value) {
    return value;
  }
};

var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && typeof entity === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure$1) {
  var deepEqual = structure$1.deepEqual,
      getIn = structure$1.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = structure.getIn(syncErrors, name); // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property

    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property

    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField =
  /*#__PURE__*/
  function (_Component) {
    inheritsLoose(ConnectedField, _Component);

    function ConnectedField() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.ref = React__default.createRef();

      _this.isPristine = function () {
        return _this.props.pristine;
      };

      _this.getValue = function () {
        return _this.props.value;
      };

      _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;
        var newValue = onChangeValue(event, {
          name: name,
          parse: parse,
          normalize: normalize
        });
        var defaultPrevented = false;

        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!isReactNative && isEvent(event)) {
            onChange(_extends_1({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            var onChangeResult = onChange(event, newValue, previousValue, name); // Return value of change handler affecting preventDefault is RN
            // specific behavior.

            if (isReactNative) {
              defaultPrevented = onChangeResult;
            }
          }
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue)); // call post-change callback

          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      };

      _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;
        var defaultPrevented = false;

        if (onFocus) {
          if (!isReactNative) {
            onFocus(_extends_1({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            defaultPrevented = onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      };

      _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;
        var newValue = onChangeValue(event, {
          name: name,
          parse: parse,
          normalize: normalize
        }); // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.

        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;

        if (onBlur) {
          if (!isReactNative) {
            onBlur(_extends_1({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            defaultPrevented = onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue)); // call post-blur callback

          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      };

      _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;
        eventDataTransferSetData(event, dataKey, value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      };

      _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;
        var newValue = eventDataTransferGetData(event, dataKey);
        var defaultPrevented = false;

        if (onDrop) {
          onDrop(_extends_1({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      };

      return _this;
    }

    var _proto = ConnectedField.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var nextPropsKeys = Object.keys(nextProps);
      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
      // https://twitter.com/erikras/status/915866544558788608

      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
        if (~(nextProps.immutableProps || []).indexOf(prop)) {
          return _this2.props[prop] !== nextProps[prop];
        }

        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
      }));
    };

    _proto.getRenderedComponent = function getRenderedComponent() {
      return this.ref.current;
    };

    _proto.render = function render() {
      var _this$props6 = this.props,
          component = _this$props6.component,
          forwardRef = _this$props6.forwardRef,
          name = _this$props6.name,
          _reduxForm = _this$props6._reduxForm,
          normalize = _this$props6.normalize,
          onBlur = _this$props6.onBlur,
          onChange = _this$props6.onChange,
          onFocus = _this$props6.onFocus,
          onDragStart = _this$props6.onDragStart,
          onDrop = _this$props6.onDrop,
          immutableProps = _this$props6.immutableProps,
          rest = objectWithoutPropertiesLoose(_this$props6, ["component", "forwardRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"]);

      var _createFieldProps = createFieldProps(structure$1, name, _extends_1({}, rest, {
        form: _reduxForm.form,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onDrop: this.handleDrop,
        onDragStart: this.handleDragStart,
        onFocus: this.handleFocus
      })),
          custom = _createFieldProps.custom,
          props = objectWithoutPropertiesLoose(_createFieldProps, ["custom"]);

      if (forwardRef) {
        custom.ref = this.ref;
      }

      if (typeof component === 'string') {
        var input = props.input,
            meta = props.meta; // eslint-disable-line no-unused-vars
        // flatten input into other props

        return createElement(component, _extends_1({}, input, {}, custom));
      } else {
        return createElement(component, _extends_1({}, props, {}, custom));
      }
    };

    return ConnectedField;
  }(Component);

  ConnectedField.propTypes = {
    component: validateComponentProp,
    props: PropTypes.object
  };
  var connector = connect(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;
    var formState = getFormState(state);
    var initialState = getIn(formState, "initial." + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, "values." + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, "asyncErrors." + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, "fields." + name),
      submitError: getIn(formState, "submitErrors." + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for radios)

    };
  }, undefined, undefined, {
    forwardRef: true
  });
  return connector(ConnectedField);
};

var customizer$1 = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = _isEqualWith(instance.props, nextProps, customizer$1);

  var stateEqual = _isEqualWith(instance.state, nextState, customizer$1);

  return !propsEqual || !stateEqual;
};

var createField = function createField(structure$1) {
  var ConnectedField = createConnectedField(structure$1);
  var setIn = structure$1.setIn;

  var Field =
  /*#__PURE__*/
  function (_Component) {
    inheritsLoose(Field, _Component);

    function Field(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.ref = React__default.createRef();

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }

        var previousValues = _this.props._reduxForm.getValues();

        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues, name);
      };

      if (!props._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }

      return _this;
    }

    var _proto = Field.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.props._reduxForm.register(this.name, 'Field', function () {
        return _this2.props.validate;
      }, function () {
        return _this2.props.warn;
      });
    };

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    };

    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
      var oldName = formatName(this.props, this.props.name);
      var newName = formatName(nextProps, nextProps.name);

      if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
      !structure.deepEqual(this.props.validate, nextProps.validate) || !structure.deepEqual(this.props.warn, nextProps.warn)) {
        // unregister old name
        this.props._reduxForm.unregister(oldName); // register new name


        this.props._reduxForm.register(newName, 'Field', function () {
          return nextProps.validate;
        }, function () {
          return nextProps.warn;
        });
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.props._reduxForm.unregister(this.name);
    };

    _proto.getRenderedComponent = function getRenderedComponent() {
      browser(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Field');
      return this.ref.current ? this.ref.current.getRenderedComponent() : undefined;
    };

    _proto.render = function render() {
      return createElement(ConnectedField, _extends_1({}, this.props, {
        name: this.name,
        normalize: this.normalize,
        ref: this.ref
      }));
    };

    createClass(Field, [{
      key: "name",
      get: function get() {
        return formatName(this.props, this.props.name);
      }
    }, {
      key: "dirty",
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: "pristine",
      get: function get() {
        return !!(this.ref.current && this.ref.current.isPristine());
      }
    }, {
      key: "value",
      get: function get() {
        return this.ref.current && this.ref.current.getValue();
      }
    }]);

    return Field;
  }(Component);

  Field.propTypes = {
    name: PropTypes.string.isRequired,
    component: validateComponentProp,
    format: PropTypes.func,
    normalize: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    parse: PropTypes.func,
    props: PropTypes.object,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    warn: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.func)]),
    forwardRef: PropTypes.bool,
    immutableProps: PropTypes.arrayOf(PropTypes.string),
    _reduxForm: PropTypes.object
  };
  polyfill(Field);
  return withReduxForm(Field);
};

var Field = createField(structure);

var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + "._error"];

    case 'FieldArray':
      return [name + "._error"];

    default:
      throw new Error('Unknown field type');
  }
};

var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };

  return hasError;
};

var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;
  var hasError = createHasError(structure);
  return function (form, getFormState, ignoreSubmitErrors) {
    if (ignoreSubmitErrors === void 0) {
      ignoreSubmitErrors = false;
    }

    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + ".syncError");

      if (syncError) {
        return false;
      }

      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + ".error");

        if (error) {
          return false;
        }
      }

      var syncErrors = getIn(formState, form + ".syncErrors");
      var asyncErrors = getIn(formState, form + ".asyncErrors");
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + ".submitErrors");

      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + ".registeredFields");

      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, "['" + name + "'].count") > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f$3=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f$3:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f$3;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f$3};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f$3||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min$1 = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs$1 = createCommonjsModule(function (module) {

{
  module.exports = reactIs_production_min$1;
}
});
var reactIs_1$1 = reactIs$1.ForwardRef;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (reactIs$1.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var isPromise_1 = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();

  if (!isPromise_1(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }

  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }

      stop();
      return Promise.resolve();
    };
  };

  return promise.then(handleErrors(false), handleErrors(true));
};

var silenceEvent = function silenceEvent(event) {
  var is = isEvent(event);

  if (is) {
    event.preventDefault();
  }

  return is;
};

var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return silenceEvent(event) ? fn.apply(void 0, args) : fn.apply(void 0, [event].concat(args));
  };
};

var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);

  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);

    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);

      if (error) {
        errors = structure.setIn(errors, name, error);
      }
    });
    return errors;
  };
};

var isSubmissionError = function isSubmissionError(error) {
  return error && error.name === SubmissionError.name;
};

var mergeErrors = function mergeErrors(_ref) {
  var asyncErrors = _ref.asyncErrors,
      syncErrors = _ref.syncErrors;
  return asyncErrors && typeof asyncErrors.merge === 'function' ? asyncErrors.merge(syncErrors).toJS() : _extends_1({}, asyncErrors, {}, syncErrors);
};

var isImmutableList;

try {
  // ImmutableJS isList implementation if available
  // eslint-disable-next-line import/no-extraneous-dependencies
  var _require = require('immutable'),
      List = _require.List;

  isImmutableList = List.isList;
} catch (err) {
  isImmutableList = function isImmutableList(maybeList) {
    return false;
  };
} // fields may be an Immutable List which cannot be spread
// convert the fields to an array if necessary


var makeFieldsArray = function makeFieldsArray(fields) {
  return isImmutableList(fields) ? fields.toArray() : fields;
};

var executeSubmit = function executeSubmit(submit, fields, props) {
  var dispatch = props.dispatch,
      submitAsSideEffect = props.submitAsSideEffect,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      values = props.values;
  fields = makeFieldsArray(fields);
  var result;

  try {
    result = submit(values, dispatch, props);
  } catch (submitError) {
    var error = isSubmissionError(submitError) ? submitError.errors : undefined;
    stopSubmit(error);
    setSubmitFailed.apply(void 0, fields);

    if (onSubmitFail) {
      onSubmitFail(error, dispatch, submitError, props);
    }

    if (error || onSubmitFail) {
      // if you've provided an onSubmitFail callback, don't re-throw the error
      return error;
    } else {
      throw submitError;
    }
  }

  if (submitAsSideEffect) {
    if (result) {
      dispatch(result);
    }
  } else {
    if (isPromise_1(result)) {
      startSubmit();
      return result.then(function (submitResult) {
        stopSubmit();
        setSubmitSucceeded();

        if (onSubmitSuccess) {
          onSubmitSuccess(submitResult, dispatch, props);
        }

        return submitResult;
      }, function (submitError) {
        var error = isSubmissionError(submitError) ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(void 0, fields);

        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }

        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      });
    } else {
      setSubmitSucceeded();

      if (onSubmitSuccess) {
        onSubmitSuccess(result, dispatch, props);
      }
    }
  }

  return result;
};

var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      setSubmitFailed = props.setSubmitFailed,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      persistentSubmitErrors = props.persistentSubmitErrors;
  fields = makeFieldsArray(fields);
  touch.apply(void 0, fields); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var asyncValidateResult = asyncValidate && asyncValidate();

    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }

        return executeSubmit(submit, fields, props);
      })["catch"](function (asyncErrors) {
        setSubmitFailed.apply(void 0, fields);

        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }

        return Promise.reject(asyncErrors);
      });
    } else {
      return executeSubmit(submit, fields, props);
    }
  } else {
    setSubmitFailed.apply(void 0, fields);
    var errors = mergeErrors({
      asyncErrors: asyncErrors,
      syncErrors: syncErrors
    });

    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }

    return errors;
  }
};

var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

var isHotReloading = function isHotReloading() {
  var castModule = module;
  return !!(typeof castModule !== 'undefined' && castModule.hot && typeof castModule.hot.status === 'function' && castModule.hot.status() === 'apply');
};

var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
}; // extract field-specific actions


var arrayInsert$1 = actions.arrayInsert,
    arrayMove$1 = actions.arrayMove,
    arrayPop$1 = actions.arrayPop,
    arrayPush$1 = actions.arrayPush,
    arrayRemove$1 = actions.arrayRemove,
    arrayRemoveAll$1 = actions.arrayRemoveAll,
    arrayShift$1 = actions.arrayShift,
    arraySplice$1 = actions.arraySplice,
    arraySwap$1 = actions.arraySwap,
    arrayUnshift$1 = actions.arrayUnshift,
    blur$1 = actions.blur,
    change$1 = actions.change,
    focus$1 = actions.focus,
    formActions = objectWithoutPropertiesLoose(actions, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]);

var arrayActions = {
  arrayInsert: arrayInsert$1,
  arrayMove: arrayMove$1,
  arrayPop: arrayPop$1,
  arrayPush: arrayPush$1,
  arrayRemove: arrayRemove$1,
  arrayRemoveAll: arrayRemoveAll$1,
  arrayShift: arrayShift$1,
  arraySplice: arraySplice$1,
  arraySwap: arraySwap$1,
  arrayUnshift: arrayUnshift$1
};
var propsToNotUpdateFor$1 = [].concat(Object.keys(actions), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }

  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure$1) {
  var deepEqual = structure$1.deepEqual,
      empty = structure$1.empty,
      getIn = structure$1.getIn,
      setIn = structure$1.setIn,
      keys = structure$1.keys,
      fromJS = structure$1.fromJS;
  var isValid = createIsValid(structure$1);
  return function (initialConfig) {
    var config = _extends_1({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: defaultShouldAsyncValidate,
      shouldValidate: defaultShouldValidate,
      shouldError: defaultShouldError,
      shouldWarn: defaultShouldWarn,
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false,
      submitAsSideEffect: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form =
      /*#__PURE__*/
      function (_React$Component) {
        inheritsLoose(Form, _React$Component);

        function Form() {
          var _this;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
          _this.wrapped = React__default.createRef();
          _this.destroyed = false;
          _this.fieldCounts = {};
          _this.fieldValidators = {};
          _this.lastFieldValidatorKeys = [];
          _this.fieldWarners = {};
          _this.lastFieldWarnerKeys = [];
          _this.innerOnSubmit = undefined;
          _this.submitPromise = undefined;

          _this.getValues = function () {
            return _this.props.values;
          };

          _this.isValid = function () {
            return _this.props.valid;
          };

          _this.isPristine = function () {
            return _this.props.pristine;
          };

          _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;

            _this.props.registerField(name, type);

            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }

            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          };

          _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || forceUnregisterOnUnmount) {
                unregisterField(name, _destroyOnUnmount);

                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                unregisterField(name, false);
              }
            }
          };

          _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];

            if (!registeredFields) {
              return list;
            }

            var keySeq = keys(registeredFields);

            if (options) {
              if (options.excludeFieldArray) {
                keySeq = keySeq.filter(function (name) {
                  return getIn(registeredFields, "['" + name + "'].type") !== 'FieldArray';
                });
              }

              if (options.excludeUnregistered) {
                keySeq = keySeq.filter(function (name) {
                  return getIn(registeredFields, "['" + name + "'].count") !== 0;
                });
              }
            }

            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          };

          _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();

              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          };

          _this.generateValidator = function () {
            var validators = _this.getValidators();

            return Object.keys(validators).length ? generateValidator(validators, structure$1) : undefined;
          };

          _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();

              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          };

          _this.generateWarner = function () {
            var warners = _this.getWarners();

            return Object.keys(warners).length ? generateValidator(warners, structure$1) : undefined;
          };

          _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;
            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);

              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return asyncValidation(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          };

          _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          };

          _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          };

          _this.listenToSubmit = function (promise) {
            if (!isPromise_1(promise)) {
              return promise;
            }

            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          };

          _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;

            if (!submitOrEvent || silenceEvent(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(handleSubmit(checkSubmit(onSubmit), _extends_1({}, _this.props, {}, bindActionCreators({
                    blur: blur,
                    change: change
                  }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
                    excludeFieldArray: true,
                    excludeUnregistered: true
                  })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return silenceEvents(function () {
                return !_this.submitPromise && _this.listenToSubmit(handleSubmit(checkSubmit(submitOrEvent), _extends_1({}, _this.props, {}, bindActionCreators({
                  blur: blur,
                  change: change
                }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
                  excludeFieldArray: true,
                  excludeUnregistered: true
                })));
              });
            }
          };

          _this.reset = function () {
            return _this.props.reset();
          };

          return _this;
        }

        var _proto = Form.prototype;

        _proto.initIfNeeded = function initIfNeeded(nextProps) {
          var enableReinitialize = this.props.enableReinitialize;

          if (nextProps) {
            if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
              var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;

              this.props.initialize(nextProps.initialValues, _keepDirty, {
                keepValues: nextProps.keepValues,
                lastInitialValues: this.props.initialValues,
                updateUnregisteredFields: nextProps.updateUnregisteredFields
              });
            }
          } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
            this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
              keepValues: this.props.keepValues,
              updateUnregisteredFields: this.props.updateUnregisteredFields
            });
          }
        };

        _proto.updateSyncErrorsIfNeeded = function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
          var _this$props4 = this.props,
              error = _this$props4.error,
              updateSyncErrors = _this$props4.updateSyncErrors;
          var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
          var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;

          if (!(noErrors && nextNoErrors) && (!structure.deepEqual(lastSyncErrors, nextSyncErrors) || !structure.deepEqual(error, nextError))) {
            updateSyncErrors(nextSyncErrors, nextError);
          }
        };

        _proto.clearSubmitPromiseIfNeeded = function clearSubmitPromiseIfNeeded(nextProps) {
          var submitting = this.props.submitting;

          if (this.submitPromise && submitting && !nextProps.submitting) {
            delete this.submitPromise;
          }
        };

        _proto.submitIfNeeded = function submitIfNeeded(nextProps) {
          var _this$props5 = this.props,
              clearSubmit = _this$props5.clearSubmit,
              triggerSubmit = _this$props5.triggerSubmit;

          if (!triggerSubmit && nextProps.triggerSubmit) {
            clearSubmit();
            this.submit();
          }
        };

        _proto.shouldErrorFunction = function shouldErrorFunction() {
          var _this$props6 = this.props,
              shouldValidate = _this$props6.shouldValidate,
              shouldError = _this$props6.shouldError;
          var shouldValidateOverridden = shouldValidate !== defaultShouldValidate;
          var shouldErrorOverridden = shouldError !== defaultShouldError;
          return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
        };

        _proto.validateIfNeeded = function validateIfNeeded(nextProps) {
          var _this$props7 = this.props,
              validate = _this$props7.validate,
              values = _this$props7.values;
          var shouldError = this.shouldErrorFunction();
          var fieldLevelValidate = this.generateValidator();

          if (validate || fieldLevelValidate) {
            var initialRender = nextProps === undefined;
            var fieldValidatorKeys = Object.keys(this.getValidators());
            var validateParams = {
              values: values,
              nextProps: nextProps,
              props: this.props,
              initialRender: initialRender,
              lastFieldValidatorKeys: this.lastFieldValidatorKeys,
              fieldValidatorKeys: fieldValidatorKeys,
              structure: structure$1
            };

            if (shouldError(validateParams)) {
              var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

              var _merge2 = _merge(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                  _error = _merge2._error,
                  nextSyncErrors = objectWithoutPropertiesLoose(_merge2, ["_error"]);

              this.lastFieldValidatorKeys = fieldValidatorKeys;
              this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
            }
          } else {
            this.lastFieldValidatorKeys = [];
          }
        };

        _proto.updateSyncWarningsIfNeeded = function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
          var _this$props8 = this.props,
              warning = _this$props8.warning,
              updateSyncWarnings = _this$props8.updateSyncWarnings;
          var noWarnings = (!lastSyncWarnings || !Object.keys(lastSyncWarnings).length) && !warning;
          var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;

          if (!(noWarnings && nextNoWarnings) && (!structure.deepEqual(lastSyncWarnings, nextSyncWarnings) || !structure.deepEqual(warning, nextWarning))) {
            updateSyncWarnings(nextSyncWarnings, nextWarning);
          }
        };

        _proto.shouldWarnFunction = function shouldWarnFunction() {
          var _this$props9 = this.props,
              shouldValidate = _this$props9.shouldValidate,
              shouldWarn = _this$props9.shouldWarn;
          var shouldValidateOverridden = shouldValidate !== defaultShouldValidate;
          var shouldWarnOverridden = shouldWarn !== defaultShouldWarn;
          return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
        };

        _proto.warnIfNeeded = function warnIfNeeded(nextProps) {
          var _this$props10 = this.props,
              warn = _this$props10.warn,
              values = _this$props10.values;
          var shouldWarn = this.shouldWarnFunction();
          var fieldLevelWarn = this.generateWarner();

          if (warn || fieldLevelWarn) {
            var initialRender = nextProps === undefined;
            var fieldWarnerKeys = Object.keys(this.getWarners());
            var validateParams = {
              values: values,
              nextProps: nextProps,
              props: this.props,
              initialRender: initialRender,
              lastFieldValidatorKeys: this.lastFieldWarnerKeys,
              fieldValidatorKeys: fieldWarnerKeys,
              structure: structure$1
            };

            if (shouldWarn(validateParams)) {
              var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

              var _merge3 = _merge(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                  _warning = _merge3._warning,
                  nextSyncWarnings = objectWithoutPropertiesLoose(_merge3, ["_warning"]);

              this.lastFieldWarnerKeys = fieldWarnerKeys;
              this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
            }
          }
        };

        _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
          if (!isHotReloading()) {
            this.initIfNeeded();
            this.validateIfNeeded();
            this.warnIfNeeded();
          }

          browser(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
        };

        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
          this.initIfNeeded(nextProps);
          this.validateIfNeeded(nextProps);
          this.warnIfNeeded(nextProps);
          this.clearSubmitPromiseIfNeeded(nextProps);
          this.submitIfNeeded(nextProps);
          var onChange = nextProps.onChange,
              values = nextProps.values,
              dispatch = nextProps.dispatch;

          if (onChange && !deepEqual(values, this.props.values)) {
            onChange(values, dispatch, nextProps, this.props.values);
          }
        };

        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
          var _this2 = this;

          if (!this.props.pure) return true;
          var _config$immutableProp = config.immutableProps,
              immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp; // if we have children, we MUST update in React 16
          // https://twitter.com/erikras/status/915866544558788608

          return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
            // useful to debug rerenders
            // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
            //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
            // }
            if (~immutableProps.indexOf(prop)) {
              return _this2.props[prop] !== nextProps[prop];
            }

            return !~propsToNotUpdateFor$1.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
          }));
        };

        _proto.componentDidMount = function componentDidMount() {
          if (!isHotReloading()) {
            this.initIfNeeded(this.props);
            this.validateIfNeeded();
            this.warnIfNeeded();
          }

          browser(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          var _this$props11 = this.props,
              destroyOnUnmount = _this$props11.destroyOnUnmount,
              destroy = _this$props11.destroy;

          if (destroyOnUnmount && !isHotReloading()) {
            this.destroyed = true;
            destroy();
          }
        };

        _proto.render = function render() {
          var _ref,
              _this3 = this;

          // remove some redux-form config-only props

          /* eslint-disable no-unused-vars */
          var _this$props12 = this.props,
              anyTouched = _this$props12.anyTouched,
              array = _this$props12.array,
              arrayInsert = _this$props12.arrayInsert,
              arrayMove = _this$props12.arrayMove,
              arrayPop = _this$props12.arrayPop,
              arrayPush = _this$props12.arrayPush,
              arrayRemove = _this$props12.arrayRemove,
              arrayRemoveAll = _this$props12.arrayRemoveAll,
              arrayShift = _this$props12.arrayShift,
              arraySplice = _this$props12.arraySplice,
              arraySwap = _this$props12.arraySwap,
              arrayUnshift = _this$props12.arrayUnshift,
              asyncErrors = _this$props12.asyncErrors,
              asyncValidate = _this$props12.asyncValidate,
              asyncValidating = _this$props12.asyncValidating,
              blur = _this$props12.blur,
              change = _this$props12.change,
              clearSubmit = _this$props12.clearSubmit,
              destroy = _this$props12.destroy,
              destroyOnUnmount = _this$props12.destroyOnUnmount,
              forceUnregisterOnUnmount = _this$props12.forceUnregisterOnUnmount,
              dirty = _this$props12.dirty,
              dispatch = _this$props12.dispatch,
              enableReinitialize = _this$props12.enableReinitialize,
              error = _this$props12.error,
              focus = _this$props12.focus,
              form = _this$props12.form,
              getFormState = _this$props12.getFormState,
              immutableProps = _this$props12.immutableProps,
              initialize = _this$props12.initialize,
              initialized = _this$props12.initialized,
              initialValues = _this$props12.initialValues,
              invalid = _this$props12.invalid,
              keepDirtyOnReinitialize = _this$props12.keepDirtyOnReinitialize,
              keepValues = _this$props12.keepValues,
              updateUnregisteredFields = _this$props12.updateUnregisteredFields,
              pristine = _this$props12.pristine,
              propNamespace = _this$props12.propNamespace,
              registeredFields = _this$props12.registeredFields,
              registerField = _this$props12.registerField,
              reset = _this$props12.reset,
              resetSection = _this$props12.resetSection,
              setSubmitFailed = _this$props12.setSubmitFailed,
              setSubmitSucceeded = _this$props12.setSubmitSucceeded,
              shouldAsyncValidate = _this$props12.shouldAsyncValidate,
              shouldValidate = _this$props12.shouldValidate,
              shouldError = _this$props12.shouldError,
              shouldWarn = _this$props12.shouldWarn,
              startAsyncValidation = _this$props12.startAsyncValidation,
              startSubmit = _this$props12.startSubmit,
              stopAsyncValidation = _this$props12.stopAsyncValidation,
              stopSubmit = _this$props12.stopSubmit,
              submitAsSideEffect = _this$props12.submitAsSideEffect,
              submitting = _this$props12.submitting,
              submitFailed = _this$props12.submitFailed,
              submitSucceeded = _this$props12.submitSucceeded,
              touch = _this$props12.touch,
              touchOnBlur = _this$props12.touchOnBlur,
              touchOnChange = _this$props12.touchOnChange,
              persistentSubmitErrors = _this$props12.persistentSubmitErrors,
              syncErrors = _this$props12.syncErrors,
              syncWarnings = _this$props12.syncWarnings,
              unregisterField = _this$props12.unregisterField,
              untouch = _this$props12.untouch,
              updateSyncErrors = _this$props12.updateSyncErrors,
              updateSyncWarnings = _this$props12.updateSyncWarnings,
              valid = _this$props12.valid,
              validExceptSubmit = _this$props12.validExceptSubmit,
              values = _this$props12.values,
              warning = _this$props12.warning,
              rest = objectWithoutPropertiesLoose(_this$props12, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitAsSideEffect", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]);
          /* eslint-enable no-unused-vars */


          var reduxFormProps = _extends_1({
            array: array,
            anyTouched: anyTouched,
            asyncValidate: this.asyncValidate,
            asyncValidating: asyncValidating
          }, bindActionCreators({
            blur: blur,
            change: change
          }, dispatch), {
            clearSubmit: clearSubmit,
            destroy: destroy,
            dirty: dirty,
            dispatch: dispatch,
            error: error,
            form: form,
            handleSubmit: this.submit,
            initialize: initialize,
            initialized: initialized,
            initialValues: initialValues,
            invalid: invalid,
            pristine: pristine,
            reset: reset,
            resetSection: resetSection,
            submitting: submitting,
            submitAsSideEffect: submitAsSideEffect,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            touch: touch,
            untouch: untouch,
            valid: valid,
            warning: warning
          });

          var propsToPass = _extends_1({}, propNamespace ? (_ref = {}, _ref[propNamespace] = reduxFormProps, _ref) : reduxFormProps, {}, rest);

          if (isClassComponent(WrappedComponent)) {
            propsToPass.ref = this.wrapped;
          }

          var _reduxForm = _extends_1({}, this.props, {
            getFormState: function getFormState(state) {
              return getIn(_this3.props.getFormState(state), _this3.props.form);
            },
            asyncValidate: this.asyncValidate,
            getValues: this.getValues,
            sectionPrefix: undefined,
            register: this.register,
            unregister: this.unregister,
            registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
              return _this3.innerOnSubmit = innerOnSubmit;
            }
          });

          return createElement(ReduxFormContext.Provider, {
            value: _reduxForm,
            children: createElement(WrappedComponent, propsToPass)
          });
        };

        return Form;
      }(React__default.Component);

      Form.displayName = "Form(" + getDisplayName(WrappedComponent) + ")";
      Form.WrappedComponent = WrappedComponent;
      Form.propTypes = {
        destroyOnUnmount: PropTypes.bool,
        forceUnregisterOnUnmount: PropTypes.bool,
        form: PropTypes.string.isRequired,
        immutableProps: PropTypes.arrayOf(PropTypes.string),
        initialValues: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        getFormState: PropTypes.func,
        onSubmitFail: PropTypes.func,
        onSubmitSuccess: PropTypes.func,
        propNamespace: PropTypes.string,
        validate: PropTypes.func,
        warn: PropTypes.func,
        touchOnBlur: PropTypes.bool,
        touchOnChange: PropTypes.bool,
        triggerSubmit: PropTypes.bool,
        persistentSubmitErrors: PropTypes.bool,
        registeredFields: PropTypes.any
      };
      var connector = connect(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;
        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
        var initial = initialValues || stateInitial || empty;

        if (!shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || structure.empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || structure.empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        }; // Bind the first parameter on `props.form`


        var boundFormACs = _mapValues(formActions, bindForm);

        var boundArrayACs = _mapValues(arrayActions, bindForm);

        var boundBlur = function boundBlur(field, value) {
          return blur$1(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };

        var boundChange = function boundChange(field, value) {
          return change$1(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };

        var boundFocus = bindForm(focus$1); // Wrap action creators with `dispatch`

        var connectedFormACs = bindActionCreators(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: bindActionCreators(boundArrayACs.arrayInsert, dispatch),
          move: bindActionCreators(boundArrayACs.arrayMove, dispatch),
          pop: bindActionCreators(boundArrayACs.arrayPop, dispatch),
          push: bindActionCreators(boundArrayACs.arrayPush, dispatch),
          remove: bindActionCreators(boundArrayACs.arrayRemove, dispatch),
          removeAll: bindActionCreators(boundArrayACs.arrayRemoveAll, dispatch),
          shift: bindActionCreators(boundArrayACs.arrayShift, dispatch),
          splice: bindActionCreators(boundArrayACs.arraySplice, dispatch),
          swap: bindActionCreators(boundArrayACs.arraySwap, dispatch),
          unshift: bindActionCreators(boundArrayACs.arrayUnshift, dispatch)
        };
        return _extends_1({}, connectedFormACs, {}, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });
      }, undefined, {
        forwardRef: true
      });
      var ConnectedForm = hoistNonReactStatics_cjs(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config; // build outer component to expose instance api

      var ReduxForm =
      /*#__PURE__*/
      function (_React$Component2) {
        inheritsLoose(ReduxForm, _React$Component2);

        function ReduxForm() {
          var _this4;

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          _this4 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
          _this4.ref = React__default.createRef();
          return _this4;
        }

        var _proto2 = ReduxForm.prototype;

        _proto2.submit = function submit() {
          return this.ref.current && this.ref.current.submit();
        };

        _proto2.reset = function reset() {
          if (this.ref) {
            this.ref.current.reset();
          }
        };

        _proto2.render = function render() {
          var _this$props13 = this.props,
              initialValues = _this$props13.initialValues,
              rest = objectWithoutPropertiesLoose(_this$props13, ["initialValues"]);

          return createElement(ConnectedForm, _extends_1({}, rest, {
            ref: this.ref,
            // convert initialValues if need to
            initialValues: fromJS(initialValues)
          }));
        };

        createClass(ReduxForm, [{
          key: "valid",
          get: function get() {
            return !!(this.ref.current && this.ref.current.isValid());
          }
        }, {
          key: "invalid",
          get: function get() {
            return !this.valid;
          }
        }, {
          key: "pristine",
          get: function get() {
            return !!(this.ref.current && this.ref.current.isPristine());
          }
        }, {
          key: "dirty",
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: "values",
          get: function get() {
            return this.ref.current ? this.ref.current.getValues() : empty;
          }
        }, {
          key: "fieldList",
          get: function get() {
            // mainly provided for testing
            return this.ref.current ? this.ref.current.getFieldList() : [];
          }
        }, {
          key: "wrappedInstance",
          get: function get() {
            // for testing
            return this.ref.current && this.ref.current.wrapped.current;
          }
        }]);

        return ReduxForm;
      }(React__default.Component);

      polyfill(ReduxForm);
      var WithContext = hoistNonReactStatics_cjs(withReduxForm(ReduxForm), WrappedComponent);
      WithContext.defaultProps = config;
      return WithContext;
    };
  };
};

var reduxForm = createReduxForm(structure);

function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;
  return function (shouldDelete) {
    if (shouldDelete === void 0) {
      shouldDelete = shouldDeleteDefault;
    }

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = _toPath(path);

        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');

      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);

        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);

          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }

      return result;
    };

    return deleteInWithCleanUp;
  };
}

var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (/^values/.test(path)) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > prefix.length && action.type.substring(0, prefix.length) === prefix;
};

function createReducer$1(structure$1) {
  var _behaviors;

  var deepEqual = structure$1.deepEqual,
      empty = structure$1.empty,
      forEach = structure$1.forEach,
      getIn = structure$1.getIn,
      setIn = structure$1.setIn,
      deleteIn = structure$1.deleteIn,
      fromJS = structure$1.fromJS,
      keys = structure$1.keys,
      size = structure$1.size,
      some = structure$1.some,
      splice = structure$1.splice;
  var deleteInWithCleanUp = createDeleteInWithCleanUp(structure$1)(shouldDelete);
  var plainDeleteInWithCleanUp = createDeleteInWithCleanUp(structure)(shouldDelete);

  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + "." + field);
    return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
  };

  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = structure.getIn(slice, field);
    return existing || force ? setIn(state, key, structure.setIn(slice, field, structure.splice(existing, index, removeNum, value))) : state;
  };

  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];

  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _behaviors[ARRAY_INSERT] = function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;
    return arraySplice(state, field, index, 0, payload);
  }, _behaviors[ARRAY_MOVE] = function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    var result = state;

    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + "." + field;

        if (getIn(result, path)) {
          var value = getIn(result, path + "[" + from + "]");
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove

          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }

    return result;
  }, _behaviors[ARRAY_POP] = function (state, _ref4) {
    var field = _ref4.meta.field;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }, _behaviors[ARRAY_PUSH] = function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }, _behaviors[ARRAY_REMOVE] = function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;
    return arraySplice(state, field, index, 1);
  }, _behaviors[ARRAY_REMOVE_ALL] = function (state, _ref7) {
    var field = _ref7.meta.field;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }, _behaviors[ARRAY_SHIFT] = function (state, _ref8) {
    var field = _ref8.meta.field;
    return arraySplice(state, field, 0, 1);
  }, _behaviors[ARRAY_SPLICE] = function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;
    return arraySplice(state, field, index, removeNum, payload);
  }, _behaviors[ARRAY_SWAP] = function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;
    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
      var valueB = getIn(result, key + "." + field + "[" + indexB + "]");

      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
        result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
      }
    });
    return result;
  }, _behaviors[ARRAY_UNSHIFT] = function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;
    return arraySplice(state, field, 0, 0, payload);
  }, _behaviors[AUTOFILL] = function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;
    var result = state;
    result = deleteInWithCleanUp(result, "asyncErrors." + field);
    result = deleteInWithCleanUp(result, "submitErrors." + field);
    result = setIn(result, "fields." + field + ".autofilled", true);
    result = setIn(result, "values." + field, payload);
    return result;
  }, _behaviors[BLUR] = function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;
    var result = state;
    var initial = getIn(result, "initial." + field);

    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, "values." + field);
    } else if (payload !== undefined) {
      result = setIn(result, "values." + field, payload);
    }

    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }

    result = deleteIn(result, "fields." + field + ".active");

    if (touch) {
      result = setIn(result, "fields." + field + ".touched", true);
      result = setIn(result, 'anyTouched', true);
    }

    return result;
  }, _behaviors[CHANGE] = function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;
    var result = state;
    var initial = getIn(result, "initial." + field);

    if (initial === undefined && payload === '' || payload === undefined) {
      result = deleteInWithCleanUp(result, "values." + field);
    } else if (_isFunction(payload)) {
      var fieldCurrentValue = getIn(state, "values." + field);
      result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
    } else {
      result = setIn(result, "values." + field, payload);
    }

    result = deleteInWithCleanUp(result, "asyncErrors." + field);

    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, "submitErrors." + field);
    }

    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");

    if (touch) {
      result = setIn(result, "fields." + field + ".touched", true);
      result = setIn(result, 'anyTouched', true);
    }

    return result;
  }, _behaviors[CLEAR_SUBMIT] = function (state) {
    return deleteIn(state, 'triggerSubmit');
  }, _behaviors[CLEAR_SUBMIT_ERRORS] = function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }, _behaviors[CLEAR_ASYNC_ERROR] = function (state, _ref15) {
    var field = _ref15.meta.field;
    return deleteIn(state, "asyncErrors." + field);
  }, _behaviors[CLEAR_FIELDS] = function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;
    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, "asyncErrors." + field);

      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, "submitErrors." + field);
      }

      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");

      if (!keepTouched) {
        result = deleteIn(result, "fields." + field + ".touched");
      }

      var values = getIn(state, "initial." + field);
      result = values ? setIn(result, "values." + field, values) : deleteInWithCleanUp(result, "values." + field);
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }, _behaviors[FOCUS] = function (state, _ref17) {
    var field = _ref17.meta.field;
    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, "fields." + previouslyActive + ".active");
    result = setIn(result, "fields." + field + ".visited", true);
    result = setIn(result, "fields." + field + ".active", true);
    result = setIn(result, 'active', field);
    return result;
  }, _behaviors[INITIALIZE] = function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;
    var mapData = fromJS(payload);
    var result = empty; // clean all field state
    // persist old warnings, they will get recalculated if the new form values are different from the old values

    var warning = getIn(state, 'warning');

    if (warning) {
      result = setIn(result, 'warning', warning);
    }

    var syncWarnings = getIn(state, 'syncWarnings');

    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } // persist old errors, they will get recalculated if the new form values are different from the old values


    var error = getIn(state, 'error');

    if (error) {
      result = setIn(result, 'error', error);
    }

    var syncErrors = getIn(state, 'syncErrors');

    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');

    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');
    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)

            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);

          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);
        newValues = setIn(newValues, name, previousValue);
      });
      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);
        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }

    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }, _behaviors[REGISTER_FIELD] = function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;
    var key = "registeredFields['" + name + "']";
    var field = getIn(state, key);

    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({
        name: name,
        type: type,
        count: 1
      });
    }

    return setIn(state, key, field);
  }, _behaviors[RESET] = function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');

    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var values = getIn(state, 'initial');

    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }

    return result;
  }, _behaviors[RESET_SECTION] = function (state, _ref20) {
    var sections = _ref20.meta.sections;
    var result = state;
    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, "asyncErrors." + section);
      result = deleteInWithCleanUp(result, "submitErrors." + section);
      result = deleteInWithCleanUp(result, "fields." + section);
      var values = getIn(state, "initial." + section);
      result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }, _behaviors[SUBMIT] = function (state) {
    return setIn(state, 'triggerSubmit', true);
  }, _behaviors[START_ASYNC_VALIDATION] = function (state, _ref21) {
    var field = _ref21.meta.field;
    return setIn(state, 'asyncValidating', field || true);
  }, _behaviors[START_SUBMIT] = function (state) {
    return setIn(state, 'submitting', true);
  }, _behaviors[STOP_ASYNC_VALIDATION] = function (state, _ref22) {
    var payload = _ref22.payload;
    var result = state;
    result = deleteIn(result, 'asyncValidating');

    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = objectWithoutPropertiesLoose(payload, ["_error"]);

      if (_error) {
        result = setIn(result, 'error', _error);
      }

      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }

    return result;
  }, _behaviors[STOP_SUBMIT] = function (state, _ref23) {
    var payload = _ref23.payload;
    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');

    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = objectWithoutPropertiesLoose(payload, ["_error"]);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }

      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }

      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }

    return result;
  }, _behaviors[SET_SUBMIT_FAILED] = function (state, _ref24) {
    var fields = _ref24.meta.fields;
    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, "fields." + field + ".touched", true);
    });

    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }

    return result;
  }, _behaviors[SET_SUBMIT_SUCCEEDED] = function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }, _behaviors[TOUCH] = function (state, _ref25) {
    var fields = _ref25.meta.fields;
    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, "fields." + field + ".touched", true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }, _behaviors[UNREGISTER_FIELD] = function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;
    var result = state;
    var key = "registeredFields['" + name + "']";
    var field = getIn(result, key);

    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;

    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);

      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }

      var syncErrors = getIn(result, 'syncErrors');

      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);

        if (structure.deepEqual(syncErrors, structure.empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }

      var syncWarnings = getIn(result, 'syncWarnings');

      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);

        if (structure.deepEqual(syncWarnings, structure.empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }

      result = deleteInWithCleanUp(result, "submitErrors." + name);
      result = deleteInWithCleanUp(result, "asyncErrors." + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }

    return result;
  }, _behaviors[UNTOUCH] = function (state, _ref27) {
    var fields = _ref27.meta.fields;
    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, "fields." + field + ".touched");
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }, _behaviors[UPDATE_SYNC_ERRORS] = function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;
    var result = state;

    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }

    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }

    return result;
  }, _behaviors[UPDATE_SYNC_WARNINGS] = function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;
    var result = state;

    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }

    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }

    return result;
  }, _behaviors);

  var reducer = function reducer(state, action) {
    if (state === void 0) {
      state = empty;
    }

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function (state, action) {
      if (state === void 0) {
        state = empty;
      }

      if (action === void 0) {
        action = {
          type: 'NONE'
        };
      }

      var form = action && action.meta && action.meta.form;

      if (!form || !isReduxFormAction(action)) {
        return state;
      }

      if (action.type === DESTROY && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }

      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };
  /**
   * Adds additional functionality to the reducer
   */


  function decorate(target) {
    target.plugin = function (reducers, config) {
      var _this = this;

      if (config === void 0) {
        config = {};
      }

      // use 'function' keyword to enable 'this'
      return decorate(function (state, action) {
        if (state === void 0) {
          state = empty;
        }

        if (action === void 0) {
          action = {
            type: 'NONE'
          };
        }

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer


        var form = action && action.meta && action.meta.form;

        if (form && !config.receiveAllFormActions) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

var formReducer = createReducer$1(structure);

var reset$1 = actions.reset;
var submit$1 = actions.submit;

var isEnum = _objectPie.f;
var _objectToArray = function (isEntries) {
  return function (it) {
    var O = _toIobject(it);
    var keys = _objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

// https://github.com/tc39/proposal-object-values-entries

var $values = _objectToArray(false);

_export(_export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

var values = _core.Object.values;

var values$1 = createCommonjsModule(function (module) {
module.exports = { "default": values, __esModule: true };
});

var _Object$values = unwrapExports(values$1);

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys$1 = _core.Object.keys;

var keys$2 = createCommonjsModule(function (module) {
module.exports = { "default": keys$1, __esModule: true };
});

var _Object$keys = unwrapExports(keys$2);

const { createReducer: createReducer$2 } = helpers;

const PICK_START = 'PICK_START';
const PICK_END = 'PICK_END';
const RETRY_REQUEST = 'RETRY_REQUEST';
const RETRY_DONE = 'RETRY_DONE';
const ABORT_REQUEST = 'ABORT_REQUEST';
const UPLOAD_REQUEST = 'UPLOAD_REQUEST';
const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
const UPLOAD_COMPLETE = 'UPLOAD_COMPLETE';
const CLEAR_FILEPICKER_DATA = 'CLEAR_FILEPICKER_DATA';

const namespace$1 = 'filePicker';

const defaultPickerState = {
  open: false,
  state: 'selecting', // selecting | uploading | complete
  progressPercentByFileKey: {},
  success: false,
  error: false,
  warning: false,
  uploadResult: null
};

const defaultState$1 = {
  // populated like:
  // [pickerId]: { ...defaultPickerState }
};

var filePickerReducer = createReducer$2(defaultState$1, {
  [PICK_START](state, {
    meta: { id }
  }) {
    return {
      [id]: _extends$1({}, defaultPickerState, {
        open: true,
        state: 'selecting'
      })
    };
  },
  [PICK_END](state, {
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        open: false
      })
    });
  },
  [CLEAR_FILEPICKER_DATA](state, {
    meta: { id }
  }) {
    return update(state, {
      $unset: [id]
    });
  },
  [ABORT_REQUEST](state, {
    meta: { id, fileKey }
  }) {
    let newProgressPercentByFileKey = _get(state, [id, 'progressPercentByFileKey'], {});
    if (fileKey) {
      newProgressPercentByFileKey = update(newProgressPercentByFileKey, {
        [fileKey]: {
          aborted: { $set: 'aborted' }
        }
      });
    } else {
      _Object$keys(_get(state, [id, 'progressPercentByFileKey'], {})).forEach(fileKey => {
        newProgressPercentByFileKey = update(newProgressPercentByFileKey, {
          [fileKey]: {
            aborted: { $set: 'aborted' }
          }
        });
      });
    }
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        progressPercentByFileKey: newProgressPercentByFileKey
      })
    });
  },
  [RETRY_REQUEST](state, {
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        state: 'uploading',
        progressPercentByFileKey: {},
        success: null,
        error: null,
        warning: null
      })
    });
  },
  [RETRY_DONE](state, {
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        state: 'complete'
      })
    });
  },
  [UPLOAD_REQUEST](state, {
    meta: { id }
  }) {
    // todo: status message
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        state: 'uploading',
        progressPercentByFileKey: {},
        success: null,
        error: null,
        warning: null,
        uploadResult: null
      })
    });
  },
  [UPLOAD_PROGRESS](state, {
    payload,
    meta: { fileKey, id }
  }) {
    // todo: status message
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        progressPercentByFileKey: _extends$1({}, state[id].progressPercentByFileKey, {
          [fileKey]: _extends$1({}, state[id].progressPercentByFileKey[fileKey], payload)
        })
      })
    });
  },
  [UPLOAD_COMPLETE](state, {
    payload,
    meta: { warning, error, id }
  }) {
    const errorMessage = _get(error, 'message', error); // Error or string
    // Extract failed files to be reuploaded
    const failedFiles = _isArray$1(payload) ? payload.filter(result => result.error).map(result => result.file) : [];
    // Combine existing uploadResult if any
    const prevUploadResult = (_get(state, [id, 'uploadResult']) || []).filter(result => !result.error);
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        success: !(warning || error) || null,
        error: error ? errorMessage : null,
        warning: warning || null,
        state: 'complete',
        uploadResult: prevUploadResult.concat(payload),
        failedFiles
      })
    });
  }
});

const local$1 = state => state[namespace$1];

const pick = id => ({
  type: PICK_START,
  meta: { id }
});

const endPick = id => ({
  type: PICK_END,
  meta: { id }
});

const retryRequest = (id, callback) => ({
  type: RETRY_REQUEST,
  payload: { callback },
  meta: { id }
});

const abortRequest = (id, fileKey) => ({
  type: ABORT_REQUEST,
  meta: { id, fileKey }
});

const retryDone = (id, callback) => ({
  type: RETRY_DONE,
  payload: { callback },
  meta: { id }
});

const uploadRequest = (id, files, callback) => ({
  type: UPLOAD_REQUEST,
  payload: { files, callback },
  meta: { id }
});

const uploadProgress = (id, fileKey, data) => ({
  type: UPLOAD_PROGRESS,
  payload: _extends$1({}, data, {
    percent: _clamp(Math.round(data.percent), 100)
  }),
  meta: { fileKey, id }
});

const uploadComplete = (id, result, { warning, error }) => ({
  type: UPLOAD_COMPLETE,
  payload: result,
  meta: { warning, error, id }
});

const isOpen = (state, id) => _get(local$1(state), [id, 'open']);
const state = (state, id) => _get(local$1(state), [id, 'state'], 'selecting');

// Keep this in case we want to go back to using mean percentage progresses
const progressPercent = (state, id) => {
  const currentProgress = _get(local$1(state), [id, 'progressPercentByFileKey']);
  if (!currentProgress) {
    return 0;
  }

  const meanProgress = _mean(_Object$values(currentProgress));
  const rounded = Math.round(meanProgress);
  return _isNaN(rounded) ? 0 : rounded;
};
const percentByFiles = (state, id) => {
  const currentFiles = _get(local$1(state), [id, 'progressPercentByFileKey'], {});
  return _Object$keys(currentFiles).map(key => {
    const value = currentFiles[key];
    return {
      key,
      value
    };
  });
};
const failedFiles = (state, id) => {
  const failedFiles = _get(local$1(state), [id, 'failedFiles'], []);
  return failedFiles;
};
const uploadResult = (state, id) => _get(local$1(state), [id, 'uploadResult']);
const didSucceed = (state, id) => !!_get(local$1(state), [id, 'success']);
const didError = (state, id) => !!_get(local$1(state), [id, 'error']);
const didWarn = (state, id) => !!_get(local$1(state), [id, 'warning']);
// todo: status message for normal cases
const statusMessage = (state, id) => _get(local$1(state), [id, 'warning']) || _get(local$1(state), [id, 'error']) || '';

var index = /*#__PURE__*/Object.freeze({
	PICK_START: PICK_START,
	PICK_END: PICK_END,
	RETRY_REQUEST: RETRY_REQUEST,
	RETRY_DONE: RETRY_DONE,
	ABORT_REQUEST: ABORT_REQUEST,
	UPLOAD_REQUEST: UPLOAD_REQUEST,
	UPLOAD_PROGRESS: UPLOAD_PROGRESS,
	UPLOAD_COMPLETE: UPLOAD_COMPLETE,
	CLEAR_FILEPICKER_DATA: CLEAR_FILEPICKER_DATA,
	namespace: namespace$1,
	'default': filePickerReducer,
	pick: pick,
	endPick: endPick,
	retryRequest: retryRequest,
	abortRequest: abortRequest,
	retryDone: retryDone,
	uploadRequest: uploadRequest,
	uploadProgress: uploadProgress,
	uploadComplete: uploadComplete,
	isOpen: isOpen,
	state: state,
	progressPercent: progressPercent,
	percentByFiles: percentByFiles,
	failedFiles: failedFiles,
	uploadResult: uploadResult,
	didSucceed: didSucceed,
	didError: didError,
	didWarn: didWarn,
	statusMessage: statusMessage
});

const { createReducer: createReducer$3, fetchGraphQLApi } = helpers;
const { selectSessionToken, selectOAuthToken } = modules.auth;
const { getConfig } = modules.config;

const namespace$2 = 'folderSelectionDialog';
const FETCH_ROOT_FOLDER = `vtn/${namespace$2}/FETCH_ROOT_FOLDER`;
const SELECTED_FOLDER = `vtn/${namespace$2}/SELECTED_FOLDER`;
const FETCH_SUB_FOLDERS = `vtn/${namespace$2}/FETCH_SUB_FOLDERS`;
const LOADING = `vtn/${namespace$2}/LOADING`;
const NEW_FOLDER = `vtn/${namespace$2}/NEW_FOLDER`;

const defaultState$2 = {
  selectedFolder: {},
  subFolderList: {},
  rootFolder: {},
  loading: false,
  newFolder: {
    loading: false,
    error: false,
    errorMessage: '',
    folder: null
  }
};

const reducer$1 = createReducer$3(defaultState$2, {
  [FETCH_ROOT_FOLDER](state, action) {
    const folder = _get(action, 'payload');
    return _extends$1({}, state, {
      rootFolder: folder
    });
  },

  [SELECTED_FOLDER](state, action) {
    const selected = _get(action, 'payload');
    return _extends$1({}, state, {
      selectedFolder: selected
    });
  },

  [FETCH_SUB_FOLDERS](state, action) {
    let folders = _get(action, 'payload');
    let previousFolders = _get(state, 'subFolderList');
    let newSubfolderList = _extends$1({}, previousFolders, folders);
    return _extends$1({}, state, {
      subFolderList: newSubfolderList
    });
  },

  [LOADING](state, action) {
    let loading = _get(action, 'payload');
    return _extends$1({}, state, {
      loading: loading
    });
  },

  [NEW_FOLDER](state, action) {
    let updatedInfo = _get(action, 'payload');
    let previous = _get(state, 'newFolder');
    let folderInfo = _extends$1({}, previous, updatedInfo);
    return _extends$1({}, state, {
      newFolder: folderInfo
    });
  }
});

const { createReducer: createReducer$4 } = helpers;

const namespace$3 = 'dataPicker';
const PICK_START$1 = `${namespace$3}_PICK_START`;
const ON_PICK = `${namespace$3}_ON_PICK`;
const PICK_END$1 = `${namespace$3}_PICK_END`;
const INIT_PICKER_TYPE = `${namespace$3}_INIT_PICKER_TYPE`;
const INIT_FOLDER = `${namespace$3}_INIT_FOLDER`;
const INIT_UPLOAD = `${namespace$3}_INIT_UPLOAD`;
const SET_PICKER_TYPE = `${namespace$3}_SET_PICKER_TYPE`;
const FETCH_PAGE = `${namespace$3}_FETCH_PAGE`;
const ERRORED_PAGE = `${namespace$3}_ERRORED_PAGE`;
const LOADED_PAGE = `${namespace$3}_LOADED_PAGE`;
const SELECT_NODE = `${namespace$3}_SELECT_NODE`;
const SELECT_CRUMB = `${namespace$3}_SELECT_CRUMB`;
const UPLOAD_TO_TDO = `${namespace$3}_UPLOAD_TO_TDO`;

const RETRY_REQUEST$1 = `${namespace$3}_RETRY_REQUEST`;
const RETRY_DONE$1 = `${namespace$3}_RETRY_DONE`;

const SET_SEARCH_VALUE = `${namespace$3}_SET_SEARCH_VALUE`;
const CLEAR_SEARCH = `${namespace$3}_CLEAR_SEARCH`;

const ITEM_PICK_PROPS = ['id', 'type', 'name', 'createdDateTime', 'modifiedDateTime', 'startDateTime', 'stopDateTime', 'primaryAsset', 'streams'];

const defaultState$3 = {
  itemData: {},
  searchData: {}
};

var dataPickerReducer = createReducer$4(defaultState$3, {
  [PICK_START$1](state, {
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        open: true
      })
    });
  },
  [ON_PICK](state, {
    meta: { id },
    payload
  }) {
    return state;
  },
  [PICK_END$1](state, {
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        open: false
      })
    });
  },
  [INIT_PICKER_TYPE](state, {
    payload,
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], payload, {
        searchValue: ''
      })
    });
  },
  [INIT_FOLDER](state, {
    payload,
    meta: { id }
  }) {
    return _extends$1({}, state, {
      itemData: _extends$1({}, state.itemData, payload),
      [id]: _extends$1({}, state[id], {
        folderData: _extends$1({}, state[id].folderData, {
          currentPath: []
        })
      })
    });
  },
  [INIT_UPLOAD](state, { meta: { id } }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        uploadData: {}
      })
    });
  },
  [UPLOAD_TO_TDO](state, {
    meta: { id },
    payload
  }) {
    return state;
  },
  [SET_PICKER_TYPE](state, {
    payload,
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        currentPickerType: payload
      })
    });
  },
  [FETCH_PAGE](state, { meta: { id } }) {
    // Dive into the tree structure and update the loading flag for that nodeItem
    const pickerType = _get(state, [id, 'currentPickerType']);
    const currentTypeInitialized = _get(state, [id, `${pickerType}Data`]);
    if (!id || !currentTypeInitialized) {
      return state;
    }

    const {
      currentNodeId,
      currentNodeType
    } = getCurrentIdAndType(state, id);
    const currentNodeKey = `${currentNodeType}:${currentNodeId}`;

    return update(state, {
      itemData: {
        [currentNodeKey]: {
          isLoading: { $set: true }
        }
      }
    });
  },
  [ERRORED_PAGE](state, {
    meta: { id },
    payload
  }) {
    const {
      currentNodeId,
      currentNodeType
    } = getCurrentIdAndType(state, id);

    if (currentNodeId && currentNodeType && payload) {
      return update(state, {
        itemData: {
          [`${currentNodeType}:${currentNodeId}`]: {
            error: { $set: payload },
            isLoading: { $set: false }
          }
        }
      });
    }
    return state;
  },
  [LOADED_PAGE](state, {
    payload: {
      itemData = {},
      nodeIds = [],
      leafIds = [],
      nodeOffset = 0,
      leafOffset = 0
    },
    meta: { id }
  }) {
    const pickerType = _get(state, [id, 'currentPickerType']);

    if (!id || !_get(state, [id, `${pickerType}Data`])) {
      return state;
    }

    const {
      currentNodeId,
      currentNodeType
    } = getCurrentIdAndType(state, id);
    const itemDataSetter = _Object$keys(itemData).reduce((acc, key) => {
      acc[key] = { $set: itemData[key] };
      return acc;
    }, {});
    itemDataSetter[`${currentNodeType}:${currentNodeId}`] = {
      nodeIds: { $push: nodeIds },
      leafIds: { $push: leafIds },
      nodeOffset: { $set: nodeOffset },
      leafOffset: { $set: leafOffset },
      isLoading: { $set: false },
      isLoaded: { $set: true }
    };
    const newState = update(state, {
      itemData: itemDataSetter
    });

    return newState;
  },
  [SELECT_NODE](state, {
    meta: { id },
    payload
  }) {
    let newState = state;
    if (id && _isArray$1(payload)) {
      const pickerType = _get(state, [id, 'currentPickerType']);
      newState = update(newState, {
        [id]: {
          [`${pickerType}Data`]: {
            currentPath: { $push: payload }
          }
        }
      });
    }
    return newState;
  },
  [SELECT_CRUMB](state, {
    meta: { id },
    payload
  }) {
    const pickerType = _get(state, [id, 'currentPickerType']);
    const currentPath = _get(state, [id, `${pickerType}Data`, 'currentPath'], []);
    let newState = state;
    if (payload < currentPath.length) {
      const newPath = currentPath.slice(0, payload);
      newState = update(newState, {
        [id]: {
          [`${pickerType}Data`]: {
            currentPath: { $set: newPath }
          }
        }
      });
    }
    return newState;
  },
  [SET_SEARCH_VALUE](state, {
    meta: { id },
    payload
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        searchValue: payload
      }),
      searchData: _extends$1({}, state.searchData, {
        [payload]: _extends$1({}, state.searchData[payload], {
          results: [..._get(state, ['searchData', payload, 'results'], [])],
          offset: _get(state, ['searchData', payload, 'offset'], 0),
          isLoading: false
        })
      })
    });
  },
  [CLEAR_SEARCH](state, {
    meta: { id }
  }) {
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        searchValue: ''
      })
    });
  }
});

// Gets the variables used to map to itemData
function getCurrentIdAndType(state, id) {
  const pickerType = _get(state, [id, 'currentPickerType']);
  let currentNodeType = pickerType,
      currentNodeId = 'root';
  const currentPath = _get(state, [id, `${pickerType}Data`, 'currentPath'], []);
  if (currentPath.length) {
    const curDir = currentPath.slice(-1)[0];
    currentNodeId = curDir.id;
    currentNodeType = curDir.type;
  }
  return {
    currentNodeId,
    currentNodeType
  };
}

const local$2 = state => state[namespace$3];

const isOpen$1 = (state, id) => _get(local$2(state), [id, 'open']);
const availablePickerTypes = (state, id) => _get(local$2(state), [id, 'availablePickerTypes'], []);
const currentPickerType = (state, id) => _get(local$2(state), [id, 'currentPickerType']);
const searchValue = (state, id) => _get(local$2(state), [id, 'searchValue'], '');

const getItemByTypeAndId = state => (type, itemId) => {
  const item = _get(local$2(state), ['itemData', `${type}:${itemId}`]);
  return item ? _pick(item, ITEM_PICK_PROPS) : undefined;
};

// Map the path array of ids with the container names
const currentPath = (state, id) => {
  const availableTypes = availablePickerTypes(state, id);
  const itemData = _get(local$2(state), 'itemData', {});
  let pickerType = currentPickerType(state, id);

  // Let users see what folder they're uploading to
  if (pickerType === 'upload' && availableTypes.includes('folder')) {
    pickerType = 'folder';
  }

  const curPath = _get(local$2(state), [id, `${pickerType}Data`, 'currentPath'], []);
  // We have the array of ids and need to resolve the node names
  const nodePath = [];
  curPath.forEach(pathObj => {
    const match = itemData[`${pickerType}:${pathObj.id}`];
    if (match) {
      nodePath.push(_pick(match, ['id', 'type', 'name']));
    }
  });
  return nodePath;
};

// Get the directory we're currently in (used to make API calls)
const getCurrentNode = (state, id) => {
  const availableTypes = availablePickerTypes(state, id);
  const itemData = _get(local$2(state), 'itemData', {});
  let pickerType = _get(local$2(state), [id, 'currentPickerType']);

  // Retain current folder to upload to
  if (pickerType === 'upload' && availableTypes.includes('folder')) {
    pickerType = 'folder';
  }

  const curPath = _get(local$2(state), [id, `${pickerType}Data`, 'currentPath'], []);
  let currentNodeType = pickerType,
      currentNodeId = 'root';
  if (curPath.length) {
    const curDir = curPath.slice(-1)[0];
    currentNodeType = curDir.type;
    currentNodeId = curDir.id;
  }
  return itemData[`${currentNodeType}:${currentNodeId}`];
};

// Traverse the current pickerType dataspaces' treeItems and get the current folders contents
const currentDirectoryItems = (state, id) => {
  const pickerType = _get(local$2(state), [id, 'currentPickerType']);
  const searchValue = _get(local$2(state), [id, 'searchValue'], '');
  const itemData = _get(local$2(state), 'itemData', {});
  const searchData = _get(local$2(state), 'searchData', {});
  let currentNodeId = 'root',
      currentNodeType = pickerType;
  const curPath = _get(local$2(state), [id, `${pickerType}Data`, 'currentPath'], []);
  // If searchValue populated, display search results
  if (searchValue) {
    return _get(searchData, [searchValue, 'results'], []);
  }
  if (curPath.length) {
    const curDir = curPath.slice(-1)[0];
    currentNodeId = curDir.id;
    currentNodeType = curDir.type;
  }
  const currentNode = itemData[`${currentNodeType}:${currentNodeId}`];
  const nodeItems = _get(currentNode, 'nodeIds', []);
  const leafItems = _get(currentNode, 'leafIds', []);
  return nodeItems.concat(leafItems);
};

const currentDirectoryLoadingState = (state, id) => {
  const currentNode = getCurrentNode(state, id);
  return _pick(currentNode, ['isLoading', 'isLoaded', 'nodeOffset', 'leafOffset', 'error']);
};

// ACTIONS
const pick$1 = (id, configuration) => ({
  type: PICK_START$1,
  meta: { id },
  payload: configuration
});
const onPick = (id, itemIds, callback) => ({
  type: ON_PICK,
  meta: { id },
  payload: {
    itemIds,
    callback
  }
});
const endPick$1 = id => ({
  type: PICK_END$1,
  meta: { id }
});
const fetchPage = id => ({
  type: FETCH_PAGE,
  meta: { id }
});
const selectNode = (id, items) => ({
  type: SELECT_NODE,
  meta: { id },
  payload: items
});
const selectCrumb = (id, index) => ({
  type: SELECT_CRUMB,
  meta: { id },
  payload: index
});
const setPickerType = (id, pickerType) => ({
  type: SET_PICKER_TYPE,
  meta: { id },
  payload: pickerType
});
const uploadToTDO = (id, files, callback) => ({
  type: UPLOAD_TO_TDO,
  meta: { id },
  payload: {
    files,
    callback
  }
});

// These retry actions are wrappers around filepicker retries
const retryRequest$1 = (id, callback) => ({
  type: RETRY_REQUEST$1,
  payload: { callback },
  meta: { id }
});
const retryDone$1 = (id, callback) => ({
  type: RETRY_DONE$1,
  payload: { callback },
  meta: { id }
});

// Search Actions
const setSearchValue = (id, searchValue) => ({
  type: SET_SEARCH_VALUE,
  meta: { id },
  payload: searchValue
});
const clearSearch = id => ({
  type: CLEAR_SEARCH,
  meta: { id }
});

var index$1 = /*#__PURE__*/Object.freeze({
	namespace: namespace$3,
	PICK_START: PICK_START$1,
	ON_PICK: ON_PICK,
	PICK_END: PICK_END$1,
	INIT_PICKER_TYPE: INIT_PICKER_TYPE,
	INIT_FOLDER: INIT_FOLDER,
	INIT_UPLOAD: INIT_UPLOAD,
	SET_PICKER_TYPE: SET_PICKER_TYPE,
	FETCH_PAGE: FETCH_PAGE,
	ERRORED_PAGE: ERRORED_PAGE,
	LOADED_PAGE: LOADED_PAGE,
	SELECT_NODE: SELECT_NODE,
	SELECT_CRUMB: SELECT_CRUMB,
	UPLOAD_TO_TDO: UPLOAD_TO_TDO,
	RETRY_REQUEST: RETRY_REQUEST$1,
	RETRY_DONE: RETRY_DONE$1,
	SET_SEARCH_VALUE: SET_SEARCH_VALUE,
	CLEAR_SEARCH: CLEAR_SEARCH,
	'default': dataPickerReducer,
	isOpen: isOpen$1,
	availablePickerTypes: availablePickerTypes,
	currentPickerType: currentPickerType,
	searchValue: searchValue,
	getItemByTypeAndId: getItemByTypeAndId,
	currentPath: currentPath,
	getCurrentNode: getCurrentNode,
	currentDirectoryItems: currentDirectoryItems,
	currentDirectoryLoadingState: currentDirectoryLoadingState,
	pick: pick$1,
	onPick: onPick,
	endPick: endPick$1,
	fetchPage: fetchPage,
	selectNode: selectNode,
	selectCrumb: selectCrumb,
	setPickerType: setPickerType,
	uploadToTDO: uploadToTDO,
	retryRequest: retryRequest$1,
	retryDone: retryDone$1,
	setSearchValue: setSearchValue,
	clearSearch: clearSearch
});

var $JSON = _core.JSON || (_core.JSON = { stringify: JSON.stringify });
var stringify = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

var stringify$1 = createCommonjsModule(function (module) {
module.exports = { "default": stringify, __esModule: true };
});

var _JSON$stringify = unwrapExports(stringify$1);

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if (( FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
  _iterators[NAME] = _iterators.Array;
}

var _redefineAll = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide(target, key, src[key]);
  } return target;
};

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

var SPECIES = _wks('species');

var _setSpecies = function (KEY) {
  var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
  if (_descriptors && C && !C[SPECIES]) _objectDp.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var _validateCollection = function (it, TYPE) {
  if (!_isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

var dP$1 = _objectDp.f;









var fastKey = _meta.fastKey;

var SIZE = _descriptors ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

var _collectionStrong = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      _anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = _objectCreate(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
    });
    _redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = _validateCollection(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        _validateCollection(this, NAME);
        var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(_validateCollection(this, NAME), key);
      }
    });
    if (_descriptors) dP$1(C.prototype, 'size', {
      get: function () {
        return _validateCollection(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    _iterDefine(C, NAME, function (iterated, kind) {
      this._t = _validateCollection(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return _iterStep(1);
      }
      // return step by kind
      if (kind == 'keys') return _iterStep(0, entry.k);
      if (kind == 'values') return _iterStep(0, entry.v);
      return _iterStep(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    _setSpecies(NAME);
  }
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var SPECIES$1 = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

var dP$2 = _objectDp.f;
var each = _arrayMethods(0);


var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = _global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!_descriptors || typeof C != 'function' || !(IS_WEAK || proto.forEach && !_fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    _redefineAll(C.prototype, methods);
    _meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      _anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) _forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) _hide(C.prototype, KEY, function (a, b) {
        _anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !_isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP$2(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  _setToStringTag(C, NAME);

  O[NAME] = C;
  _export(_export.G + _export.W + _export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

var SET = 'Set';

// 23.2 Set Objects
var es6_set = _collection(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
  }
}, _collectionStrong);

var _arrayFromIterable = function (iter, ITERATOR) {
  var result = [];
  _forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


var _collectionToJson = function (NAME) {
  return function toJSON() {
    if (_classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return _arrayFromIterable(this);
  };
};

// https://github.com/DavidBruant/Map-Set.prototype.toJSON


_export(_export.P + _export.R, 'Set', { toJSON: _collectionToJson('Set') });

// https://tc39.github.io/proposal-setmap-offrom/


var _setCollectionOf = function (COLLECTION) {
  _export(_export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
_setCollectionOf('Set');

// https://tc39.github.io/proposal-setmap-offrom/





var _setCollectionFrom = function (COLLECTION) {
  _export(_export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    _aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) _aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = _ctx(mapFn, arguments[2], 2);
      _forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      _forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
_setCollectionFrom('Set');

var set = _core.Set;

var set$1 = createCommonjsModule(function (module) {
module.exports = { "default": set, __esModule: true };
});

var _Set = unwrapExports(set$1);

const { createReducer: createReducer$5 } = helpers;
const { engine: engineModule } = modules;

const INITIALIZE_WIDGET = 'vtn/engineSelection/INITIALIZE_WIDGET';

const CHECK_ALL_ENGINES = 'vtn/engineSelection/CHECK_ALL_ENGINES';
const UNCHECK_ALL_ENGINES = 'vtn/engineSelection/UNCHECK_ALL_ENGINES';

const SELECT_ENGINE = 'vtn/engineSelection/SELECT_ENGINE';
const DESELECT_ENGINE = 'vtn/engineSelection/DESELECT_ENGINE';

const CHECK_ENGINE = 'vtn/engineSelection/CHECK_ENGINE';
const UNCHECK_ENGINE = 'vtn/engineSelection/UNCHECK_ENGINE';

const ADD_FILTER = 'vtn/engineSelection/ADD_FILTER';
const REMOVE_FILTER = 'vtn/engineSelection/REMOVE_FILTER';
const CLEAR_ALL_FILTERS = 'vtn/engineSelection/CLEAR_ALL_FILTERS';

const SEARCH = 'vtn/engineSelection/SEARCH';
const CLEAR_SEARCH$1 = 'vtn/engineSelection/CLEAR_SEARCH';

const CHANGE_TAB = 'vtn/engineSelection/CHANGE_TAB';
const TOGGLE_SEARCH = 'vtn/engineSelection/TOGGLE_SEARCH';

const SET_ACTIVE_SIDEBAR_PATH = 'vtn/engineSelection/SET_ACTIVE_SIDEBAR_PATH';

const SET_DESELECTED_ENGINES = 'vtn/engineSelection/SET_DESELECTED_ENGINES';
const SET_ALL_ENGINES_SELECTED = 'vtn/engineSelection/SET_ALL_ENGINES_SELECTED';

const namespace$4 = 'engineSelection';

const defaultFilterState = {
  category: [],
  rating: []
};

const defaultSelectionState = {
  tabState: {
    own: {
      searchQuery: '',
      isSearchOpen: false,
      filters: defaultFilterState
    },
    explore: {
      searchQuery: '',
      isSearchOpen: false,
      filters: defaultFilterState
    }
  },
  orderBy: {},
  selectedEngineIds: [],
  checkedEngineIds: [],
  allEnginesChecked: false,
  currentTab: 'own',
  activeSidebarPath: [],
  deselectedEngineIds: [],
  allEnginesSelected: false
};
const defaultState$4 = {
  // populated like:
  // [pickerId]: { ...defaultPickerState }
};

var engineSelectionReducer = createReducer$5(defaultState$4, {
  [INITIALIZE_WIDGET](state, action) {
    return _extends$1({}, defaultState$4, {
      searchResults: state.searchResults || {},
      [action.meta.id]: _extends$1({}, defaultSelectionState)
    });
  },
  [engineModule.FETCH_ENGINES_SUCCESS](state, action) {
    const id = action.meta.id;
    const resultsPath = pathFor(action.meta.searchQuery, action.meta.filters);
    const normalizedResults = action.payload.results.map(engine => engine.id);
    const newResults = _set({}, resultsPath, normalizedResults);

    /*
    * Check if engines in deselectedEngineIds
    * if so then ignore
    * otherwise add to selected
    */
    const selectedEngineIds = state[id].allEnginesSelected ? _difference(normalizedResults, state[id].deselectedEngineIds) : [];

    return _extends$1({}, state, {
      searchResults: _merge({}, state.searchResults, newResults),
      [id]: _extends$1({}, state[id], {
        selectedEngineIds: [...new _Set([...state[id].selectedEngineIds, ...selectedEngineIds])]
      })
    });
  },
  [CHECK_ALL_ENGINES](state, action) {
    const id = action.meta.id;
    const engineIds = action.payload.engines;

    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        checkedEngineIds: engineIds,
        allEnginesChecked: true
      })
    });
  },
  [UNCHECK_ALL_ENGINES](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [SELECT_ENGINE](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        selectedEngineIds: _union(state[id].selectedEngineIds, action.payload.engineIds),
        deselectedEngineIds: _without(state[id].deselectedEngineIds, ...action.payload.engineIds),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [DESELECT_ENGINE](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        selectedEngineIds: _without(state[id].selectedEngineIds, ...action.payload.engineIds),
        deselectedEngineIds: _union(state[id].deselectedEngineIds, action.payload.engineIds),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [CHECK_ENGINE](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        checkedEngineIds: _union(state[id].checkedEngineIds, [action.payload.engineId])
      })
    });
  },
  [UNCHECK_ENGINE](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        checkedEngineIds: _without(state[id].checkedEngineIds, action.payload.engineId),
        allEnginesChecked: false
      })
    });
  },
  [ADD_FILTER](state, action) {
    const id = action.meta.id;
    const currentTab = state[id].currentTab;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        tabState: _extends$1({}, state[id].tabState, {
          [currentTab]: _extends$1({}, state[id].tabState[currentTab], {
            filters: _extends$1({}, state[id].tabState[currentTab].filters, {
              [action.payload.type]: action.payload.value
            })
          })
        }),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [REMOVE_FILTER](state, action) {
    const id = action.meta.id;
    const currentTab = state[id].currentTab;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        tabState: _extends$1({}, state[id].tabState, {
          [currentTab]: _extends$1({}, state[id].tabState[currentTab], {
            filters: _omit(state[id].tabState[currentTab].filters, action.payload.type)
          })
        }),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [CLEAR_ALL_FILTERS](state, action) {
    const id = action.meta.id;
    const currentTab = state[id].currentTab;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        tabState: _extends$1({}, state[id].tabState, {
          [currentTab]: _extends$1({}, state[id].tabState[currentTab], {
            filters: defaultFilterState
          })
        }),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [SET_ACTIVE_SIDEBAR_PATH](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        activeSidebarPath: [...action.payload.path]
      })
    });
  },
  [SEARCH](state, action) {
    const id = action.meta.id;
    const currentTab = state[id].currentTab;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        tabState: _extends$1({}, state[id].tabState, {
          [currentTab]: _extends$1({}, state[id].tabState[currentTab], {
            searchQuery: action.payload.searchQuery
          })
        }),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [CLEAR_SEARCH$1](state, action) {
    const id = action.meta.id;
    const currentTab = state[id].currentTab;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        tabState: _extends$1({}, state[id].tabState, {
          [currentTab]: _extends$1({}, state[id].tabState[currentTab], {
            searchQuery: '',
            isSearchOpen: false
          })
        }),
        checkedEngineIds: [],
        allEnginesChecked: false
      })
    });
  },
  [CHANGE_TAB](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        currentTab: action.payload.tab,
        activeSidebarPath: []
      })
    });
  },
  [TOGGLE_SEARCH](state, action) {
    const id = action.meta.id;
    const currentTab = state[id].currentTab;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        tabState: _extends$1({}, state[id].tabState, {
          [currentTab]: _extends$1({}, state[id].tabState[currentTab], {
            isSearchOpen: !state[id].tabState[currentTab].isSearchOpen,
            searchQuery: ''
          })
        })
      })
    });
  },
  [SET_DESELECTED_ENGINES](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        deselectedEngineIds: action.payload.deselectedEngineIds
      })
    });
  },
  [SET_ALL_ENGINES_SELECTED](state, action) {
    const id = action.meta.id;
    return _extends$1({}, state, {
      [id]: _extends$1({}, state[id], {
        allEnginesSelected: action.payload.allEnginesSelected
      })
    });
  }
});

function local$3(state) {
  return state[namespace$4];
}

function initializeWidget(id) {
  return {
    type: INITIALIZE_WIDGET,
    meta: { id }
  };
}

function refetchEngines(id) {
  return function action(dispatch, getState) {
    const searchQuery = getSearchQuery(getState(), id);
    const filters = getEngineFilters(getState(), id);
    dispatch(engineModule.fetchEngines({ offset: 0, limit: 1000, owned: false }, searchQuery, filters, {
      status: ['deployed']
    }, id));
  };
}

function searchEngines(id, { name }) {
  return {
    type: SEARCH,
    payload: {
      searchQuery: name
    },
    meta: { id }
  };
}

function addEngineFilter(id, { type, value }) {
  return {
    type: ADD_FILTER,
    payload: {
      type,
      value
    },
    meta: { id }
  };
}

function removeEngineFilter(id, { type, value }) {
  return {
    type: REMOVE_FILTER,
    payload: {
      type,
      value
    },
    meta: { id }
  };
}

function checkAllEngines(id, engines) {
  return {
    type: CHECK_ALL_ENGINES,
    payload: {
      engines
    },
    meta: { id }
  };
}

function uncheckAllEngines(id) {
  return {
    type: UNCHECK_ALL_ENGINES,
    payload: {},
    meta: { id }
  };
}

function selectEngines(id, engineIds) {
  return {
    type: SELECT_ENGINE,
    payload: {
      engineIds
    },
    meta: { id }
  };
}

function deselectEngines(id, engineIds) {
  return {
    type: DESELECT_ENGINE,
    payload: {
      engineIds
    },
    meta: { id }
  };
}

function checkEngine(id, engineId) {
  return {
    type: CHECK_ENGINE,
    payload: {
      engineId
    },
    meta: { id }
  };
}

function uncheckEngine(id, engineId) {
  return {
    type: UNCHECK_ENGINE,
    payload: {
      engineId
    },
    meta: { id }
  };
}

function clearSearch$1(id) {
  return {
    type: CLEAR_SEARCH$1,
    payload: {},
    meta: { id }
  };
}

function clearAllFilters(id) {
  return {
    type: CLEAR_ALL_FILTERS,
    payload: {},
    meta: { id }
  };
}

function changeTab(id, tab) {
  return {
    type: CHANGE_TAB,
    payload: {
      tab
    },
    meta: { id }
  };
}

function toggleSearch(id) {
  return {
    type: TOGGLE_SEARCH,
    payload: {},
    meta: { id }
  };
}

function setDeselectedEngineIds(id, deselectedEngineIds) {
  return {
    type: SET_DESELECTED_ENGINES,
    payload: {
      deselectedEngineIds
    },
    meta: { id }
  };
}

function setAllEnginesSelected(id, allEnginesSelected) {
  return {
    type: SET_ALL_ENGINES_SELECTED,
    payload: {
      allEnginesSelected
    },
    meta: { id }
  };
}

function setActiveSidebarPath(id, path) {
  return {
    type: SET_ACTIVE_SIDEBAR_PATH,
    payload: {
      path
    },
    meta: { id }
  };
}

function pathFor(searchQuery, filters) {
  return [searchQuery, _JSON$stringify(filters)];
}

function getCurrentTab(state, id) {
  return _get(local$3(state), [id, 'currentTab']);
}

function isSearchOpen(state, id) {
  return _get(local$3(state), [id, 'tabState', getCurrentTab(state, id), 'isSearchOpen']);
}

function getCurrentResults(state, id) {
  const results = _get(_get(local$3(state), 'searchResults'), pathFor(_get(local$3(state), [id, 'tabState', getCurrentTab(state, id), 'searchQuery']), _get(local$3(state), [id, 'tabState', getCurrentTab(state, id), 'filters'])));
  return results;
}

function getSearchQuery(state, id) {
  return _get(local$3(state), [id, 'tabState', getCurrentTab(state, id), 'searchQuery']);
}

function getEngineFilters(state, id) {
  return _get(local$3(state), [id, 'tabState', getCurrentTab(state, id), 'filters']);
}

function engineIsSelected(state, engineId, id) {
  return _get(local$3(state), [id, 'selectedEngineIds']).includes(engineId);
}

function engineIsChecked(state, engineId, id) {
  return _get(local$3(state), [id, 'checkedEngineIds']).includes(engineId);
}

function allEnginesChecked(state, id) {
  return _get(local$3(state), [id, 'allEnginesChecked']);
}

function getSelectedEngineIds(state, id) {
  return _get(local$3(state), [id, 'selectedEngineIds']);
}

function getDeselectedEngineIds(state, id) {
  return _get(local$3(state), [id, 'deselectedEngineIds']);
}

function getCheckedEngineIds(state, id) {
  return _get(local$3(state), [id, 'checkedEngineIds']);
}

function getActiveSidebarPath(state, id) {
  return _get(local$3(state), [id, 'activeSidebarPath']);
}

function getFilteredSelectedEngineids(state, id) {
  const selectedEngineIds = getSelectedEngineIds(state, id);
  const currentResults = getCurrentResults(state, id);

  return _intersection(selectedEngineIds, currentResults);
}

function hasActiveFilters(state, id) {
  const filters = getEngineFilters(state, id);
  const searchQuery = getSearchQuery(state, id);

  return _Object$values(filters).some(val => _isNumber(val) || !_isEmpty(val)) || !!searchQuery;
}

const { createReducer: createReducer$6, callGraphQLApi } = helpers;

const namespace$5 = 'multiEngineSelection';

const FETCH_ENGINES = `vtn/${namespace$5}/FETCH_ENGINES`;
const FETCH_ENGINES_SUCCESS = `vtn/${namespace$5}/FETCH_ENGINES_SUCCESS`;
const FETCH_ENGINES_FAILURE = `vtn/${namespace$5}/FETCH_ENGINES_FAILURE`;
const TOGGLE_ENGINE = `vtn/${namespace$5}/TOGGLE_ENGINE`;

const defaultState$5 = {};
const PAGE_SIZE = 100;
const MAX_SELECTIONS = 6;

const getPickerID = action => _get(action, 'meta.variables.id');

const loadingEngines = (state, id) => _get(local$4(state), [id, 'loadingEngines']);
const loadingEnginesFailed = (state, id) => _get(local$4(state), [id, 'loadingEnginesFailed']);
const engines = (state, id) => {
  return _get(local$4(state), [id, 'engines']);
};
const selectedEngines = (state, id, ids) => {
  if (id) {
    return _get(local$4(state), [id, 'selected']);
  } else {
    const pickers = ids || _Object$keys(local$4(state));
    const selected = {};

    pickers.forEach(id => {
      _Object$assign(selected, _get(local$4(state), [id, 'selected']));
    });
    return selected;
  }
};
const canSelectMore = (state, id) => {
  const existingSelections = selectedEngines(state, id);
  return !existingSelections || _Object$keys(existingSelections).length < MAX_SELECTIONS;
};

const hasMorePages = (state, id) => {
  return _get(local$4(state), [id, 'lastCount']) >= PAGE_SIZE;
};

const lastSearch = (state, id) => {
  return _get(local$4(state), [id, 'lastSearch']);
};

const reducer$2 = createReducer$6(defaultState$5, {
  [FETCH_ENGINES](state, action) {
    const newSearch = _get(action, 'meta.variables.search');
    const lastSearch = _get(state, [getPickerID(action), 'lastSearch']);
    const engines = newSearch !== lastSearch ? [] : _get(state, [getPickerID(action), 'engines']);

    return _extends$1({}, state, {
      [getPickerID(action)]: {
        loadingEngines: true,
        loadingEnginesFailed: false,
        engines: engines,
        selected: _get(state, [getPickerID(action), 'selected']) || {},
        lastSearch: newSearch
      }
    });
  },
  [TOGGLE_ENGINE](state, action) {
    const id = action.id;
    const rowId = action.rowId;
    const toggleSelection = (state, id, rowId) => {
      const selected = _extends$1({}, _get(state, [id, 'selected']));
      if (selected.hasOwnProperty(rowId)) {
        delete selected[rowId];
      } else {
        const engines = _get(state, [id, 'engines']);
        selected[rowId] = engines.find(engine => engine.id === rowId);
      }
      return selected;
    };

    // only toggle one picker
    if (id) {
      let nextState = _extends$1({}, state);
      const selected = toggleSelection(state, id, rowId);
      nextState[id].selected = selected;
      return nextState;
    } else {
      // toggle all pickers
      let nextState = _extends$1({}, state);
      const ids = _Object$keys(nextState);
      ids.forEach(id => {
        nextState[id].selected = toggleSelection(nextState, id, rowId);
      });
      return nextState;
    }
  },
  [FETCH_ENGINES_SUCCESS](state, action) {
    let engines = _get(state, [getPickerID(action), 'engines']) || [];
    let enginesNextPage = _get(action, 'payload.engines.records');

    let myOrgId = _get(action, 'payload.me.organizationId');
    enginesNextPage.forEach(engine => engine.owned = engine.ownerOrganization.id === myOrgId);

    engines = engines.concat(enginesNextPage);
    let lastSearch = _get(state, [getPickerID(action), 'lastSearch']);
    if (_isNil(lastSearch) || lastSearch === _get(action, 'meta.variables.search')) {
      return _extends$1({}, state, {
        [getPickerID(action)]: {
          loadingEngines: false,
          loadingEnginesFailed: false,
          engines,
          offset: _get(action, 'meta.variables.offset') + _get(action, 'payload.engines.count'),
          lastCount: _get(action, 'payload.engines.count'),
          lastSearch,
          selected: _get(state, [getPickerID(action), 'selected'])
        }
      });
    } else {
      return state;
    }
  },
  [FETCH_ENGINES_FAILURE](state, action) {
    return _extends$1({}, state, {
      [getPickerID(action)]: {
        loadingEngines: false,
        loadingEnginesFailed: true,
        engines: [],
        offset: 0,
        lastCount: 0,
        lastSearch: undefined,
        selected: {}
      }
    });
  }
});

function local$4(state) {
  return state[namespace$5];
}

const toggleEngine = ({ id, rowId }) => {
  return {
    type: TOGGLE_ENGINE,
    id,
    rowId
  };
};

const fetchEngines = ({ category, id, owned, engineName }) => async (dispatch, getState) => {
  const lastSearch = _get(local$4(getState()), [id, 'lastSearch']);
  let offset = _get(local$4(getState()), [id, 'offset']) || 0;
  if (!_isEqual(engineName, lastSearch)) {
    offset = 0;
  }

  const query = `
    query {
      engines(offset: ${offset}, limit: ${PAGE_SIZE}, category: "${category}", name: "${engineName}", state: active, orderBy: {field: name, direction: asc}, owned: ${owned === true}) {
        records {
          id,
          name,
          displayName,
          logoPath,
          builds {
            records {
              id,
              name,
              version,
              price
            }
          },
          description,
          deployedVersion,
          ownerOrganization {
            name,
            id
          }
        },
        count
      },
      me {
        organizationId
      }
    }
  `;

  return await callGraphQLApi({
    actionTypes: [FETCH_ENGINES, FETCH_ENGINES_SUCCESS, FETCH_ENGINES_FAILURE],
    query,
    dispatch,
    variables: {
      id: id,
      offset: offset,
      search: engineName,
      owned
    },
    getState
  });
};

var index$2 = /*#__PURE__*/Object.freeze({
	namespace: namespace$5,
	FETCH_ENGINES: FETCH_ENGINES,
	FETCH_ENGINES_SUCCESS: FETCH_ENGINES_SUCCESS,
	FETCH_ENGINES_FAILURE: FETCH_ENGINES_FAILURE,
	TOGGLE_ENGINE: TOGGLE_ENGINE,
	MAX_SELECTIONS: MAX_SELECTIONS,
	loadingEngines: loadingEngines,
	loadingEnginesFailed: loadingEnginesFailed,
	engines: engines,
	selectedEngines: selectedEngines,
	canSelectMore: canSelectMore,
	hasMorePages: hasMorePages,
	lastSearch: lastSearch,
	'default': reducer$2,
	toggleEngine: toggleEngine,
	fetchEngines: fetchEngines
});

const { createReducer: createReducer$7 } = helpers;

const namespace$6 = 'snackbar';

const SHOW_SNACKBAR = 'vtn/snackbar/SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'vtn/snackbar/HIDE_SNACKBAR';

const SHOW_DIALOG = 'vtn/snackbar/SHOW_DIALOG';
const HIDE_DIALOG = 'vtn/snackbar/HIDE_DIALOG';

const defaultState$6 = {
  snackbar: {
    open: false,
    message: ''
  },
  dialog: {
    open: false,
    message: '',
    title: ''
  }
};

const reducer$3 = createReducer$7(defaultState$6, {
  [SHOW_SNACKBAR](state, action) {
    if (!action.payload.message) {
      return _extends$1({}, state);
    }

    return _extends$1({}, state, {
      snackbar: {
        open: true,
        message: action.payload.message
      }
    });
  },
  // todo: implement snackbar queue as described in
  // https://material-ui.com/demos/snackbars/#consecutive-snackbars
  [HIDE_SNACKBAR](state) {
    return _extends$1({}, state, {
      snackbar: defaultState$6.snackbar
    });
  },
  [SHOW_DIALOG](state, action) {
    return _extends$1({}, state, {
      dialog: {
        open: true,
        title: action.payload.title,
        message: action.payload.message
      }
    });
  },
  [HIDE_DIALOG](state) {
    return _extends$1({}, state, {
      dialog: defaultState$6.dialog
    });
  }
});

function local$5(state) {
  return state[namespace$6];
}

function showNotification(message) {
  return {
    type: SHOW_SNACKBAR,
    payload: {
      message
    }
  };
}

function hideSnackbarNotification() {
  return {
    type: HIDE_SNACKBAR
  };
}

function showDialogNotification(title, message) {
  return {
    type: SHOW_DIALOG,
    payload: {
      title,
      message
    }
  };
}

function hideDialogNotification() {
  return {
    type: HIDE_DIALOG
  };
}

function selectSnackbarNotificationState(state) {
  return local$5(state).snackbar;
}

function selectDialogNotificationState(state) {
  return local$5(state).dialog;
}

var index$3 = /*#__PURE__*/Object.freeze({
	namespace: namespace$6,
	'default': reducer$3,
	showNotification: showNotification,
	hideSnackbarNotification: hideSnackbarNotification,
	showDialogNotification: showDialogNotification,
	hideDialogNotification: hideDialogNotification,
	selectSnackbarNotificationState: selectSnackbarNotificationState,
	selectDialogNotificationState: selectDialogNotificationState
});

const { createReducer: createReducer$8, callGraphQLApi: callGraphQLApi$1 } = helpers;

const namespace$7 = 'engineOutputExport';

const FETCH_ENGINE_RUNS = `vtn/${namespace$7}/FETCH_ENGINE_RUNS`;
const FETCH_ENGINE_RUNS_SUCCESS = `vtn/${namespace$7}/FETCH_ENGINE_RUNS_SUCCESS`;
const FETCH_ENGINE_RUNS_FAILURE = `vtn/${namespace$7}/FETCH_ENGINE_RUNS_FAILURE`;

const SET_INCLUDE_MEDIA = `vtn/${namespace$7}/SET_INCLUDE_MEDIA`;

const TOGGLE_CONFIG_EXPAND = `vtn/${namespace$7}/TOGGLE_CONFIG_EXPAND`;

const UPDATE_SELECTED_FILE_TYPES = `vtn/${namespace$7}/UPDATE_SELECTED_FILE_TYPES`;

const APPLY_SUBTITLE_CONFIGS = `vtn/${namespace$7}/APPLY_SUBTITLE_CONFIGS`;
const STORE_SUBTITLE_CONFIGS = `vtn/${namespace$7}/STORE_SUBTITLE_CONFIGS`;

const APPLY_SPEAKER_TOGGLE = `vtn/${namespace$7}/APPLY_SPEAKER_TOGGLE`;
const STORE_SPEAKER_TOGGLE = `vtn/${namespace$7}/STORE_SPEAKER_TOGGLE`;
const STORE_HAS_SPEAKER_DATA = `vtn/${namespace$7}/STORE_HAS_SPEAKER_DATA`;

const START_EXPORT_AND_DOWNLOAD = `vtn/${namespace$7}/START_EXPORT_AND_DOWNLOAD`;
const EXPORT_AND_DOWNLOAD_SUCCESS = `vtn/${namespace$7}/EXPORT_AND_DOWNLOAD_SUCCESS`;
const EXPORT_AND_DOWNLOAD_FAILURE = `vtn/${namespace$7}/EXPORT_AND_DOWNLOAD_FAILURE`;

const ADD_SNACK_BAR = `vtn/${namespace$7}/ADD_SNACK_BAR`;
const CLOSE_SNACK_BAR = `vtn/${namespace$7}/CLOSE_SNACK_BAR`;

const defaultState$7 = {
  fetchingEngineRuns: false,
  fetchingCategoryExportFormats: false,
  includeMedia: false,
  enginesRan: {},
  categoryLookup: {},
  expandedCategories: {},
  subtitleConfigCache: {},
  speakerToggleCache: {
    withSpeakerData: true // Default value across all categories
  },
  hasSpeakerData: false,
  outputConfigurations: [],
  errorSnackBars: [],
  fetchEngineRunsFailed: false,
  exportAndDownloadFailed: false,
  isBulkExport: false,
  transcriptCategoryType: 'transcript',
  speakerCategoryType: 'speaker'
};

var engineOutputExportReducer = createReducer$8(defaultState$7, {
  [FETCH_ENGINE_RUNS](state) {
    return _extends$1({}, state, {
      fetchingEngineRuns: true,
      fetchEngineRunsFailed: null
    });
  },
  [FETCH_ENGINE_RUNS_SUCCESS](state, { payload }) {
    let newOutputConfigurations = [];
    const categoryLookup = {};
    const expandedCategories = {};
    const isBulkExport = _Object$keys(payload).length > 1;
    const enginesRan = _Object$values(payload).reduce((accumulator, tdo) => {
      const engines = _get(tdo, 'engineRuns.records');
      if (engines) {
        engines.forEach(record => {
          if (record.status !== 'failed') {
            accumulator[record.engine.id] = record.engine;
          }
        });
      }
      return accumulator;
    }, {});
    _forEach(enginesRan, engineRun => {
      if (_get(engineRun, 'category.exportFormats.length')) {
        if (isBulkExport) {
          if (!categoryLookup[engineRun.category.id]) {
            newOutputConfigurations.push({
              categoryId: engineRun.category.id,
              categoryType: engineRun.category.categoryType,
              formats: []
            });
          }
        } else {
          newOutputConfigurations.push({
            engineId: engineRun.id,
            categoryType: engineRun.category.categoryType,
            formats: []
          });
        }
        categoryLookup[engineRun.category.id] = engineRun.category;
        expandedCategories[engineRun.category.id] = false;
      }
    });
    newOutputConfigurations = _uniqWith(newOutputConfigurations, (output1, output2) => {
      return output1.engineId === output2.engineId && output1.categoryId === output2.categoryId;
    });

    return _extends$1({}, state, {
      fetchingEngineRuns: false,
      enginesRan: _extends$1({}, state.enginesRan, enginesRan),
      categoryLookup: _extends$1({}, state.categoryLookup, categoryLookup),
      subtitleConfigCache: {},
      outputConfigurations: newOutputConfigurations,
      expandedCategories: expandedCategories,
      isBulkExport,
      fetchEngineRunsFailed: false,
      includeMedia: false
    });
  },
  [FETCH_ENGINE_RUNS_FAILURE](state) {
    return _extends$1({}, state, {
      enginesRan: {},
      categoryLookup: {},
      expandedCategories: {},
      outputConfigurations: [],
      fetchingEngineRuns: false,
      fetchEngineRunsFailed: true
    });
  },
  [SET_INCLUDE_MEDIA](state, {
    payload: { includeMedia }
  }) {
    return _extends$1({}, state, {
      includeMedia: includeMedia
    });
  },
  [TOGGLE_CONFIG_EXPAND](state, {
    payload: { categoryId }
  }) {
    return _extends$1({}, state, {
      expandedCategories: _extends$1({}, state.expandedCategories, {
        [categoryId]: !state.expandedCategories[categoryId]
      })
    });
  },
  [UPDATE_SELECTED_FILE_TYPES](state, {
    payload: { engineId, categoryId, selectedFileTypes }
  }) {
    return _extends$1({}, state, {
      outputConfigurations: state.outputConfigurations.map(config => {
        if (engineId && config.engineId === engineId || config.categoryId === categoryId) {
          const storedSubtitleConfig = _get(state, ['subtitleConfigCache', categoryId]);
          const storedSpeakerToggle = state.hasSpeakerData ? _get(state, ['speakerToggleCache', categoryId]) || _get(state, 'speakerToggleCache') : {};
          return _extends$1({}, config, {
            formats: selectedFileTypes.map(type => {
              return {
                extension: type,
                options: storedSubtitleConfig ? _extends$1({}, storedSubtitleConfig, storedSpeakerToggle) : _extends$1({}, storedSpeakerToggle)
              };
            })
          });
        }
        return config;
      })
    });
  },
  [APPLY_SPEAKER_TOGGLE](state, {
    payload: { categoryId, values }
  }) {
    return _extends$1({}, state, {
      outputConfigurations: state.outputConfigurations.map(config => {
        let engineCategoryId;
        if (!config.categoryId && config.engineId) {
          engineCategoryId = _get(state, ['enginesRan', config.engineId, 'category', 'id']);
        }
        if (config.categoryId === categoryId || engineCategoryId === categoryId) {
          return _extends$1({}, config, {
            formats: config.formats.map(format => {
              return _extends$1({}, format, {
                options: _extends$1({}, format.options, {
                  withSpeakerData: values
                })
              });
            })
          });
        }
        return config;
      })
    });
  },
  [STORE_SPEAKER_TOGGLE](state, {
    payload: { categoryId, config }
  }) {
    return _extends$1({}, state, {
      speakerToggleCache: _extends$1({}, state.speakerToggleCache, config)
    });
  },
  [STORE_HAS_SPEAKER_DATA](state, {
    payload: { hasSpeakerData }
  }) {
    return _extends$1({}, state, {
      hasSpeakerData
    });
  },
  [APPLY_SUBTITLE_CONFIGS](state, {
    payload: { categoryId, values }
  }) {
    return _extends$1({}, state, {
      outputConfigurations: state.outputConfigurations.map(config => {
        let engineCategoryId;
        if (!config.categoryId && config.engineId) {
          engineCategoryId = _get(state, ['enginesRan', config.engineId, 'category', 'id']);
        }
        if (config.categoryId === categoryId || engineCategoryId === categoryId) {
          return _extends$1({}, config, {
            formats: config.formats.map(format => {
              return _extends$1({}, format, {
                options: _extends$1({}, values)
              });
            })
          });
        }
        return config;
      })
    });
  },
  [STORE_SUBTITLE_CONFIGS](state, {
    payload: { categoryId, config }
  }) {
    return _extends$1({}, state, {
      subtitleConfigCache: _extends$1({}, state.subtitleConfigCache, {
        [categoryId]: _extends$1({}, config)
      })
    });
  },
  [START_EXPORT_AND_DOWNLOAD](state) {
    return _extends$1({}, state, {
      exportAndDownloadFailed: false
    });
  },
  [EXPORT_AND_DOWNLOAD_FAILURE](state) {
    return _extends$1({}, state, {
      exportAndDownloadFailed: true
    });
  },
  [ADD_SNACK_BAR](state, {
    payload: { snackBarConfig }
  }) {
    return _extends$1({}, state, {
      errorSnackBars: [...state.errorSnackBars, snackBarConfig]
    });
  },
  [CLOSE_SNACK_BAR](state, {
    payload: { snackBarId }
  }) {
    return _extends$1({}, state, {
      errorSnackBars: state.errorSnackBars.map(snackBar => {
        if (snackBar.id === snackBarId) {
          return _extends$1({}, snackBar, {
            open: false
          });
        }
        return snackBar;
      })
    });
  }
});

function local$6(state) {
  return state[namespace$7];
}

const getIncludeMedia = state => _get(local$6(state), 'includeMedia');
const outputConfigsByCategoryId = state => {
  const outputConfigsByCategoryId = {};
  const outputConfigurations = _get(local$6(state), 'outputConfigurations');
  _forEach(outputConfigurations, config => {
    if (config.categoryId) {
      if (!outputConfigsByCategoryId[config.categoryId]) {
        outputConfigsByCategoryId[config.categoryId] = [];
      }
      outputConfigsByCategoryId[config.categoryId].push(config);
    } else if (config.engineId) {
      // Look up engine category id using engineId
      const categoryId = _get(getEngineById(state, config.engineId), 'category.id');
      if (!outputConfigsByCategoryId[categoryId]) {
        outputConfigsByCategoryId[categoryId] = [];
      }
      outputConfigsByCategoryId[categoryId].push(config);
    }
  });
  return outputConfigsByCategoryId;
};
const getCategoryById = (state, categoryId) => {
  return _get(local$6(state), ['categoryLookup', categoryId]);
};
const expandedCategories = state => _get(local$6(state), 'expandedCategories');
const getEngineById = (state, engineId) => _get(local$6(state), ['enginesRan', engineId]);
const fetchingEngineRuns = state => _get(local$6(state), 'fetchingEngineRuns');
const fetchingCategoryExportFormats = state => _get(local$6(state), 'fetchingCategoryExportFormats');
const getOutputConfigurations = state => _get(local$6(state), 'outputConfigurations');
const errorSnackBars = state => _get(local$6(state), 'errorSnackBars');
const fetchEngineRunsFailed = state => _get(local$6(state), 'fetchEngineRunsFailed');
const speakerCategoryType = state => _get(local$6(state), 'speakerCategoryType');
const transcriptCategoryType = state => _get(local$6(state), 'transcriptCategoryType');
const getSubtitleConfig = (state, categoryId) => _get(local$6(state), ['subtitleConfigCache', categoryId]);
const getSpeakerToggle = (state, categoryId) => {
  // If the category speaker toggle is undefined, then
  // fallback to the default across all categories
  const speakerToggleCache = _get(local$6(state), ['speakerToggleCache', categoryId]) || _get(local$6(state), 'speakerToggleCache');
  return speakerToggleCache;
};
const hasSpeakerData = state => _get(local$6(state), 'hasSpeakerData');
const isBulkExport = state => _get(local$6(state), 'isBulkExport');
const selectedFormats = state => _get(local$6(state), 'outputConfigurations').reduce((accumulator, configObj) => {
  return [...accumulator, ...configObj.formats];
}, []);

const fetchEngineRuns = tdos => async (dispatch, getState) => {
  // TODO: Update the temporalDataObjects query to accept multiple ids.
  const tdoQueries = tdos.map(tdo => tdo.tdoId).reduce((accumulator, id) => {
    const subquery = `
      tdo${id}:  temporalDataObject(id: "${id}") {
        id
        engineRuns {
          records {
            engine {
              id
              name
              signedIconPath
              iconPath
              category {
                id
                name
                categoryType
                iconClass
                exportFormats {
                  format
                  label
                  types
                }
              }
            },
            status
          }
        }
      }
    `;
    return accumulator + subquery;
  }, '');

  const query = `
    query {
      ${tdoQueries}
    }
  `;

  return await callGraphQLApi$1({
    actionTypes: [FETCH_ENGINE_RUNS, FETCH_ENGINE_RUNS_SUCCESS, FETCH_ENGINE_RUNS_FAILURE],
    query,
    dispatch,
    getState
  });
};

const exportAndDownload = tdoData => async (dispatch, getState) => {
  const query = `
    mutation createExportRequest(
      $includeMedia: Boolean,
      $tdoData: [CreateExportRequestForTDO!]!,
      $outputConfigurations: [CreateExportRequestOutputConfig!]
    ) {
      createExportRequest(input: {
        includeMedia: $includeMedia
        tdoData: $tdoData
        outputConfigurations: $outputConfigurations
      }) {
        id
        status
        organizationId
        createdDateTime
        modifiedDateTime
        requestorId
        assetUri
      }
    }
  `;

  if (!selectedFormats(getState()).length) {
    const e = {
      name: 'no_formats_selected',
      message: 'Please select from at least one option'
    };

    dispatch({
      type: EXPORT_AND_DOWNLOAD_FAILURE,
      error: true,
      payload: e
    });

    let error = new Error('No file formats selected');
    // wrap this single error for consistency with graphQL errors, which are always
    // wrapped.
    error.errors = [e];
    throw error;
  }

  return await callGraphQLApi$1({
    actionTypes: [START_EXPORT_AND_DOWNLOAD, EXPORT_AND_DOWNLOAD_SUCCESS, EXPORT_AND_DOWNLOAD_FAILURE],
    query,
    variables: {
      includeMedia: getIncludeMedia(getState()),
      outputConfigurations: getOutputConfigurations(getState()).map(config => _pick(config, ['engineId', 'categoryId', 'formats'])),
      tdoData
    },
    dispatch,
    getState
  });
};

const setIncludeMedia = includeMedia => {
  return {
    type: SET_INCLUDE_MEDIA,
    payload: {
      includeMedia
    }
  };
};

const toggleConfigExpand = categoryId => {
  return {
    type: TOGGLE_CONFIG_EXPAND,
    payload: {
      categoryId
    }
  };
};

const selectFileType = (selectedFileTypes, categoryId, engineId) => {
  return {
    type: UPDATE_SELECTED_FILE_TYPES,
    payload: {
      selectedFileTypes,
      categoryId,
      engineId
    }
  };
};

const applySubtitleConfigs = (categoryId, values) => {
  return {
    type: APPLY_SUBTITLE_CONFIGS,
    payload: {
      categoryId,
      values
    }
  };
};

const applySpeakerToggle = (categoryId, values) => {
  return {
    type: APPLY_SPEAKER_TOGGLE,
    payload: {
      categoryId,
      values
    }
  };
};

const storeSpeakerToggle = (categoryId, config) => {
  return {
    type: STORE_SPEAKER_TOGGLE,
    payload: {
      categoryId,
      config
    }
  };
};

const setHasSpeakerData = hasSpeakerData => {
  return {
    type: STORE_HAS_SPEAKER_DATA,
    payload: {
      hasSpeakerData
    }
  };
};

const addSnackBar = snackBarConfig => {
  return {
    type: ADD_SNACK_BAR,
    payload: {
      snackBarConfig
    }
  };
};

const closeSnackBar = snackBarId => {
  return {
    type: CLOSE_SNACK_BAR,
    payload: {
      snackBarId
    }
  };
};

const storeSubtitleConfigs = (categoryId, config) => {
  return {
    type: STORE_SUBTITLE_CONFIGS,
    payload: {
      categoryId,
      config
    }
  };
};

var index$4 = /*#__PURE__*/Object.freeze({
	namespace: namespace$7,
	FETCH_ENGINE_RUNS: FETCH_ENGINE_RUNS,
	FETCH_ENGINE_RUNS_SUCCESS: FETCH_ENGINE_RUNS_SUCCESS,
	FETCH_ENGINE_RUNS_FAILURE: FETCH_ENGINE_RUNS_FAILURE,
	SET_INCLUDE_MEDIA: SET_INCLUDE_MEDIA,
	TOGGLE_CONFIG_EXPAND: TOGGLE_CONFIG_EXPAND,
	UPDATE_SELECTED_FILE_TYPES: UPDATE_SELECTED_FILE_TYPES,
	APPLY_SUBTITLE_CONFIGS: APPLY_SUBTITLE_CONFIGS,
	STORE_SUBTITLE_CONFIGS: STORE_SUBTITLE_CONFIGS,
	APPLY_SPEAKER_TOGGLE: APPLY_SPEAKER_TOGGLE,
	STORE_SPEAKER_TOGGLE: STORE_SPEAKER_TOGGLE,
	STORE_HAS_SPEAKER_DATA: STORE_HAS_SPEAKER_DATA,
	START_EXPORT_AND_DOWNLOAD: START_EXPORT_AND_DOWNLOAD,
	EXPORT_AND_DOWNLOAD_SUCCESS: EXPORT_AND_DOWNLOAD_SUCCESS,
	EXPORT_AND_DOWNLOAD_FAILURE: EXPORT_AND_DOWNLOAD_FAILURE,
	ADD_SNACK_BAR: ADD_SNACK_BAR,
	CLOSE_SNACK_BAR: CLOSE_SNACK_BAR,
	'default': engineOutputExportReducer,
	getIncludeMedia: getIncludeMedia,
	outputConfigsByCategoryId: outputConfigsByCategoryId,
	getCategoryById: getCategoryById,
	expandedCategories: expandedCategories,
	getEngineById: getEngineById,
	fetchingEngineRuns: fetchingEngineRuns,
	fetchingCategoryExportFormats: fetchingCategoryExportFormats,
	getOutputConfigurations: getOutputConfigurations,
	errorSnackBars: errorSnackBars,
	fetchEngineRunsFailed: fetchEngineRunsFailed,
	speakerCategoryType: speakerCategoryType,
	transcriptCategoryType: transcriptCategoryType,
	getSubtitleConfig: getSubtitleConfig,
	getSpeakerToggle: getSpeakerToggle,
	hasSpeakerData: hasSpeakerData,
	isBulkExport: isBulkExport,
	selectedFormats: selectedFormats,
	fetchEngineRuns: fetchEngineRuns,
	exportAndDownload: exportAndDownload,
	setIncludeMedia: setIncludeMedia,
	toggleConfigExpand: toggleConfigExpand,
	selectFileType: selectFileType,
	applySubtitleConfigs: applySubtitleConfigs,
	applySpeakerToggle: applySpeakerToggle,
	storeSpeakerToggle: storeSpeakerToggle,
	setHasSpeakerData: setHasSpeakerData,
	addSnackBar: addSnackBar,
	closeSnackBar: closeSnackBar,
	storeSubtitleConfigs: storeSubtitleConfigs
});

function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = createSelectorCreator(defaultMemoize);

const namespace$8 = 'folderTree';

const folderSelector = state => state[namespace$8];

const folderData = state => state[namespace$8].foldersData;

const folderFetching = state => state[namespace$8].fetching;

const folderFetched = state => state[namespace$8].fetched;

const folderError = state => state[namespace$8].error;

const rootFolderIds = state => state[namespace$8].foldersData.rootIds;

const folderById = state => folderId => state[namespace$8].foldersData.byId[folderId];

const folderExpanded = state => state[namespace$8].expandedFolderIds;

const selected = state => state[namespace$8].selectedFolder;

const processingFolder = state => state[namespace$8].processingFolder;

const config = state => state[namespace$8].config;

const searchValue$1 = state => state[namespace$8].currentSearchValue;

const searchData = state => state[namespace$8].searchFolderData;

const initialSuccess = state => state[namespace$8].initialSuccess;

const eventSelector = state => state[namespace$8].event;

const foldersDataSelector = createSelector([folderData, searchValue$1, searchData], (foldersData, searchValue, searchData) => {
  if (searchValue !== '') {
    return searchData.byId[searchValue];
  }
  return foldersData;
});

const folderFetchingStatus = createSelector([folderFetching], folderFetching => folderFetching);

const folderFetchedStatus = createSelector([folderFetched], folderFetched => folderFetched);

const folderErrorStatus = createSelector([folderError], folderError => folderError);

const selectedFolder = createSelector([selected], selected => selected);

const processingFolderSelector = createSelector([processingFolder], processingFolder => processingFolder);

const getInitialStatus = createSelector([initialSuccess], initialSuccess => initialSuccess);

const INIT_ROOT_FOLDER = `${namespace$8}/INIT_ROOT_FOLDER`;
const INIT_CONFIG = `${namespace$8}/INIT_CONFIG`;
const INIT_ROOT_FOLDER_START = `${namespace$8}/INIT_ROOT_FOLDER_START`;
const INIT_ROOT_FOLDER_SUCCESS = `${namespace$8}/INIT_ROOT_FOLDER_SUCCESS`;
const INIT_ROOT_FOLDER_ERROR = `${namespace$8}/INIT_ROOT_FOLDER_ERROR`;
const INIT_FOLDER$1 = `${namespace$8}/INIT_FOLDER`;
const INIT_FOLDER_START = `${namespace$8}/INIT_FOLDER_START`;
const INIT_FOLDER_SUCCESS = `${namespace$8}/INIT_FOLDER_SUCCESS`;
const INIT_FOLDER_ERROR = `${namespace$8}/INIT_FOLDER_ERROR`;
const FETCH_MORE = `${namespace$8}/FETCH_MORE`;
const FETCH_MORE_START = `${namespace$8}/FETCH_MORE_START`;
const FETCH_MORE_SUCCESS = `${namespace$8}/FETCH_MORE_SUCCESS`;
const FETCH_MORE_ERROR = `${namespace$8}/FETCH_MORE_ERROR`;
const SEARCH_FOLDER = `${namespace$8}/SEARCH_FOLDER`;
const SEARCH_START = `${namespace$8}/SEARCH_START`;
const SEARCH_SUCCESS = `${namespace$8}/SEARCH_SUCCESS`;
const SEARCH_ERROR = `${namespace$8}/SEARCH_ERROR`;
const SEARCH_UPDATE_DATA = `${namespace$8}/SEARCH_UPDATE_DATA`;
const CLEAR_SEARCH$2 = `${namespace$8}/CLEAR_SEARCH`;
const SELECT_FOLDER = `${namespace$8}/SELECT_FOLDER`;
const SELECT_ALL_FOLDER = `${namespace$8}/SELECT_ALL_FOLDER`;
const CREATE_FOLDER = `${namespace$8}/CREATE_FOLDER`;
const CREATE_FOLDER_START = `${namespace$8}/CREATE_FOLDER_START`;
const CREATE_FOLDER_SUCCESS = `${namespace$8}/CREATE_FOLDER_SUCCESS`;
const CREATE_FOLDER_ERROR = `${namespace$8}/CREATE_FOLDER_ERROR`;
const DELETE_FOLDER = `${namespace$8}/DELETE_FOLDER`;
const DELETE_FOLDER_START = `${namespace$8}/DELETE_FOLDER_START`;
const DELETE_FOLDER_SUCCESS = `${namespace$8}/DELETE_FOLDER_SUCCESS`;
const DELETE_FOLDER_ERROR = `${namespace$8}/DELETE_FOLDER_ERROR`;
const EDIT_FOLDER = `${namespace$8}/EDIT_FOLDER`;
const EDIT_FOLDER_START = `${namespace$8}/EDIT_FOLDER_START`;
const EDIT_FOLDER_SUCCESS = `${namespace$8}/EDIT_FOLDER_SUCCESS`;
const EDIT_FOLDER_ERROR = `${namespace$8}/EDIT_FOLDER_ERROR`;
const INIT_FOLDER_FROM_APP = `${namespace$8}/INIT_FOLDER_FROM_APP`;
const INIT_FOLDER_FROM_APP_START = `${namespace$8}/INIT_FOLDER_FROM_APP_START`;
const INIT_FOLDER_FROM_APP_ERROR = `${namespace$8}/INIT_FOLDER_FROM_APP_ERROR`;
const UNSELECT_FOLDER = `${namespace$8}/UNSELECT_FOLDER`;
const UNSELECT_ALL_FOLDER = `${namespace$8}/UNSELECT_ALL_FOLDER`;
const UNSELECT_CURRENT_FOLDER = `${namespace$8}/UNSELECT_CURRENT_FOLDER`;
const EVENT_CHANNEL = `${namespace$8}/EVENT_CHANNEL`;

const initConfig = config => ({
  type: INIT_CONFIG,
  payload: {
    config
  }
});
//rootFolder
const initRootFolder = config => ({
  type: INIT_ROOT_FOLDER,
  payload: {
    config
  }
});

const initRootFolderStart = () => ({
  type: INIT_ROOT_FOLDER_START
});

const initRootFolderSuccess = (folders, rootFolderId) => ({
  type: INIT_ROOT_FOLDER_SUCCESS,
  payload: {
    folders,
    rootFolderId
  }
});
const initRootFolderError = () => ({
  type: INIT_ROOT_FOLDER_ERROR
});

const initFolder = folderId => ({
  type: INIT_FOLDER$1,
  payload: {
    folderId
  }
});

const initFolderSuccess = folder => ({
  type: INIT_FOLDER_SUCCESS,
  payload: {
    folder
  }
});

const initFolderError = folderId => ({
  type: INIT_FOLDER_ERROR,
  payload: {
    folderId
  }
});

const fetchMore = (folderId, isReload = false) => ({
  type: FETCH_MORE,
  payload: {
    folderId,
    isReload
  }
});

const fetchMoreStart = folderId => ({
  type: FETCH_MORE_START,
  payload: {
    folderId
  }
});

const fetchMoreSuccess = (folders, folderId) => ({
  type: FETCH_MORE_SUCCESS,
  payload: {
    folders,
    folderId
  }
});

const searchFolder = searchValue => ({
  type: SEARCH_FOLDER,
  payload: {
    searchValue
  }
});

const searchFolderStart = searchValue => ({
  type: SEARCH_START,
  payload: {
    searchValue
  }
});

const searchFolderSuccess = (searchValue, folders) => ({
  type: SEARCH_SUCCESS,
  payload: {
    searchValue,
    folders
  }
});

const clearSearchData = () => ({
  type: CLEAR_SEARCH$2
});

const updateSearchData = () => ({
  type: SEARCH_UPDATE_DATA
});

const selectFolder = (workSpace, selected) => ({
  type: SELECT_FOLDER,
  payload: {
    workSpace,
    selected
  }
});

const selectAllFolder = workSpace => ({
  type: SELECT_ALL_FOLDER,
  payload: {
    workSpace
  }
});

const createFolder = (folderName, parentFolderId) => ({
  type: CREATE_FOLDER,
  payload: {
    name: folderName,
    parentId: parentFolderId
  }
});

const createFolderStart = () => ({
  type: CREATE_FOLDER_START
});

const createFolderSuccess = () => ({
  type: CREATE_FOLDER_SUCCESS
});

const createFolderError = () => ({
  type: CREATE_FOLDER_ERROR
});

const deleteFolder = (folderId, workSpace) => ({
  type: DELETE_FOLDER,
  payload: {
    folderId,
    workSpace
  }
});

const deleteFolderStart = folderId => ({
  type: DELETE_FOLDER_START,
  payload: {
    folderId
  }
});

const deleteFolderSuccess = (folderId, parentId) => ({
  type: DELETE_FOLDER_SUCCESS,
  payload: {
    folderId,
    parentId
  }
});

const deleteFolderError = folderId => ({
  type: DELETE_FOLDER_ERROR,
  payload: {
    folderId
  }
});

const modifyFolder = (folderId, folderName, isEditName, isMoveFolder, parentId) => ({
  type: EDIT_FOLDER,
  payload: {
    folderId,
    folderName,
    isEditName,
    isMoveFolder,
    parentId
  }
});

const modifyFolderStart = folderId => ({
  type: EDIT_FOLDER_START,
  payload: {
    folderId
  }
});

const modifyFolderSuccess = folder => ({
  type: EDIT_FOLDER_SUCCESS,
  payload: {
    folder
  }
});

const modifyFolderError = folderId => ({
  type: EDIT_FOLDER_ERROR,
  payload: {
    folderId
  }
});

const initFolderFromApp = folderId => ({
  type: INIT_FOLDER_FROM_APP,
  payload: {
    folderId
  }
});

const initFolderFromAppStart = folderId => ({
  type: INIT_FOLDER_FROM_APP_START,
  payload: {
    folderId
  }
});

const unSelectFolder = (folderId, workSpace) => ({
  type: UNSELECT_FOLDER,
  payload: {
    folderId,
    workSpace
  }
});

const unSelectAllFolder = () => ({
  type: UNSELECT_ALL_FOLDER
});

const unSelectCurrentFolder = workSpace => ({
  type: UNSELECT_CURRENT_FOLDER,
  payload: {
    workSpace
  }
});

const initFolderFromAppError = folderId => ({
  type: INIT_FOLDER_FROM_APP_ERROR,
  payload: {
    folderId
  }
});

const eventChannel = (workSpace, eventType, data) => ({
  type: EVENT_CHANNEL,
  payload: {
    workSpace,
    eventType,
    data
  }
});

// 20.1.2.3 Number.isInteger(number)

var floor$1 = Math.floor;
var _isInteger = function isInteger(it) {
  return !_isObject(it) && isFinite(it) && floor$1(it) === it;
};

// 20.1.2.3 Number.isInteger(number)


_export(_export.S, 'Number', { isInteger: _isInteger });

var isInteger = _core.Number.isInteger;

var isInteger$1 = createCommonjsModule(function (module) {
module.exports = { "default": isInteger, __esModule: true };
});

var _Number$isInteger = unwrapExports(isInteger$1);

const { fetchGraphQLApi: fetchGraphQLApi$1 } = helpers;
const {
  auth: authModule,
  config: configModule,
  getExtraHeaders
} = modules;

function* getGqlParams() {
  const config = yield select(configModule.getConfig);
  const extraHeaders = yield select(getExtraHeaders);
  const { apiRoot, graphQLEndpoint } = config;
  const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;
  const sessionToken = yield select(authModule.selectSessionToken);
  const oauthToken = yield select(authModule.selectOAuthToken);
  const token = sessionToken || oauthToken;
  return {
    graphQLUrl,
    token,
    extraHeaders
  };
}

function* handleRequest({ query, variables }) {
  const { graphQLUrl, token, extraHeaders } = yield call(getGqlParams);
  let response;
  try {
    response = yield call(fetchGraphQLApi$1, {
      endpoint: graphQLUrl,
      query,
      variables,
      extraHeaders,
      token
    });
    if (response.errors) {
      throw new Error(response.errors);
    }
  } catch (error) {
    console.log('error', error);
    return {
      error
    };
  }

  return {
    error: null,
    response
  };
}

const { createReducer: createReducer$9 } = helpers;

const folderType = {
  cms: {
    orgFolderName: 'My Organization',
    ownerFolderName: 'My Folder',
    rootFolderType: 'cms',
    childs: 'tdo',
    childsType: 'childTDOs',
    deleteContent: 'deleteTDO'

  },
  watchlist: {
    orgFolderName: 'Shared Watchlist',
    ownerFolderName: 'My Watchlist',
    rootFolderType: 'watchlist',
    child: 'watchlist',
    childsType: 'childWatchlists',
    deleteContent: 'deleteWatchlist'

  },
  collection: {
    orgFolderName: 'Shared Collections',
    ownerFolderName: 'My Collection',
    rootFolderType: 'collection ',
    child: 'collection',
    childsType: 'childCollections',
    deleteContent: 'deleteCollection'
  }
};

const defaultFolderState = {
  config: {},
  initialSuccess: false,
  fetching: false,
  fetched: false,
  error: false,
  foldersData: {
    rootIds: [],
    allId: [],
    byId: {}
  },
  selectedFolder: {},
  processingFolder: [],
  expandedFolderIds: [],
  searching: false,
  currentSearchValue: '',
  searchFolderData: {
    allId: [],
    byId: {}
  },
  event: {}
};

const folderReducer = createReducer$9(defaultFolderState, {
  [INIT_CONFIG]: (state, action) => _extends$1({}, state, {
    config: _extends$1({}, state.config, action.payload.config)
  }),
  [INIT_ROOT_FOLDER_START]: (state, action) => _extends$1({}, state, {
    fetching: true
  }),
  [INIT_ROOT_FOLDER_SUCCESS]: (state, action) => {
    const { folders, rootFolderId } = action.payload;
    const folderIds = folders.map(folder => folder.id);
    const folderByIds = folders.reduce((accum, currentFolder) => _extends$1({}, accum, {
      [currentFolder.id]: currentFolder
    }), {});
    return _extends$1({}, state, {
      fetching: false,
      fetched: true,
      initialSuccess: true,
      foldersData: _extends$1({}, state.foldersData, {
        rootIds: [...rootFolderId],
        allId: uniq([...state.foldersData.allId, ...rootFolderId, ...folderIds]),
        byId: _extends$1({}, state.foldersData.byId, folderByIds)
      })
    });
  },
  [INIT_ROOT_FOLDER_ERROR]: (state, action) => _extends$1({}, state, {
    fetching: false,
    fetched: true,
    error: true
  }),
  [INIT_FOLDER_START]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder, action.payload.folderId]
  }),
  [INIT_FOLDER_SUCCESS]: (state, action) => {
    const { folder } = action.payload;
    const folderId = folder.id;
    const parentId = folder.parentId;
    const allIdNew = includes(state.foldersData.allId, folderId) ? [...state.foldersData.allId] : [...state.foldersData.allId, folderId];
    const newParent = parentId ? {
      [parentId]: _extends$1({}, state.foldersData.byId[parentId], {
        childs: uniq([...state.foldersData.byId[parentId].childs, folderId])
      })
    } : {};
    return _extends$1({}, state, {
      fetching: false,
      fetched: true,
      initialSuccess: true,
      foldersData: _extends$1({}, state.foldersData, {
        allId: [...allIdNew],
        byId: _extends$1({}, state.foldersData.byId, {
          [folderId]: _extends$1({}, state.foldersData.byId[folderId], folder)
        }, newParent)
      })
    });
  },
  [INIT_FOLDER_ERROR]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder.filter(item => item !== action.payload.folderId)]
  }),
  [FETCH_MORE_START]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder, action.payload.folderId]
  }),
  [FETCH_MORE_SUCCESS]: (state, action) => {
    const { folders, folderId } = action.payload;
    const folderByIds = folders.reduce((accum, currentFolder) => _extends$1({}, accum, {
      [currentFolder.id]: currentFolder
    }), {});
    const folderChilds = [...folders.map(item => item.id)];
    return _extends$1({}, state, {
      processingFolder: [...state.processingFolder.filter(item => item !== folderId)],
      expandedFolderIds: [...state.expandedFolderIds, folderId],
      foldersData: _extends$1({}, state.foldersData, {
        allId: uniq([...state.foldersData.allId, ...folders.map(item => item.id)]),
        byId: _extends$1({}, state.foldersData.byId, {
          [folderId]: _extends$1({}, state.foldersData.byId[folderId], {
            childs: folderChilds,
            hasContent: folderChilds.length > 0
          })
        }, folderByIds)
      })
    });
  },
  [FETCH_MORE_ERROR]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder.filter(item => item !== action.payload.folderId)]
  }),
  [SELECT_FOLDER]: (state, action) => {
    const { selected, workSpace } = action.payload;
    return _extends$1({}, state, {
      selectedFolder: _extends$1({}, state.selectedFolder, {
        [workSpace]: selected
      })
    });
  },
  [SELECT_ALL_FOLDER]: (state, action) => _extends$1({}, state, {
    selectedFolder: _extends$1({}, state.searchFolder, {
      [action.payload.workSpace]: state.foldersData.allId.reduce((accum, currentFolderId) => _extends$1({}, accum, {
        [currentFolderId]: true
      }), {})

    })
  }),
  [SEARCH_START]: (state, action) => _extends$1({}, state, {
    currentSearchValue: action.payload.searchValue,
    fetching: true,
    searching: true,
    fetched: false,
    error: false
  }),
  [SEARCH_SUCCESS]: (state, action) => {
    const { searchValue, folders } = action.payload;
    return _extends$1({}, state, {
      fetching: false,
      fetched: true,
      searching: false,
      searchFolderData: _extends$1({}, state.searchFolderData, {
        allId: [...state.searchFolderData.allId, searchValue],
        byId: _extends$1({}, state.searchFolderData.byId, {
          [searchValue]: {
            rootIds: [],
            allId: [...folders.map(item => item.id)],
            byId: _extends$1({}, folders.reduce((accum, currentFolder) => _extends$1({}, accum, {
              [currentFolder.id]: _extends$1({}, currentFolder, {
                parentId: null,
                hasContent: false
              })
            }), {}))
          }
        })
      })
    });
  },
  [SEARCH_ERROR]: (state, action) => _extends$1({}, state, {
    fetching: false,
    fetched: true,
    searching: false,
    error: true
  }),
  [CLEAR_SEARCH$2]: state => _extends$1({}, state, {
    currentSearchValue: ''
  }),
  [DELETE_FOLDER_START]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder, action.payload.folderId]
  }),
  [DELETE_FOLDER_ERROR]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder.filter(item => item !== action.payload.folderId)]
  }),
  [DELETE_FOLDER_SUCCESS]: (state, action) => {
    const { folderId, parentId } = action.payload;
    const targetParentFolder = state.foldersData.byId[parentId] || {};
    if (_isEmpty(targetParentFolder)) {
      return state;
    }
    return _extends$1({}, state, {
      processingFolder: [...state.processingFolder.filter(item => item !== folderId)],
      foldersData: _extends$1({}, state.foldersData, {
        allId: [...state.foldersData.allId.filter(item => item !== folderId)],
        byId: _extends$1({}, _omit(state.foldersData.byId, folderId), {
          [parentId]: _extends$1({}, targetParentFolder, {
            childs: [...targetParentFolder.childs.filter(child => child !== folderId)]
          })
        })
      })
    });
  },
  [EDIT_FOLDER_START]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder, action.payload.folderId]
  }),
  [EDIT_FOLDER_ERROR]: (state, action) => _extends$1({}, state, {
    processingFolder: [...state.processingFolder.filter(item => item !== action.payload.folderId)]
  }),
  [EDIT_FOLDER_SUCCESS]: (state, action) => {
    const { folder } = action.payload;
    const folderId = folder.id;
    const targetFolder = state.foldersData.byId[folderId] || {};
    return _extends$1({}, state, {
      processingFolder: [...state.processingFolder.filter(item => item !== folderId)],
      foldersData: _extends$1({}, state.foldersData, {
        byId: _extends$1({}, state.foldersData.byId, {
          [folderId]: _extends$1({}, targetFolder, folder)
        })
      })
    });
  },
  [UNSELECT_ALL_FOLDER]: (state, action) => _extends$1({}, state, {
    selectedFolder: {}
  }),
  [UNSELECT_FOLDER]: (state, action) => {
    const { workSpace, folderId } = action.payload;
    const selected = state.selectedFolder[workSpace];
    return _extends$1({}, state, {
      selectedFolder: _extends$1({}, state.selectedFolder, {
        [workSpace]: _extends$1({}, _omit(selected, folderId))
      })
    });
  },
  [UNSELECT_CURRENT_FOLDER]: (state, action) => {
    const { workSpace } = action.payload;
    return _extends$1({}, state, {
      selectedFolder: _extends$1({}, state.selectedFolder, {
        [workSpace]: {}
      })
    });
  },
  [EVENT_CHANNEL]: (state, action) => _extends$1({}, state, {
    event: _extends$1({}, state.event, {
      [action.payload.workSpace]: {
        eventType: action.payload.eventType,
        data: action.payload.data
      }
    })
  })
});

function* expandFolder() {
  yield takeEvery(FETCH_MORE, function* (action) {
    const { folderId, isReload } = action.payload;
    const config$1 = yield select(config);
    const rootFolderIds$1 = yield select(rootFolderIds);
    const expandedFolder = yield select(folderExpanded);
    if (includes(rootFolderIds$1, folderId) && !isReload) {
      return;
    }
    if (includes(expandedFolder, folderId)) {
      return yield put(initFolder(folderId));
    }
    const { selectable, workSpace } = config$1;
    return yield expandFolderInFunction(folderId, workSpace, selectable);
  });
}

function* expandFolderInFunction(folderId, workSpace, selectable) {
  yield put(fetchMoreStart(folderId));
  const folders = yield fetchMore$1(folderId);
  const folderReprocess = folders.map(folder => {
    const childs = _get(folder, 'childFolders.records', []);
    return _extends$1({}, folder, {
      parentId: folder.parent.id,
      childs: childs.map(item => item.id)
    });
  });
  yield put(fetchMoreSuccess(folderReprocess, folderId));
  const folderChildId = folderReprocess.map(folder => folder.id);
  const selected$1 = yield select(selected);
  if (_get(selected$1, [workSpace, folderId]) && selectable) {
    const newSelected = _extends$1({}, _get(selected$1, [workSpace], {}), folderChildId.reduce((accum, value) => _extends$1({}, accum, {
      [value]: true
    }), {}));
    yield put(selectFolder(workSpace, newSelected));
  }
}
function* fetchMore$1(folderId) {
  const config$1 = yield select(config);
  const {
    type,
    isEnableShowContent
  } = config$1;
  const initialOffset = 0;
  const pageSize = 30;
  let results = [];
  let contentResult = [];
  const childType = folderType[type].childsType;
  const childContentType = isEnableShowContent ? folderType[type].childs : '';
  const queryFolder = `query folder($id:ID!, $offset: Int, $limit: Int){
      folder(id: $id){
        id
        name
        parent{
          id
        }
        orderIndex
        treeObjectId
        childFolders(offset: $offset, limit: $limit){
          count
          records{
            id
            name
            typeId
            treeObjectId
            parent {
              id
            }
            orderIndex
            childFolders{
              count
            }
            ${isEnableShowContent ? `${childType}{
              count
            }` : ""}
          }
        }
      }
    }`;

  const queryContent = `query folder($id:ID!, $offset: Int, $limit: Int){
      folder(id: $id){
        id
        name
        treeObjectId
        parent{
          id
        }
        ${childType}(offset: $offset, limit: $limit){
          count
          records{
            id
            name
            treeObjectId
          }
        }
      }
    }`;
  function* getChildFolder(offset) {
    if (!_Number$isInteger(parseInt(offset))) {
      return yield put(initFolderError('Something wrong'));
    }
    const variables = {
      id: folderId,
      limit: pageSize,
      offset: offset
    };
    const { error, response } = yield call(handleRequest, { query: queryFolder, variables });
    if (error) {
      yield put(initFolderError(error));
      return results;
    }
    const count = _get(response, 'data.folder.childFolders.count', 0);
    const records = _get(response, 'data.folder.childFolders.records', []);
    const recordsReprocess = records.map(item => {
      const childCount = _get(item, ['childFolders', 'count'], 0);
      const childContentCount = _get(item, [childType, 'count'], 0);
      return _extends$1({}, item, {
        hasContent: childCount > 0 || childContentCount > 0,
        contentType: 'folder'
      });
    });
    results = results.concat(recordsReprocess);
    if (count === pageSize) {
      return yield getChildFolder(offset + pageSize);
    } else {
      return results;
    }
  }
  function* getChildContent(offset) {
    if (!isEnableShowContent) {
      return [];
    }
    if (!_Number$isInteger(parseInt(offset))) {
      yield put(initFolderError('Something wrong'));
      return [];
    }
    const variables = {
      id: folderId,
      limit: pageSize,
      offset: offset
    };
    const { error, response } = yield call(handleRequest, { query: queryContent, variables });
    if (error) {
      yield put(initFolderError(error));
      return contentResult;
    }
    const records = _get(response, ['data', 'folder', childType, 'records'], []);
    const recordsReprocess = records.map(item => _extends$1({}, item, {
      contentType: childContentType,
      parent: {
        id: folderId
      }
    }));
    const count = _get(response, ['data', 'folder', childType, 'count'], 0);
    contentResult = contentResult.concat(recordsReprocess);
    if (count === pageSize) {
      return yield getChildFolder(offset + pageSize);
    } else {
      return contentResult;
    }
  }
  const childFolder = yield getChildFolder(initialOffset);
  const childFolderSorted = orderBy(childFolder, [folder => folder.name.toLowerCase(), 'orderIndex'], ['asc', 'asc']);
  const childContent = yield getChildContent(initialOffset);
  const childContentSorted = orderBy(childContent, [content => content.name.toLowerCase()], ['asc']);
  return [...childFolderSorted, ...childContentSorted];
}

function* initFolder$1() {
  yield all([takeEvery(INIT_ROOT_FOLDER, initRootFolderSagas), takeEvery(INIT_FOLDER$1, initFolderSagas), takeEvery(INIT_FOLDER_FROM_APP, initFolderFromApp$1)]);
}

function* initRootFolderSagas(action) {
  const { config } = action.payload;
  const childType = folderType[config.type].childsType;
  const isEnableOrgFolder = includes(config.showingType, 'org');
  const isEnableOwnerFolder = includes(config.showingType, 'owner');
  yield put(initConfig(_extends$1({}, config, {
    isEnableOrgFolder,
    isEnableOwnerFolder
  })));
  yield put(initRootFolderStart());
  const rootFolderResponse = yield getRootFolder(action);
  if (_isEmpty(rootFolderResponse)) {
    return;
  }
  const orgRootFolder = isEnableOrgFolder ? [_get(rootFolderResponse, ['data', 'rootFolders', 0], {})] : [];
  const ownerRootFolder = isEnableOwnerFolder ? [_get(rootFolderResponse, ['data', 'rootFolders', 1], {})] : [];

  const rootFolderReprocess = [...orgRootFolder, ...ownerRootFolder].map(rootFolder => {
    const childFolderCounts = _get(rootFolder, 'childFolders.count', 0);
    const childContentCounts = _get(rootFolder, [childType, 'count'], 0);
    let folderName = includes(rootFolder.name, config.type) ? folderType[config.type].orgFolderName : folderType[config.type].ownerFolderName;
    return _extends$1({}, rootFolder, {
      id: rootFolder.id,
      name: folderName,
      contentType: 'folder',
      parentId: null,
      hasContent: childFolderCounts > 0 || childContentCounts > 0,
      childs: []
    });
  });
  const rootFolderId = [...orgRootFolder, ...ownerRootFolder].map(folder => folder.id);
  yield all(rootFolderId.map(rootFolderId => {
    return put(fetchMore(rootFolderId, true));
  }));
  yield put(initRootFolderSuccess(rootFolderReprocess, rootFolderId));
}

function* getRootFolder(action) {
  const { config } = action.payload;
  const { type, isEnableShowContent } = config;
  const initialOffset = 0;
  const childType = folderType[config.type].childsType;
  const query = `query rootFolders($type: RootFolderType){
      rootFolders(type: $type){
        id
        name
        treeObjectId
        childFolders{
          count
        }
        ${isEnableShowContent ? `${childType}{
          count
        }` : ""}
      }
    }`;

  function* getRootFolder(offset) {
    if (!_Number$isInteger(parseInt(offset))) {
      return yield put(initRootFolderError());
    }
    const variables = {
      type,
      limit: 30,
      offset: offset
    };
    const { error, response } = yield call(handleRequest, { query, variables });
    if (error) {
      yield put(initRootFolderError());
      return {};
    }
    return response;
  }
  return yield getRootFolder(initialOffset);
}

function* initFolderSagas(action) {
  const { folderId } = action.payload;
  return yield initFolderFn(folderId);
}

function* initFolderFn(folderId) {
  const { type, isEnableShowContent } = yield select(config);
  const rootFolderIds$1 = yield select(rootFolderIds);
  const childType = folderType[type].childsType;
  const query = `query folder($id: ID!){
      folder(id: $id){
        id
        name
        treeObjectId
        parent{
          id
        }
        childFolders{
          count
        }
        ${isEnableShowContent ? `${childType}{
          count
        }` : ""}
      }
    }`;
  const variables = {
    id: folderId
  };
  const { error, response } = yield call(handleRequest, { query, variables });
  if (error) {
    yield put(initFolderError(folderId));
    return {};
  }
  const rootName = folderType[type].orgFolderName;
  const folder = _get(response, 'data.folder', {});
  const childFolderCounts = _get(folder, 'childFolders.count', 0);
  const childContentCounts = _get(folder, [childType, 'count'], 0);
  const childsList = yield fetchMore$1(folderId);
  const folderReprocess = _extends$1({}, folder, {
    contentType: 'folder',
    parentId: folder.parent ? folder.parent.id : null,
    hasContent: childFolderCounts > 0 || childContentCounts > 0,
    name: includes(rootFolderIds$1, folderId) ? rootName : folder.name,
    childs: childsList.map(item => item.id)
  });
  yield put(initFolderSuccess(folderReprocess));
}

function* initFolderFromApp$1(action) {
  const { folderId } = action.payload;
  const { selectable, workSpace } = yield select(config);
  const folderExpanded$1 = yield select(folderExpanded);
  yield put(initFolderFromAppStart(folderId));
  const data = yield initAllParent(folderId);
  const folderFromRoot = [...uniq(data.reverse().filter(item => !includes(folderExpanded$1, item))), folderId];
  for (const folderIdForInit of folderFromRoot) {
    yield expandFolderInFunction(folderIdForInit, selectable, workSpace);
  }
  if (selectable) {
    yield put(selectAllFolder(workSpace));
  } else {
    yield put(selectFolder(workSpace, {
      [folderId]: true
    }));
  }
}

function* initAllParent(folderId) {
  const query = `query folder($id: ID!){
    folder(id: $id){
      id
      name
      parent{
        id
      }
    }
  }`;
  const variables = {
    id: folderId
  };
  const { error, response } = yield call(handleRequest, { query, variables });
  if (error) {
    yield put(initFolderFromAppError(folderId));
  }
  const parentId = _get(response, 'data.folder.parent.id');
  if (parentId) {
    const expand = yield initAllParent(parentId);
    return [parentId, ...expand];
  }
  return [];
}

function* createFolderSaga() {
  yield takeEvery(CREATE_FOLDER, createFolder$1);
}

function* createFolder$1(action) {
  yield put(createFolderStart());
  const {
    name,
    parentId
  } = action.payload;
  const { type: rootFolderType } = yield select(config);
  const query = `
    mutation createFolder($name: String!, $description: String!, $parentId: ID!, $rootFolderType: RootFolderType){
      createFolder(input:{
        name: $name,
        description: $description,
        parentId: $parentId,
        rootFolderType: $rootFolderType
      }){
        id
        name
      }
    }`;
  const variables = {
    name,
    parentId,
    rootFolderType,
    description: ''
  };
  const { error, response } = yield call(handleRequest, { query, variables });
  if (error) {
    yield put(createFolderError());
    yield put(showNotification("Cannot create the folder"));
  }
  const newFolderId = _get(response, 'data.createFolder.id');
  yield put(initFolder(newFolderId));
  yield put(initFolder(parentId));
  return put(createFolderSuccess());
}

function* deleteFolderSaga() {
  yield takeEvery(DELETE_FOLDER, deleteFolder$1);
}

function* deleteFolder$1(action) {
  const { folderId, workSpace } = action.payload;
  const { type: folderRootType } = yield select(config);
  const { childsType, deleteContent } = folderType[folderRootType];
  yield put(deleteFolderStart(folderId));
  const folderSelected = yield select(selected);
  const { selectable } = yield select(config);
  const rootIds = yield select(rootFolderIds);
  const queryFolder = `query folder($id:ID!){
    folder(id: $id){
      id
      name
      orderIndex
      parent {
        id
      }
      treeObjectId
    }
  }`;
  const variablesFolder = {
    id: folderId
  };
  const { error, response } = yield call(handleRequest, {
    query: queryFolder,
    variables: variablesFolder
  });
  if (error) {
    return yield put(deleteFolderError(folderId));
  }
  const { orderIndex, parent, treeObjectId } = _get(response, 'data.folder', {});
  const { childContents, childFolders } = yield getAllContent(folderId, childsType);
  if (childContents.length) {
    const deleteContentQuery = `
    mutation ${deleteContent}($id: ID!){
      ${deleteContent}(id: $id) {
        id
      }
    }`;
    yield all(childContents.map(content => call(handleRequest, { query: deleteContentQuery, variables: { id: content.id } })));
  }
  const query = `
    mutation deleteFolder($id: ID!,$orderIndex: Int! ){
      deleteFolder(input:{
        id: $id,
        orderIndex: $orderIndex
      })
      {
        id
      }
    }
  `;
  const variables = {
    id: treeObjectId,
    orderIndex
  };
  const { error: errorDelete } = yield call(handleRequest, { query, variables });
  if (errorDelete) {
    yield put(deleteFolderError(folderId));
    yield put(showNotification("Cannot delete the folder"));
  }
  yield put(initFolder(parent.id));
  const folderSelectedIds = _Object$keys(_get(folderSelected, [workSpace], {}));
  const deletedFolderIds = [...childFolders.map(item => item.id), folderId];
  if (!selectable) {
    if (includes(deletedFolderIds, _get(folderSelectedIds, 0))) {
      yield put(selectFolder(workSpace, {
        [rootIds[0]]: true
      }));
    }
  } else {
    const newSelected = _omit(folderSelected, [...deletedFolderIds]);
    yield put(selectFolder(workSpace, newSelected));
  }
  yield put(deleteFolderSuccess(folderId, parent.id));
  yield put(showNotification("Delete folder successful"));
  return yield put(updateSearchData());
}

function* getAllContent(folderId, childsType) {
  let contentArr = [];
  let folderArr = [];
  function* getContents(currentId) {
    const queryFolder = `query folder($id:ID!){
      folder(id: $id){
        id
        name
        orderIndex
        parent {
          id
        }
        treeObjectId
        childFolders(offset: 0, limit: 999) {
          records {
            id
            name
          }
        }
        ${childsType}(limit: 999) {
          records {
            id
            name
          }
        }
      }
    }`;
    const variablesFolder = {
      id: currentId
    };
    const { error, response } = yield call(handleRequest, {
      query: queryFolder,
      variables: variablesFolder
    });
    if (error) {
      return [];
    }
    const childFolders = _get(response, 'data.folder.childFolders.records', []);
    const childContents = _get(response, ['data', 'folder', childsType, 'records'], []);
    if (childFolders.length > 0) {
      yield all(childFolders.map(folder => getContents(folder.id)));
    }
    contentArr = contentArr.concat(childContents);
    folderArr = folderArr.concat(childFolders);
  }
  yield getContents(folderId);
  return {
    childContents: contentArr,
    childFolders: folderArr
  };
}

function* modifyFolderSaga() {
  yield takeEvery(EDIT_FOLDER, modifyFolder$1);
}
function* modifyFolder$1(action) {
  const {
    folderId,
    folderName,
    isEditName,
    isMoveFolder,
    parentId
  } = action.payload;
  let folder;
  yield put(modifyFolderStart(folderId));
  const { type: rootFolderType } = yield select(config);
  //get tree object and parent tree object
  const queryFolder = `query folder($id:ID!){
    folder(id: $id){
      id
      name
      orderIndex
      parent{
        id
        treeObjectId
      }
      treeObjectId
    }
  }`;
  const variablesFolder = {
    id: folderId
  };
  const { error, response } = yield call(handleRequest, {
    query: queryFolder,
    variables: variablesFolder
  });
  if (error) {
    return yield put(deleteFolderError(folderId));
  }
  const {
    treeObjectId,
    parent: oldParent,
    orderIndex: prevOrderIndex
  } = _get(response, 'data.folder', {});
  //edit name
  if (isEditName) {
    const updateNameQuery = `
    mutation updateFolder($id: ID!, $name: String!){
      updateFolder(input: {
        id: $id,
        name: $name,
      }) {
        id
        treeObjectId
        name,
        parent {
          id
        }
      }
    }
  `;
    const variables = {
      name: folderName,
      id: treeObjectId
    };
    const {
      error: errorEditName,
      response: responseEditName
    } = yield call(handleRequest, {
      query: updateNameQuery,
      variables
    });
    if (errorEditName) {
      yield put(modifyFolderError(folderId));
      yield put(showNotification("Cannot edit the folder"));
    }
    folder = _get(responseEditName, 'data.updateFolder', {});
    yield put(modifyFolderSuccess(_extends$1({}, folder, {
      id: folder.id,
      name: folder.name,
      parentId: _get(folder, 'parent.id', '')
    })));
  }
  //move folder
  if (isMoveFolder) {
    const newParentVariables = {
      id: parentId
    };
    const {
      error: newParentError,
      response: newParentResponse
    } = yield call(handleRequest, {
      query: queryFolder,
      variables: newParentVariables
    });
    if (newParentError) {
      return yield put(deleteFolderError(folderId));
    }
    const { treeObjectId: newParentTreeObjectId } = _get(newParentResponse, 'data.folder', {});
    const { treeObjectId: prevParentTreeObjectId } = oldParent;
    const moveQuery = `
      mutation moveFolder(
        $treeObjectId: ID!,
        $prevParentTreeObjectId: ID!
        $newParentTreeObjectId: ID!
        $newOrderIndex: Int!
        $prevOrderIndex: Int!
        $rootFolderType: RootFolderType
        ){
        moveFolder(input: {
          treeObjectId: $treeObjectId,
          newParentTreeObjectId: $newParentTreeObjectId,
          prevParentTreeObjectId: $prevParentTreeObjectId,
          newOrderIndex: $newOrderIndex,
          prevOrderIndex: $prevOrderIndex
          rootFolderType: $rootFolderType
        }) {
          id
          orderIndex
          name
          modifiedDateTime
          parent {
            id
            treeObjectId
          }
        }
      }
    `;
    const moveVariables = {
      rootFolderType,
      treeObjectId,
      newParentTreeObjectId,
      prevParentTreeObjectId,
      prevOrderIndex,
      newOrderIndex: 0
    };
    const { error: moveError, response: moveRespone } = yield call(handleRequest, {
      query: moveQuery,
      variables: moveVariables
    });
    if (moveError) {
      yield put(showNotification("Cannot move the folder"));
      return yield put(modifyFolderError(folderId));
    }
    folder = _get(moveRespone, 'data.moveFolder', {});
    yield put(modifyFolderSuccess(_extends$1({}, folder, {
      id: folder.id,
      name: folder.name,
      parentId: _get(folder, 'parent.id', '')
    })));
    yield put(fetchMore(parentId, true));
  }
  yield put(fetchMore(oldParent.id, true));
  yield put(updateSearchData());
}

function* searchSaga() {
  yield all([takeEvery(SEARCH_FOLDER, searchFolderSaga), takeEvery(SEARCH_UPDATE_DATA, updateSeachDataSaga)]);
}
function* searchFolderSaga(action) {
  const {
    searchValue
  } = action.payload;
  yield put(searchFolderStart(searchValue));
  const foldersData = yield select(folderData);
  const folderDataLocal = _Object$values(foldersData.byId);
  const folderSearched = folderDataLocal.filter(item => includes(toLower(item.name), toLower(searchValue))).map(item => _extends$1({}, item, {
    childs: []
  }));
  yield put(searchFolderSuccess(searchValue, folderSearched));
}
function* updateSeachDataSaga(action) {
  const searchValue = yield select(searchValue$1);
  if (searchValue) {
    yield put(searchFolder(searchValue));
  }
}

/* eslint-disable lodash/path-style */

function* folderSaga() {
  yield all([fork(initFolder$1), fork(expandFolder), fork(searchSaga), fork(createFolderSaga), fork(deleteFolderSaga), fork(modifyFolderSaga)]);
}



var index$5 = /*#__PURE__*/Object.freeze({
	fetchMore: fetchMore,
	initRootFolder: initRootFolder,
	initFolder: initFolder,
	createFolder: createFolder,
	deleteFolder: deleteFolder,
	modifyFolder: modifyFolder,
	searchFolder: searchFolder,
	updateSearchData: updateSearchData,
	clearSearchData: clearSearchData,
	selectFolder: selectFolder,
	selectAllFolder: selectAllFolder,
	initFolderFromApp: initFolderFromApp,
	unSelectFolder: unSelectFolder,
	unSelectAllFolder: unSelectAllFolder,
	unSelectCurrentFolder: unSelectCurrentFolder,
	eventChannel: eventChannel,
	folderSaga: folderSaga,
	namespace: namespace$8,
	folderSelector: folderSelector,
	'default': folderReducer,
	folderType: folderType
});

const {
  user: { reducer: userReducer, namespace: userNamespace },
  config: { reducer: configReducer, namespace: configNamespace },
  auth: { reducer: authReducer, namespace: authNamespace },
  engine: { reducer: engineReducer, namespace: engineNamespace }
} = modules;

const reducers = {
  [namespace$1]: filePickerReducer,
  [namespace$2]: reducer$1,
  [namespace$3]: dataPickerReducer,
  [namespace$4]: engineSelectionReducer,
  [namespace$6]: reducer$3,
  [namespace$7]: engineOutputExportReducer,
  [configNamespace]: configReducer,
  [namespace$5]: reducer$2,
  [userNamespace]: userReducer,
  [authNamespace]: authReducer,
  [namespace]: reducer,
  [engineNamespace]: engineReducer,
  [namespace$8]: folderReducer,
  player: playerReducer,
  operation: operationReducer,
  form: formReducer
};

function createReducer$a(asyncReducers) {
  return combineReducers(_extends$1({}, reducers, asyncReducers));
}

const { user: userModule, auth: authModule$1 } = modules;

function* handleAppAuth() {
  try {
    const res = yield putResolve(userModule.fetchUser());
    if (_get(res, 'error')) {
      throw res.payload;
    }
    // get each widget to call its onauth dependencies
    // put widgets into store and select them?
    const widgets$1 = yield select(widgets);
    for (let widget of widgets$1) {
      if (_isFunction(widget.veritoneAppDidAuthenticate)) {
        yield call(widget.veritoneAppDidAuthenticate);
      }
    }
  } catch (e) {
    // todo: add onAuthFailedCallback or something similar to VeritoneApp?
    // how does external user know if auth failed?
  }
}

function* watchAppAuth() {
  yield takeLatest([
  // fetch when we get a token, re-fetch if a new token is set
  authModule$1.SET_SESSION_TOKEN, authModule$1.SET_OAUTH_TOKEN,
  // fetch if an grant is completed
  authModule$1.OAUTH_GRANT_FLOW_SUCCESS,
  // try to fetch StartupDependencies with no token
  authModule$1.CHECK_AUTH_NO_TOKEN], handleAppAuth);
}

function* root() {
  yield fork(watchAppAuth);
}

// adapted from

function uploadFilesChannel(uploadDescriptors, files, method = 'PUT') {
  if (uploadDescriptors.length !== files.length) {
    throw new Error('Need an upload descriptor for each file to be uploaded!');
  }

  const requestMap = {};
  const chan = channel(buffers.sliding(2));
  let remainingFiles = files.length;

  const onFileProgress = (file, descriptor, { lengthComputable, loaded, total }) => {
    if (lengthComputable) {
      const progress = loaded / total * 100;
      chan.put({ progress, file, descriptor });
    }
  };

  const onStatusCodeFailure = (file, descriptor) => {
    chan.put({ error: 'Upload failed', file, descriptor });
  };

  const onXHRError = (file, descriptor, e) => {
    chan.put({ error: 'File upload error', file, descriptor });
  };

  const onStatusCodeAbort = (file, descriptor) => {
    chan.put({ error: 'Upload failed', aborted: 'Upload aborted', file, descriptor });
  };

  const onFileReadyStateChange = (file, descriptor, { target: { readyState, status } }) => {
    if (readyState === XMLHttpRequest.DONE) {
      remainingFiles -= 1;
      // Remove from requestMap cuz it finished
      delete requestMap[descriptor.key];

      if (status >= 200 && status < 300) {
        chan.put({ success: true, file, descriptor });
      } else if (status == 0) {
        onStatusCodeAbort(file, descriptor);
      } else {
        onStatusCodeFailure(file, descriptor);
      }

      if (remainingFiles === 0) {
        chan.put(END);
      }
    }
  };

  files.forEach((file, i) => {
    const descriptor = uploadDescriptors[i];
    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('progress', onFileProgress.bind(null, file, descriptor));
    xhr.upload.addEventListener('error', onXHRError.bind(null, file, descriptor));
    xhr.onreadystatechange = onFileReadyStateChange.bind(null, file, descriptor);

    // Add to requestMap to enable abortions
    if (descriptor.key) {
      requestMap[descriptor.key] = xhr;
    }

    xhr.open(method, descriptor.url, true);
    // Need this header for azure
    xhr.setRequestHeader('x-ms-blob-type', 'BlockBlob');
    xhr.send(file);
  });

  return {
    channel: chan,
    requestMap
  };
}

const { auth: authModule$2, config: configModule$1, getExtraHeaders: getExtraHeaders$1 } = modules;
const { fetchGraphQLApi: fetchGraphQLApi$2 } = helpers;

let requestMap;

function* finishUpload(id, result, { warning, error }, callback) {
  yield put(uploadComplete(id, result, { warning, error }));

  if (warning || error) {
    // There are failed uploads, don't close out and display error screen
    return;
  }
  yield put(endPick(id));
  // Get accumulated results, not just what's in the current upload/retry request
  // If there's no results, then the user must have aborted them all
  const totalResults = yield select(uploadResult, id);
  yield call(callback, totalResults, {
    warning,
    error,
    cancelled: !totalResults.length
  });
}

function* uploadFileSaga(id, fileOrFiles, callback = _noop) {
  const files = _isArray$1(fileOrFiles) ? fileOrFiles : [fileOrFiles];
  const getUrlQuery = `query urls($name: String!){
        getSignedWritableUrl(key: $name) {
          url
          key
          bucket
          expiresInSeconds
          getUrl
          unsignedUrl
        }
      }`;

  const config = yield select(configModule$1.getConfig);
  const extraHeaders = yield select(getExtraHeaders$1);
  const { apiRoot, graphQLEndpoint } = config;
  const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;
  const sessionToken = yield select(authModule$2.selectSessionToken);
  const oauthToken = yield select(authModule$2.selectOAuthToken);

  // get a signed URL for each object to be uploaded
  let signedWritableUrlResponses;
  try {
    signedWritableUrlResponses = yield all(files.map(({ name }) => call(fetchGraphQLApi$2, {
      endpoint: graphQLUrl,
      query: getUrlQuery,
      // todo: add uuid to $name to prevent naming conflicts
      variables: { name },
      extraHeaders,
      token: sessionToken || oauthToken
    })));
  } catch (error) {
    return yield* finishUpload(id, null, { error }, callback);
  }

  let uploadDescriptors; // { url, key, bucket, etc }
  try {
    uploadDescriptors = signedWritableUrlResponses.map(({ data: { getSignedWritableUrl }, errors }) => {
      if (errors && errors.length) {
        throw new Error(`Call to getSignedWritableUrl returned error: ${errors[0].message}`);
      }

      return getSignedWritableUrl;
    });
  } catch (e) {
    return yield* finishUpload(id, null, { error: e.message }, callback);
  }

  let resultChan;
  try {
    const uploadChannelResult = yield call(uploadFilesChannel, uploadDescriptors, files);
    resultChan = uploadChannelResult.channel;
    requestMap = uploadChannelResult.requestMap;
  } catch (error) {
    return yield* finishUpload(id, null, { error }, callback);
  }

  let result = [];

  while (result.length !== files.length) {
    const {
      progress = 0,
      aborted,
      error,
      success,
      file,
      descriptor: { key, bucket, expiresInSeconds, getUrl, unsignedUrl }
    } = yield take(resultChan);

    if (success || error) {
      yield put(uploadProgress(id, key, {
        name: file.name,
        type: file.type,
        size: file.size,
        error,
        aborted,
        percent: 100
      }));

      result.push({
        key,
        bucket,
        expiresInSeconds,
        fileName: file.name,
        size: file.size,
        type: file.type,
        aborted,
        error: error || false,
        unsignedUrl: error ? null : unsignedUrl,
        getUrl: error ? null : getUrl,
        file
      });

      continue;
    }

    yield put(uploadProgress(id, key, {
      name: file.name,
      type: file.type,
      size: file.size,
      percent: progress
    }));
  }

  // Remove aborted requests
  result = result.filter(r => !r.aborted);

  const isError = result.length && result.every(e => e.error);
  const isWarning = !isError && result.some(e => e.error);

  yield* finishUpload(id, result, {
    warning: isWarning ? 'Some files failed to upload.' : false,
    error: isError ? 'All files failed to upload.' : false
  }, callback);
}

function* watchUploadRequest() {
  yield takeEvery(UPLOAD_REQUEST, function* (action) {
    const { files, callback } = action.payload;
    const { id } = action.meta;
    yield call(uploadFileSaga, id, files, callback);
  });
}

function* watchRetryRequest() {
  yield takeEvery(RETRY_REQUEST, function* (action) {
    const { callback } = action.payload;
    const { id } = action.meta;
    const erroredFiles = yield select(failedFiles, id) || [];
    yield call(uploadFileSaga, id, erroredFiles, callback);
  });
}

function* watchRetryDone() {
  yield takeEvery(RETRY_DONE, function* (action) {
    const { callback } = action.payload;
    const { id } = action.meta;
    const uploads = yield select(uploadResult, id) || [];
    const completedUploads = uploads.filter(upload => !upload.error);

    yield put(endPick(id));
    yield call(callback, completedUploads, {
      cancelled: !completedUploads.length
    });
  });
}

function* watchAbortions() {
  yield takeEvery(ABORT_REQUEST, function* (action) {
    if (!requestMap) {
      return;
    }
    const { fileKey } = action.meta;
    // Abort requests somehow
    if (fileKey && requestMap[fileKey]) {
      yield requestMap[fileKey].abort && requestMap[fileKey].abort();
      delete requestMap[fileKey];
    } else {
      _Object$keys(requestMap).forEach(fileKey => {
        requestMap[fileKey].abort && requestMap[fileKey].abort();
        delete requestMap[fileKey];
      });
    }
  });
}

function* root$1() {
  yield all([fork(watchUploadRequest), fork(watchRetryRequest), fork(watchRetryDone), fork(watchAbortions)]);
}

const {
  auth: authModule$3,
  config: configModule$2,
  getExtraHeaders: getExtraHeaders$2
} = modules;

const ROOT_ID = 'root';
const DEFAULT_PAGE_SIZE = 30;
const TDO_FRAGMENTS = `
  id
  name
  startDateTime
  stopDateTime
  thumbnailUrl
  sourceImageUrl
  primaryAsset (assetType: "media") {
    id
    name
    contentType
    signedUri
  }
  createdDateTime
  modifiedDateTime
  streams {
    uri
    protocol
  }
`;

function* getGqlParams$1() {
  const config = yield select(configModule$2.getConfig);
  const extraHeaders = yield select(getExtraHeaders$2);
  const { apiRoot, graphQLEndpoint } = config;
  const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;
  const sessionToken = yield select(authModule$3.selectSessionToken);
  const oauthToken = yield select(authModule$3.selectOAuthToken);
  const token = sessionToken || oauthToken;
  return {
    graphQLUrl,
    token,
    extraHeaders
  };
}

const { fetchGraphQLApi: fetchGraphQLApi$3 } = helpers;
const {
  user: userModule$1,
  getExtraHeaders: getExtraHeaders$3
} = modules;

const template = {
  type: 'folder',
  isEnabled,
  selectType: 'tdo',
  initialization: initializeFolderData,
  pagination: fetchFolderPage
};

function* isEnabled(payload) {
  if (!payload) {
    return false;
  }
  const {
    enableFolders
  } = payload;
  const orgEnableFolders = yield select(userModule$1.hasFeature, 'cmsFolders');
  return enableFolders && orgEnableFolders;
}

function* initializeFolderData(id, refreshCache) {
  const {
    graphQLUrl,
    token
  } = yield getGqlParams$1();
  const getItem = yield select(getItemByTypeAndId);
  const extraHeaders = yield select(getExtraHeaders$3);
  const cachedFolderData = getItem(template.type, ROOT_ID);
  let itemDataPayload = {};
  // Get root folders
  if (refreshCache || !cachedFolderData) {
    const rootQuery = `mutation rootFolder {
      createRootFolders (rootFolderType: cms) {
        id
        name
        createdDateTime
        modifiedDateTime
        ownerId
      }
    }`;
    try {
      const rootFolderResponse = yield call(fetchGraphQLApi$3, {
        endpoint: graphQLUrl,
        query: rootQuery,
        extraHeaders,
        token
      });
      const error = _get(rootFolderResponse, 'errors[0].message');
      if (error) {
        throw error;
      }
      const rootFolder = _get(rootFolderResponse, 'data.createRootFolders');
      const orgRootFolder = rootFolder.find(folder => !folder.ownerId);
      itemDataPayload = {
        [`${template.type}:${ROOT_ID}`]: _extends$1({}, orgRootFolder, {
          nodeIds: [],
          leafIds: []
        })
      };
    } catch (error) {
      itemDataPayload = {
        [`${template.type}:${ROOT_ID}`]: {
          nodeIds: [],
          leafIds: [],
          error
        }
      };
    }
  }

  yield put({
    type: INIT_FOLDER,
    meta: { id },
    payload: itemDataPayload
  });
  // Initialize first page of root
  if (refreshCache || !cachedFolderData) {
    yield put({
      type: FETCH_PAGE,
      meta: { id }
    });
  }

  return true;
}

function* fetchFolderPage(currentNode, id) {
  const {
    graphQLUrl,
    token,
    extraHeaders
  } = yield getGqlParams$1();
  const currentFolderId = currentNode.id;
  const { nodeOffset = 0, leafOffset = 0 } = currentNode;
  const result = {
    itemData: {},
    nodeIds: [],
    leafIds: [],
    nodeOffset,
    leafOffset
  };
  if (nodeOffset >= 0) {
    const query = `{
      folder (id: "${currentFolderId}") {
        childFolders (limit: ${DEFAULT_PAGE_SIZE}, offset: ${nodeOffset}) {
          records {
            id
            name
            description
            createdDateTime
            modifiedDateTime
          }
        }
      }
    }`;
    try {
      const childFolderResponse = yield call(fetchGraphQLApi$3, {
        endpoint: graphQLUrl,
        query,
        extraHeaders,
        token
      });

      const error = _get(childFolderResponse, 'errors[0].message');
      if (error) {
        throw error;
      }
      const childFolders = _get(childFolderResponse, 'data.folder.childFolders.records', []);
      childFolders.forEach(item => {
        item.type = 'folder';
        item.nodeIds = [];
        item.leafIds = [];
      });
      result.nodeIds = childFolders.map(folder => ({ id: folder.id, type: template.type }));
      result.itemData = childFolders.reduce((acc, folder) => {
        acc[`${template.type}:${folder.id}`] = folder;
        return acc;
      }, result.itemData);
      // Prevent further pagination
      if (result.nodeIds.length < DEFAULT_PAGE_SIZE) {
        result.nodeOffset = -1;
      } else {
        result.nodeOffset = nodeOffset + DEFAULT_PAGE_SIZE;
      }
    } catch (error) {
      yield put({
        type: ERRORED_PAGE,
        meta: { id },
        payload: error
      });
      return;
    }
  }
  if (leafOffset >= 0 || nodeOffset >= 0 && result.nodeIds.length < DEFAULT_PAGE_SIZE) {
    const query = `{
      folder (id: "${currentFolderId}") {
        childTDOs (limit: ${DEFAULT_PAGE_SIZE}, offset: ${leafOffset}) {
          records {
            ${TDO_FRAGMENTS}
          }
        }
      }
    }`;
    try {
      const childTdoResponse = yield call(fetchGraphQLApi$3, {
        endpoint: graphQLUrl,
        query,
        extraHeaders,
        token
      });
      const error = _get(childTdoResponse, 'errors[0].message');
      if (error) {
        throw error;
      }
      const childTDOs = _get(childTdoResponse, 'data.folder.childTDOs.records', []);
      childTDOs.forEach(item => {
        item.type = 'tdo';
      });
      result.leafIds = childTDOs.map(tdo => ({
        id: tdo.id,
        type: 'tdo'
      }));
      result.itemData = childTDOs.reduce((acc, tdo) => {
        acc[`tdo:${tdo.id}`] = tdo;
        return acc;
      }, result.itemData);
      if (result.leafIds.length < DEFAULT_PAGE_SIZE) {
        result.leafOffset = -1;
      } else {
        result.leafOffset = leafOffset + DEFAULT_PAGE_SIZE;
      }
    } catch (error) {
      yield put({
        type: ERRORED_PAGE,
        meta: { id },
        payload: error
      });
      return;
    }
  }
  return result;
}

const { fetchGraphQLApi: fetchGraphQLApi$4 } = helpers;
const {
  user: userModule$2
} = modules;

const template$1 = {
  type: 'upload',
  isEnabled: isEnabled$1,
  selectType: 'tdo',
  initialization: initializeUploadData,
  watchers: [watchUploadToTDO, watchRetryRequest$1, watchRetryDone$1]
};

const WEBSTREAM_ADAPTER_ID = '9e611ad7-2d3b-48f6-a51b-0a1ba40feab4';

function* isEnabled$1(payload) {
  if (!payload) {
    return false;
  }
  const {
    enableUploads
  } = payload;
  const orgDisableUploads = yield select(userModule$2.hasFeature, 'disableCmsUpload');
  return enableUploads && !orgDisableUploads;
}

function* initializeUploadData(id) {
  yield put({
    type: INIT_UPLOAD,
    meta: { id }
  });
}

function* watchUploadToTDO() {
  yield takeEvery(UPLOAD_TO_TDO, function* (action) {
    // Upload files, use s3 urls to create TDOs, and select TDOs
    const { id } = action.meta;
    const { files, callback } = action.payload;
    yield put({
      type: UPLOAD_REQUEST,
      meta: { id },
      payload: {
        files,
        callback: createTDOsFromFiles(id, callback)
      }
    });
  });
}

function* watchRetryRequest$1() {
  yield takeEvery(RETRY_REQUEST$1, function* (action) {
    // Wrap filepicker retry request
    const { callback } = action.payload;
    const { id } = action.meta;

    yield put({
      type: RETRY_REQUEST,
      meta: { id },
      payload: {
        callback: createTDOsFromFiles(id, callback)
      }
    });
  });
}

function* watchRetryDone$1() {
  yield takeEvery(RETRY_DONE$1, function* (action) {
    // Wrap filepicker retry done
    const { callback } = action.payload;
    const { id } = action.meta;

    yield put({
      type: RETRY_DONE,
      meta: { id },
      payload: {
        callback: createTDOsFromFiles(id, callback)
      }
    });
  });
}

function createTDOsFromFiles(id, callback) {
  return function* (signedFiles, { warning, error, cancelled }) {
    // Create TDO w/ asset to set full primary asset for immediate reprocessing
    // then launch webstream adapter against it to enable playback
    const currentNode = yield select(getCurrentNode, id);
    let createdTDOs = [],
        createdJobIds = [];
    if (!cancelled && signedFiles.length) {
      const tdoResponses = yield signedFiles.map(function* (signedFile) {
        return yield createTDOWithAsset(signedFile, currentNode);
      });
      createdTDOs = tdoResponses.map(res => _get(res, 'data.createTDOWithAsset', currentNode));

      const jobResponses = yield createdTDOs.map(function* (tdo) {
        return yield createInitialJob(tdo);
      });
      createdJobIds = jobResponses.map(res => _get(res, 'data.createJob.id'));
      console.log('Created Job Ids: ', createdJobIds);
    }
    yield put({
      type: CLEAR_FILEPICKER_DATA,
      meta: { id }
    });
    yield put({
      type: PICK_END$1,
      meta: { id }
    });
    callback(createdTDOs, { warning, error, cancelled });
  };
}

function* createTDOWithAsset(signedFile, currentNode) {
  const {
    graphQLUrl,
    token,
    extraHeaders
  } = yield getGqlParams$1();
  const query = `mutation ($input: CreateTDOWithAsset!) {
    createTDOWithAsset(input: $input) {
      ${TDO_FRAGMENTS}
    }
  }`;
  const variables = {
    input: {
      name: signedFile.fileName,
      contentType: signedFile.type,
      uri: signedFile.unsignedUrl,
      startDateTime: new Date().toISOString(),
      updateStopDateTimeFromAsset: true,
      sourceId: '-1',
      isPublic: false,
      assetType: 'media',
      addToIndex: true,
      sourceData: {
        sourceId: '-1'
      }
    }
  };
  // Current node may not exist if only Upload is enabled
  if (currentNode && currentNode.id) {
    variables.input.parentFolderId = currentNode.id;
  }
  return yield call(fetchGraphQLApi$4, {
    endpoint: graphQLUrl,
    query,
    variables,
    extraHeaders,
    token
  });
}

function* createInitialJob(tdo) {
  const {
    graphQLUrl,
    token,
    extraHeaders
  } = yield getGqlParams$1();
  const query = `mutation ($input: CreateJob!) {
    createJob(input: $input) {
      id
    }
  }`;
  const variables = {
    input: {
      targetId: tdo.id,
      tasks: [{
        engineId: WEBSTREAM_ADAPTER_ID, // Webstream Adapter
        payload: {
          tdoId: tdo.id,
          url: tdo.primaryAsset.signedUri
        }
      }]
    }
  };
  return yield call(fetchGraphQLApi$4, {
    endpoint: graphQLUrl,
    query,
    variables,
    extraHeaders,
    token
  });
}

// import {
//   call,
//   put,
//   select
// } from 'redux-saga/effects';
// import { modules, helpers } from 'veritone-redux-common';
// import { get } from 'lodash';
// import {
//   DEFAULT_PAGE_SIZE,
//   TDO_FRAGMENTS
// } from './helper';
// import {
//   SET_SEARCH_VALUE,
//   FETCH_PAGE,
//   ERRORED_PAGE,
//   getItemByTypeAndId
// } from './';

// const { fetchGraphQLApi } = helpers;
// const {
//   user: userModule
// } = modules;

const template$2 = {
  type: 'search',
  selectType: 'tdo'
  // pagination: fetchSearchPage,
  // watchers: [watchOnSearch]
};

// function* fetchSearchPage(currentNode, id) {
//   console.log(currentNode, id);
// }

// function* watchOnSearch() {
//   yield takeEvery(SET_SEARCH_VALUE, function* (action) {
//     const { id } = action.meta;
//     // const searchValue = action.payload;

//     yield put({
//       type: FETCH_PAGE,
//       meta: { id }
//     });
//   });
// }

const PICKER_MODE_TEMPLATES = [template, template$1];

const PAGINATION_MAP = PICKER_MODE_TEMPLATES.reduce((acc, template) => {
  if (template.pagination) {
    acc[template.type] = template.pagination;
  }
  return acc;
}, {});

function* watchPickStart() {
  yield takeEvery(PICK_START$1, function* (action) {
    const { id } = action.meta;

    let pickerType,
        availablePickerTypes = [];
    yield all(PICKER_MODE_TEMPLATES.map(function* (template) {
      const isEnabled = yield template.isEnabled(action.payload);
      if (isEnabled) {
        pickerType = pickerType || template.type;
        availablePickerTypes.push(template.type);
      }
    }));

    yield put({
      type: INIT_PICKER_TYPE,
      meta: { id },
      payload: {
        currentPickerType: pickerType,
        availablePickerTypes
      }
    });

    yield all(PICKER_MODE_TEMPLATES.map(function* (template) {
      const isEnabled = yield template.isEnabled(action.payload);
      if (isEnabled) {
        yield template.initialization(id);
      }
    }));
  });
}

// Fetch the next page for the currentPickerType
//  Folders - fetch subfolders first. once exhausted, then fetch TDOs
//  Search - if searchValue is populated, fetch search results
function* watchPagination() {
  yield takeEvery(FETCH_PAGE, function* (action) {
    const { id } = action.meta;
    let pickerType = yield select(currentPickerType, id);
    const currentNode = yield select(getCurrentNode, id);
    const triggerSearch = yield select(searchValue, id);

    if (!currentNode) {
      return;
    }

    // If searchValue is populated then trigger search pagination
    if (triggerSearch) {
      pickerType = template$2.type;
    }

    let result;
    if (PAGINATION_MAP[pickerType]) {
      result = yield PAGINATION_MAP[pickerType](currentNode, id);
    }

    if (result) {
      yield put({
        type: LOADED_PAGE,
        meta: { id },
        payload: result
      });
    }
  });
}

function* root$2() {
  const allWatchers = PICKER_MODE_TEMPLATES.filter(template => template.watchers).reduce((acc, template) => acc.concat(template.watchers), []).map(watcher => fork(watcher));

  yield all([fork(watchPickStart), fork(watchPagination), ...allWatchers]);
}

function* fetchEngines$1(id) {
  yield put(refetchEngines(id));
}

function* getCachedResults(id) {
  return yield select(getCurrentResults, id);
}

function* watchRefetchEngineActions() {
  const refetchTypes = [SEARCH, CLEAR_SEARCH$1, ADD_FILTER, REMOVE_FILTER, CHANGE_TAB];

  yield takeLatest(refetchTypes, function* onInvalidateAction({
    meta: { id }
  }) {
    let cachedResults = yield* getCachedResults(id);

    if (!cachedResults) {
      yield* fetchEngines$1(id);
    }
  });
}

function* root$3() {
  yield fork(watchRefetchEngineActions);
}

// URI Parser from https://stackoverflow.com/a/39308026

// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return `${s4()}-${s4()}-${s4()}`;
}

function* watchErrors() {
  yield takeEvery([FETCH_ENGINE_RUNS_FAILURE, EXPORT_AND_DOWNLOAD_FAILURE], function* onError(action) {
    if (action.error) {
      let message;
      switch (action.type) {
        case FETCH_ENGINE_RUNS_FAILURE:
          if (_get(action, 'payload[0].name') === 'not_found') {
            message = 'Unable to export due to restricted file access';
          } else {
            message = 'Failed to get engine runs for one or more recordings.';
          }
          break;
        case EXPORT_AND_DOWNLOAD_FAILURE:
          if (_get(action, 'payload.name') === 'no_formats_selected') {
            message = _get(action, 'payload.message');
          } else {
            message = 'Failed to export.';
          }
          break;
        default:
          message = action.payload.message;
          break;
      }
      yield put(addSnackBar({
        id: guid(),
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        open: true,
        message: message,
        variant: 'error'
      }));
    }
  });
}

function* watchApplySubtitleConfigs() {
  yield takeEvery(APPLY_SUBTITLE_CONFIGS, function* onApplySubtitleConfigs({
    payload: { categoryId, values }
  }) {
    yield put(storeSubtitleConfigs(categoryId, values));
  });
}

function* root$4() {
  yield all([fork(watchErrors), fork(watchApplySubtitleConfigs)]);
}

const {
  user: {
    RESET_USER_PASSWORD_SUCCESS,
    RESET_USER_PASSWORD_FAILURE,
    UPDATE_CURRENT_USER_PROFILE_SUCCESS,
    UPDATE_CURRENT_USER_PROFILE_FAILURE
  }
} = modules;

function* handleChangeUser({ error }) {
  if (error) {
    yield put(showNotification('Unable to update user; please try again.'));
    return;
  }

  yield put(showNotification('User was updated successfully.'));
}

function* handleResetPassword({ error }) {
  if (error) {
    yield put(showNotification('Password reset failed. Please try again.'));
  } else {
    yield put(showNotification('Password reset email was sent.'));
  }
}

function* watchResetPassword() {
  yield takeLatest([RESET_USER_PASSWORD_SUCCESS, RESET_USER_PASSWORD_FAILURE], handleResetPassword);
}

function* watchChangeUser() {
  yield takeLatest([UPDATE_CURRENT_USER_PROFILE_SUCCESS, UPDATE_CURRENT_USER_PROFILE_FAILURE], handleChangeUser);
}

function* root$5() {
  yield all([fork(watchResetPassword), fork(watchChangeUser)]);
}

const {
  auth: { authRootSaga }
} = modules;

function* root$6() {
  yield all([fork(authRootSaga), fork(root$1), fork(root$2), fork(root), fork(root$3), fork(root$4), fork(root$5), fork(folderSaga)]);
}

// Redux devtools browser extension hook
// this has no effect unless the user has the chrome devtools extension installed.
// https://medium.com/@zalmoxis/using-redux-devtools-in-production-4c5b56c5600f
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  stateSanitizer: state => _extends$1({}, state, {
    veritoneApp: '(omitted)'
  })
}) : compose;
const sagaMiddleware = createSagaMiddleware();

const enhancer = composeEnhancers(applyMiddleware(...getBaseMiddlewares(), ...getDevOnlyMiddlewares(), sagaMiddleware));

function configureStore(initialState) {
  const store = _extends$1({}, createStore(createReducer$a(), initialState, enhancer), {
    asyncReducers: {},
    runSaga: sagaMiddleware.run,
    sagaMiddleware
  });

  store.runSaga(root$6);

  return store;
}

let PropUpdater = class PropUpdater extends React__default.Component {
  constructor(props) {
    super(props);

    this.updateProps = newProps => {
      this.setState({ props: newProps });
    };

    this.state = {};
    this.state.props = props.initialProps || {};
  }

  render() {
    return this.props.render(this.state.initialProps || this.state.props);
  }
};

PropUpdater.displayName = 'PropUpdater';
PropUpdater.propTypes = {
  render: func,
  // eslint-disable-next-line react/forbid-prop-types
  initialProps: object
};

const { auth: authModule$4, config: configModule$3, user: userModule$3 } = modules;
const { promiseMiddleware: promiseMiddleware$1 } = helpers;
const {
  WAIT_FOR_ACTION,
  ERROR_ACTION,
  CALLBACK_ERROR_ARGUMENT
} = promiseMiddleware$1;

const Sagas = util.reactReduxSaga.Sagas;

let _VeritoneApp = class _VeritoneApp {

  constructor(config) {
    this._store = configureStore();
    this._containerEl = null;

    this.setWidgetRef = (widget, ref) => {
      if (!ref) {
        // protect against errors when destroying the app
        return;
      }

      if (_isFunction(ref.getWrappedInstance) && !ref.wrappedInstance) {
        console.warn(`Warning: the following widget looks like it's wrapped with a
         @connect decorator, but the forwardRef option is not set to true.
         { forwardRef: true } should be set as the fourth argument to @connect`);
        console.warn(widget);

        return;
      }

      // try to get at the base component for @connected widgets.
      // fixme: generic solution (hoisting specified instance methods?)
      // https://github.com/elado/hoist-non-react-methods
      const r = _isFunction(ref.getWrappedInstance) ? ref.getWrappedInstance() : ref;

      widget.setRefProperties(r);
    };

    this.setPropsUpdaterRef = (widget, ref) => {
      if (!ref) {
        // protect against errors when destroying the app
        return;
      }

      widget.setUpdaterProperties(ref);
    };

    this._store.dispatch(configModule$3.setConfig(_extends$1({}, appConfig, config)));
    this._theme = config && config.theme;
  }

  _register(widget) {
    this._store.dispatch(widgetAdded(widget));
    this._renderReactApp();
  }

  _unregister(widget) {
    this._store.dispatch(widgetRemoved(widget));
    this._renderReactApp();
  }

  login({ sessionToken, OAuthToken } = {}) {
    // Allows us to transform dispatch into a promise by adding symbols
    // See promiseMiddleware.js
    const addSymbols = action => {
      return _extends$1({}, action, {
        [WAIT_FOR_ACTION]: userModule$3.FETCH_USER_SUCCESS,
        [ERROR_ACTION]: userModule$3.FETCH_USER_FAILURE,
        [CALLBACK_ERROR_ARGUMENT]: action => action.payload
      });
    };

    if (sessionToken) {
      return this._store.dispatch(addSymbols(authModule$4.setSessionToken(sessionToken)));
    } else if (OAuthToken) {
      return this._store.dispatch(addSymbols(authModule$4.setOAuthToken(OAuthToken)));
    } else {
      return this._store.dispatch(addSymbols(authModule$4.checkAuthNoToken()));
    }
  }

  destroy() {
    if (this._containerEl) {
      ReactDOM.unmountComponentAtNode(this._containerEl);
      try {
        document.body.removeChild(this._containerEl);
      } catch (e) {
        // ignore
      }
    }
  }

  _renderReactApp() {
    this._containerEl = document.getElementById('veritone-react-app');
    if (!this._containerEl) {
      this._containerEl = document.createElement('div');
      this._containerEl.setAttribute('id', 'veritone-react-app');
      document.body.appendChild(this._containerEl);
    }

    ReactDOM.render(React__default.createElement(
      VeritoneSDKThemeProvider,
      { theme: this._theme },
      React__default.createElement(
        Sagas,
        { middleware: this._store.sagaMiddleware },
        React__default.createElement(
          Provider,
          { store: this._store },
          React__default.createElement(
            'div',
            null,
            widgets(this._store.getState()).map(w => {
              if (!w._elId) {
                console.warn('The widget', w, 'needs to specify an elId that references an existing dom node.');
                return null;
              }

              if (document.getElementById(w._elId)) {
                return ReactDOM.createPortal(React__default.createElement(PropUpdater, {
                  initialProps: w.props
                  // eslint-disable-next-line react/jsx-no-bind
                  , ref: this.setPropsUpdaterRef.bind(this, w)
                  // eslint-disable-next-line react/jsx-no-bind
                  , render: props => React__default.createElement(w.Component, _extends$1({}, props, {
                    // bind is OK because this isn't a component -- only renders
                    // when mount() is called.
                    // eslint-disable-next-line
                    ref: this.setWidgetRef.bind(this, w)
                  }))
                }), document.getElementById(w._elId));
              }
            })
          )
        )
      )
    ), this._containerEl);
  }
};

let global = window || {};
function VeritoneApp(config, { _isWidget } = {}) {
  // client calls this on init to configure the app:
  // import VeritoneApp from 'veritone-widgets';
  // VeritoneApp({ ...myConfig })
  if (!global.__veritoneAppSingleton) {
    if (_isWidget) {
      console.warn(`A widget was registered to an app which hasn't yet been initialized. Import and call VeritoneApp before constructing any widgets.`);
      return;
    }

    global.__veritoneAppSingleton = new _VeritoneApp(config);
  }

  return global.__veritoneAppSingleton;
}

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var $Object = _core.Object;
var defineProperty$1 = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$2 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty$1, __esModule: true };
});

var _Object$defineProperty = unwrapExports(defineProperty$2);

var objectWithoutProperties = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

function widget(Component) {
  return class Widget {
    constructor(_ref) {
      let { elId, widgetId } = _ref,
          props = _objectWithoutProperties(_ref, ['elId', 'widgetId']);

      this._elId = elId;
      this._props = props;
      this._app = VeritoneApp(null, { _isWidget: true });
      this._id = guid();

      if (this._app) {
        this._app._register(this);
      }
    }

    destroy() {
      this._app._unregister(this);
    }

    setRefProperties(ref) {
      // allow access of ref properties on the widget itself
      // (should only be used by consumers to call component's API)
      _forOwn(ref, (value, key) => {
        try {
          _Object$defineProperty(this, key, { value });
        } catch (e) {
          /* */
        }
      });
    }

    setUpdaterProperties(ref) {
      // allow access of ref properties on the widget itself
      // (should only be used by consumers to call component's API)
      _forOwn(ref, (value, key) => {
        try {
          _Object$defineProperty(this, key, { value });
        } catch (e) {
          /* */
        }
      });
    }

    get Component() {
      return Component;
    }

    get props() {
      return _extends$1({}, this._props, {
        _widgetId: this._id
      });
    }
  };
}

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports(interopRequireDefault);

var createSvgIcon_1 = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSvgIcon;

var _extends2 = interopRequireDefault(_extends_1);

var _react = interopRequireDefault(React__default);

var _SvgIcon = interopRequireDefault(SvgIcon);

function createSvgIcon(path, displayName) {
  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
      ref: ref
    }, props), path);
  }));

  Component.muiName = _SvgIcon.default.muiName;
  return Component;
}
});

unwrapExports(createSvgIcon_1);

var Close = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.default = _default;
});

var CloseIcon = unwrapExports(Close);

var _dec, _dec2, _class, _class2, _temp2, _dec3, _class3, _class4, _temp4;

let FilePicker = (_dec = withPropsOnChange([], ({ id }) => ({
  id: id || guid()
})), _dec2 = connect((state$1, { id }) => ({
  open: isOpen(state$1, id),
  pickerState: state(state$1, id),
  percentByFiles: percentByFiles(state$1, id),
  success: didSucceed(state$1, id),
  error: didError(state$1, id),
  warning: didWarn(state$1, id),
  statusMessage: statusMessage(state$1, id)
}), {
  pick: pick,
  endPick: endPick,
  abortRequest: abortRequest,
  uploadRequest: uploadRequest,
  retryRequest: retryRequest,
  retryDone: retryDone
}, (stateProps, dispatchProps, ownProps) => _extends$1({}, ownProps, stateProps, dispatchProps, {
  // allow widget version of FilePicker to override uploadRequest
  uploadRequest: ownProps.uploadRequest || dispatchProps.uploadRequest,
  retryRequest: ownProps.retryRequest || dispatchProps.retryRequest,
  retryDone: ownProps.retryDone || dispatchProps.retryDone,
  abortRequest: ownProps.abortRequest || dispatchProps.abortRequest
})), _dec(_class = _dec2(_class = (_temp2 = _class2 = class FilePicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handlePick = () => {
      this.props.pick(this.props.id);
    }, this.cancel = () => {
      this.props.endPick(this.props.id);
      this.props.onPickCancelled();
    }, this.onFilesSelected = files => {
      this.props.uploadRequest(this.props.id, files, this.props.onPick);
    }, this.renderPickerDialog = () => {
      return React__default.createElement(
        Dialog,
        { open: this.props.open },
        React__default.createElement(FilePicker$1, _extends$1({}, this.props, {
          onRequestClose: this.cancel,
          onPickFiles: this.onFilesSelected
        }))
      );
    }, this.handleRetryDone = () => {
      const {
        id,
        onPick,
        retryDone
      } = this.props;
      retryDone && retryDone(id, onPick);
    }, this.handleRetry = () => {
      const {
        id,
        retryRequest,
        onPick
      } = this.props;
      retryRequest && retryRequest(id, onPick);
    }, this.handleAbort = fileKey => {
      const { id, abortRequest } = this.props;
      abortRequest && abortRequest(id, fileKey);
    }, this.renderProgressDialog = () => {
      let completeStatus = {
        [this.props.success]: 'success',
        [this.props.error]: 'failure',
        [this.props.warning]: 'warning'
      }[true];

      return React__default.createElement(
        Dialog,
        { open: this.props.open },
        React__default.createElement(FileProgressDialog, {
          height: this.props.height,
          width: this.props.width,
          onClose: this.cancel,
          percentByFiles: this.props.percentByFiles,
          progressMessage: this.props.statusMessage,
          handleAbort: this.handleAbort,
          retryRequest: this.handleRetry,
          onRetryDone: this.handleRetryDone,
          completeStatus: completeStatus
        })
      );
    }, _temp;
  }

  render() {
    const pickerComponent = {
      selecting: this.renderPickerDialog,
      uploading: this.renderProgressDialog,
      complete: this.renderProgressDialog
    }[this.props.pickerState]();

    return React__default.createElement(
      Fragment$1,
      null,
      pickerComponent,
      this.props.renderButton && this.props.renderButton({ handlePickFiles: this.handlePick })
    );
  }
}, _class2.propTypes = {
  id: string.isRequired,
  open: bool,
  pick: func,
  endPick: func,
  abortRequest: func,
  uploadRequest: func,
  retryRequest: func,
  retryDone: func,
  pickerState: oneOf(['selecting', 'uploading', 'complete']),
  percentByFiles: arrayOf(shape({
    key: string.isRequired,
    value: shape({
      name: string,
      size: number,
      type: string,
      percent: number
    }).isRequired
  })),
  success: bool,
  error: bool,
  warning: bool,
  statusMessage: string,
  renderButton: func,
  onPickCancelled: func,
  onPick: func,
  height: number,
  width: number,
  enableResize: bool,
  aspectRatio: number
}, _class2.defaultProps = {
  open: false,
  onPickCancelled: _noop,
  onPick: _noop,
  percentByFiles: [],
  height: 450,
  width: 600,
  enableResize: false,
  aspectRatio: 16 / 9
}, _temp2)) || _class) || _class);
FilePicker.displayName = 'FilePicker';
let FilePickerWidgetComponent = (_dec3 = connect(null, {
  pick: pick,
  endPick: endPick,
  uploadRequest: uploadRequest,
  retryRequest: retryRequest,
  retryDone: retryDone,
  abortRequest: abortRequest
}, null, { forwardRef: true }), _dec3(_class3 = (_temp4 = _class4 = class FilePickerWidgetComponent extends React__default.Component {
  constructor(...args) {
    var _temp3;

    return _temp3 = super(...args), this.pickCallback = _noop, this.componentPickCallback = _noop, this.pick = (callback = _noop) => {
      this.pickCallback = callback;
      this.props.pick(this.props._widgetId);
    }, this.cancel = () => {
      this.props.endPick(this.props._widgetId);
      this.callCancelledCallback();
    }, this.callCancelledCallback = () => {
      this.pickCallback(null, { cancelled: true });
    }, this.handleUploadRequest = (id, files) => {
      this.props.uploadRequest(id, files, this.pickCallback);
    }, this.handleRetryRequest = id => {
      this.props.retryRequest(id, this.pickCallback);
    }, this.handleRetryDone = id => {
      this.props.retryDone(id, this.pickCallback);
    }, _temp3;
  }

  render() {
    return React__default.createElement(FilePicker, _extends$1({
      id: this.props._widgetId
    }, this.props, {
      uploadRequest: this.handleUploadRequest,
      retryRequest: this.handleRetryRequest,
      retryDone: this.handleRetryDone,
      onPickCancelled: this.callCancelledCallback
    }));
  }
}, _class4.propTypes = {
  _widgetId: string.isRequired,
  pick: func.isRequired,
  endPick: func.isRequired,
  uploadRequest: func.isRequired,
  retryRequest: func.isRequired,
  retryDone: func.isRequired,
  abortRequest: func.isRequired
}, _temp4)) || _class3);
FilePickerWidgetComponent.displayName = 'FilePickerWidgetComponent';


const FilePickerWidget = widget(FilePickerWidgetComponent);

var styles = {
  container: {
    width: '100%'
  },
  field: {
    width: '100%'
  }
};

const useStyles = makeStyles(styles);

const Index = ({ name, email, onEditName, onEditEmail }) => {
  const classes = useStyles();

  return React__default.createElement(
    'div',
    { className: classes.container },
    React__default.createElement(RaisedTextField, {
      label: 'Name',
      value: name,
      action: 'edit',
      onClickAction: onEditName,
      className: classes.field
    }),
    React__default.createElement(RaisedTextField, {
      label: 'Email',
      value: email,
      action: 'edit',
      onClickAction: onEditEmail,
      actionTooltipLabel: 'This address is used to identify your Veritone account and cannot be changed.',
      className: classes.field,
      disabled: true
    })
  );
};

Index.displayName = 'Index';
Index.propTypes = {
  name: string.isRequired,
  email: string.isRequired,
  onEditName: func.isRequired,
  onEditEmail: func.isRequired
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `true`        |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var MILLISECONDS_IN_MINUTE = 60000;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token) {
  if (token === 'YYYY') {
    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'YY') {
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'D') {
    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  } else if (token === 'DD') {
    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'(.*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

var styles$1 = {
  container: {
    width: '100%'
  },
  field: {
    width: '100%'
  }
};

const useStyles$1 = makeStyles(styles$1);

const PasswordField = ({ lastUpdated, onEdit }) => {
  const classes = useStyles$1();

  return React__default.createElement(
    'div',
    { className: classes.container },
    React__default.createElement(RaisedTextField, {
      label: 'Password',
      value: lastUpdated ? `Last updated ${format(new Date(lastUpdated), 'MMMM DD, YYYY')}` : 'Never Updated',
      action: 'RESET',
      onClickAction: onEdit,
      className: classes.field
    })
  );
};

PasswordField.displayName = 'PasswordField';
PasswordField.propTypes = {
  lastUpdated: string,
  onEdit: func.isRequired
};

var styles$2 = {
  inputGroup: {
    width: 400,
    height: '75px !important' // fixed height so they don't jump around when errors appear
  }
};

const { TextField } = formComponents;

const useStyles$2 = makeStyles(styles$2);

const ChangeName = ({ open, disableConfirm, onConfirm, onCancel }) => {
  const classes = useStyles$2();

  return React__default.createElement(
    Dialog,
    { open: open, classes: { root: classes.dialogContainer } },
    React__default.createElement(
      DialogTitle,
      null,
      'Change Name'
    ),
    React__default.createElement(
      DialogContent,
      null,
      React__default.createElement(
        'div',
        { className: classes.inputGroup },
        React__default.createElement(Field, {
          component: TextField,
          name: 'firstName',
          label: 'First name',
          autoFocus: true,
          fullWidth: true
        })
      ),
      React__default.createElement(
        'div',
        { className: classes.inputGroup },
        React__default.createElement(Field, {
          component: TextField,
          name: 'lastName',
          label: 'Last name',
          fullWidth: true
        })
      )
    ),
    React__default.createElement(
      DialogActions,
      null,
      React__default.createElement(
        Button,
        { onClick: onCancel },
        'Cancel'
      ),
      React__default.createElement(
        Button,
        { color: 'primary', disabled: disableConfirm, onClick: onConfirm },
        'Done'
      )
    )
  );
};

ChangeName.displayName = 'ChangeName';
ChangeName.propTypes = {
  open: bool,
  disableConfirm: bool,
  onCancel: func.isRequired,
  onConfirm: func.isRequired
};

var ChangeNameModal = reduxForm({
  form: 'userProfile'
})(ChangeName);

const ResetPassword = ({ open, onConfirm, onCancel }) => React__default.createElement(
  Dialog,
  { open: open },
  React__default.createElement(
    DialogTitle,
    null,
    'Reset Password'
  ),
  React__default.createElement(
    DialogContent,
    null,
    React__default.createElement(
      DialogContentText,
      null,
      'Veritone will send a reset password link via the email on your account.'
    ),
    React__default.createElement(
      DialogContentText,
      null,
      'Would you like to continue?'
    )
  ),
  React__default.createElement(
    DialogActions,
    null,
    React__default.createElement(
      Button,
      { onClick: onCancel },
      'Cancel'
    ),
    React__default.createElement(
      Button,
      { color: 'primary', onClick: onConfirm },
      'Yes'
    )
  )
);

ResetPassword.displayName = 'ResetPassword';
ResetPassword.propTypes = {
  open: bool.isRequired,
  onConfirm: func.isRequired,
  onCancel: func.isRequired
};

// colors

const grey1 = '#fafafa';
const grey3 = '#e8e8e8';
const grey4 = '#e0e0e0';
const grey5 = '#727272';

const blue1 = '#2196f3';
const red500 = '#f44336';

const fullBlack = 'rgba(0, 0, 0, 1)';
const darkBlack = 'rgba(0, 0, 0, 0.87)';
const lightBlack = 'rgba(0, 0, 0, 0.54)';
const minBlack = 'rgba(0, 0, 0, 0.38)';
const faintBlack = 'rgba(0, 0, 0, 0.12)';

const fullWhite = 'rgba(255, 255, 255, 1)';
const darkWhite = 'rgba(255, 255, 255, 0.87)';

var styles$3 = {
  container: {
    paddingTop: 64, // clear appbar
    backgroundColor: grey1,
    height: '100%',
    width: '100%',
    minHeight: '700px',
    display: 'flex',
    justifyContent: 'center'
  },
  column: {
    height: '100%',
    maxWidth: '50rem',
    padding: '0 1rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 40,
    width: '100%'
  },
  subheading: {
    color: `${lightBlack} !important`
  },
  greeting: {
    marginTop: '13px !important'
  }
};

var _dec$1, _dec2$1, _dec3$1, _dec4, _dec5, _class$1, _class2$1, _temp2$1, _class3$1, _temp4$1;
const {
  user: {
    resetUserPassword,
    updateCurrentUserProfile,
    selectUser,
    selectUserOrganizationKvp
  }
} = modules;
const defaultAvatarImg = 'https://static.veritone.com/veritone-ui/default-avatar.png';
const formNameSpace = 'form';

let UserProfile = (_dec$1 = connect(state => ({
  user: selectUser(state),
  enablePasswordReset: _get(selectUserOrganizationKvp(state), 'features.oktaAuthentication.enabled', false) !== true
}), {
  resetForm: reset$1,
  submitForm: submit$1,
  resetUserPassword,
  updateCurrentUserProfile
}), _dec2$1 = branch(
// do not render if we don't have a user
props => _isEmpty(props.user), renderNothing), _dec3$1 = withProps(props => ({
  initialValues: {
    firstName: props.user.kvp.firstName,
    lastName: props.user.kvp.lastName,
    email: props.user.email
  }
})), _dec4 = reduxForm({
  form: 'userProfile',
  validate: values => {
    let errors = {};

    if (!values.firstName) {
      errors.firstName = 'Cannot be empty';
    }

    if (!values.lastName) {
      errors.lastName = 'Cannot be empty';
    }

    return errors;
  }
}), _dec5 = withStyles(styles$3), _dec$1(_class$1 = _dec2$1(_class$1 = _dec3$1(_class$1 = _dec4(_class$1 = _dec5(_class$1 = (_temp2$1 = _class2$1 = class UserProfile extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      currentModal: null
    }, this.openChangeNameModal = () => {
      this.setState({
        currentModal: 'changeName'
      });
    }, this.openChangeEmailModal = () => {
      this.setState({
        currentModal: 'changeEmail'
      });
    }, this.openChangePasswordModal = () => {
      this.setState({
        currentModal: 'changePassword'
      });
    }, this.openChangeAvatarModal = () => {
      this.setState({
        currentModal: 'changeAvatar'
      });
    }, this.closeModal = () => {
      this.setState({
        currentModal: null
      });
    }, this.cancelChanges = () => {
      this.closeModal();
      this.props.resetForm('userProfile');
    }, this.submitChanges = () => {
      this.props.submitForm('userProfile');
    }, this.handleResetPassword = () => {
      return this.props.resetUserPassword().catch(_noop).then(this.afterChange);
    }, this.handleUpdateUser = vals => {
      return this.props.updateCurrentUserProfile(vals).catch(_noop).then(this.afterChange);
    }, this.handleUpdateImage = ([result], { error }) => {
      if (error) {
        // file picker upload error, messaging handled by picker itself
        return;
      }

      return this.handleUpdateUser({
        imageUrl: result.unsignedUrl
      });
    }, this.afterChange = userResponse => {
      const updatedUser = _get(userResponse, 'updateCurrentUser');
      if (updatedUser) {
        this.props.onUserUpdated(updatedUser);
      }
      this.closeModal();
    }, this.getUserFullName = () => {
      return _startCase(`${this.props.user.kvp.firstName} ${this.props.user.kvp.lastName}`);
    }, _temp;
  }

  render() {
    const { classes } = this.props;

    return React__default.createElement(
      Form$1,
      {
        onSubmit: this.props.handleSubmit(this.handleUpdateUser),
        className: classes.container
      },
      React__default.createElement(
        'div',
        { className: classes.column },
        React__default.createElement(
          'div',
          { className: classes.section },
          React__default.createElement(FilePicker, {
            accept: ['image/*'],
            multiple: false,
            allowUrlUpload: false,
            onPick: this.handleUpdateImage
            // eslint-disable-next-line
            , renderButton: ({ handlePickFiles }) => React__default.createElement(Avatar, {
              src: this.props.user.signedImageUrl || defaultAvatarImg,
              label: 'Change',
              onClick: handlePickFiles
            })
          })
        ),
        React__default.createElement(
          'div',
          { className: classes.section },
          React__default.createElement(
            Typography,
            {
              variant: 'h6',
              gutterBottom: true,
              classes: { root: classes.title }
            },
            'Your Personal Info'
          ),
          React__default.createElement(
            Typography,
            {
              variant: 'subtitle1',
              gutterBottom: true,
              classes: { root: classes.subheading }
            },
            'Manage your basic information.'
          ),
          React__default.createElement(Index, {
            name: this.getUserFullName(),
            email: this.props.user.email,
            onEditName: this.openChangeNameModal,
            onEditEmail: this.openChangeEmailModal
          })
        ),
        this.props.enablePasswordReset === true && React__default.createElement(
          'div',
          { className: classes.section },
          React__default.createElement(
            Typography,
            {
              variant: 'h6',
              gutterBottom: true,
              classes: { root: classes.title }
            },
            'Signing in to Veritone'
          ),
          React__default.createElement(
            Typography,
            {
              variant: 'subtitle1',
              gutterBottom: true,
              classes: { root: classes.subheading }
            },
            'Control your password and account access.'
          ),
          React__default.createElement(PasswordField, {
            lastUpdated: this.props.user.lastPasswordUpdated,
            onEdit: this.openChangePasswordModal
          })
        ),
        React__default.createElement(ChangeNameModal, {
          open: this.state.currentModal === 'changeName',
          onConfirm: this.submitChanges,
          onCancel: this.cancelChanges,
          disableConfirm: this.props.invalid || this.props.pristine || this.props.submitting
        }),
        React__default.createElement(ResetPassword, {
          open: this.state.currentModal === 'changePassword',
          onConfirm: this.handleResetPassword,
          onCancel: this.cancelChanges
        })
      )
    );
  }
}, _class2$1.propTypes = {
  user: shape({
    kvp: shape({
      firstName: string.isRequired,
      lastName: string.isRequired,
      lastPasswordUpdated: string
    }).isRequired,
    email: string,
    signedImageUrl: string
  }),
  resetForm: func.isRequired,
  submitForm: func.isRequired,
  handleSubmit: func.isRequired,
  resetUserPassword: func.isRequired,
  updateCurrentUserProfile: func.isRequired,
  onUserUpdated: func,
  invalid: bool,
  pristine: bool,
  submitting: bool,
  enablePasswordReset: bool,
  classes: shape({ any })
}, _class2$1.defaultProps = {
  onUserUpdated: _noop,
  enablePasswordReset: true
}, _temp2$1)) || _class$1) || _class$1) || _class$1) || _class$1) || _class$1);

UserProfile.displayName = 'UserProfile';
const SlideDown = React__default.forwardRef((slideProps, ref) => React__default.createElement(Slide, _extends$1({ ref: ref, direction: 'down' }, slideProps)));

let UserProfileDialog = (_temp4$1 = _class3$1 = class UserProfileDialog extends React__default.Component {
  constructor(...args) {
    var _temp3;

    return _temp3 = super(...args), this.state = {
      openedByWidgetInstanceMethod: false
    }, this.open = () => {
      this.setState({
        openedByWidgetInstanceMethod: true
      });
    }, this.close = () => {
      this.setState({
        openedByWidgetInstanceMethod: false
      });
    }, this.handleClose = () => {
      this.close();
      this.props.onClose();
    }, _temp3;
  }

  render() {
    let _props = this.props,
        { open, title } = _props,
        profileProps = _objectWithoutProperties(_props, ['open', 'title']);
    return React__default.createElement(
      Dialog,
      {
        fullScreen: true,
        open: open || this.state.openedByWidgetInstanceMethod,
        TransitionComponent: SlideDown
      },
      React__default.createElement(
        AppBar$1,
        { position: 'fixed' },
        React__default.createElement(
          Toolbar,
          null,
          React__default.createElement(
            IconButton,
            { color: 'inherit', onClick: this.handleClose },
            React__default.createElement(CloseIcon, null)
          ),
          React__default.createElement(
            Typography,
            { variant: 'h6', color: 'inherit' },
            title
          )
        )
      ),
      React__default.createElement(UserProfile, profileProps)
    );
  }
}, _class3$1.propTypes = {
  open: bool,
  title: string,
  onClose: func,
  onUserUpdated: func
}, _class3$1.defaultProps = {
  onClose: _noop
}, _temp4$1);
UserProfileDialog.displayName = 'UserProfileDialog';


const UserProfileWidget = widget(UserProfileDialog);

var _dec$2, _class$2, _class2$2, _temp2$2;
const { user, config: config$1 } = modules;

let AppBar = (_dec$2 = connect(state => ({
  user: user.selectUser(state),
  enabledApps: user.selectEnabledApps(state),
  enabledAppsFailedLoading: user.enabledAppsFailedLoading(state),
  isFetchingApps: user.isFetchingApps(state),
  switchAppRoute: config$1.getConfig(state).switchAppRoute
}), { fetchEnabledApps: user.fetchEnabledApps }, null, { forwardRef: true }), _dec$2(_class$2 = (_temp2$2 = _class2$2 = class AppBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      editingUserProfile: false
    }, this.veritoneAppDidAuthenticate = () => {
      this.props.fetchEnabledApps();
    }, this.handleSwitchApp = id => {
      window.open(`${this.props.switchAppRoute}/${id}`);
    }, this.handleEditProfile = () => {
      this.setState({
        editingUserProfile: true
      });
    }, this.closeUserProfileEditor = () => {
      this.setState({
        editingUserProfile: false
      });
    }, _temp;
  }

  componentDidMount() {
    this.props.fetchEnabledApps();
  }

  render() {
    return React__default.createElement(
      Fragment$1,
      null,
      React__default.createElement(AppBar$2, _extends$1({}, this.props, {
        onSwitchApp: this.handleSwitchApp,
        onEditProfile: this.handleEditProfile
      })),
      React__default.createElement(UserProfileDialog, {
        open: this.state.editingUserProfile,
        onClose: this.closeUserProfileEditor
      })
    );
  }
}, _class2$2.propTypes = {
  _widgetId: string,
  fetchEnabledApps: func,
  switchAppRoute: string.isRequired,
  isDiscovery: bool
}, _temp2$2)) || _class$2);
AppBar.displayName = 'AppBar';


const AppBarWidget = widget(AppBar);

var _dec$3, _class$3, _class2$3, _temp2$3;
const {
  user: { userIsAuthenticated },
  auth: { requestOAuthGrant, requestOAuthGrantImplicit },
  config: { getConfig: getConfig$1 }
} = modules;

let OAuthLoginButton = (_dec$3 = connect(state => ({
  userIsAuthenticated: userIsAuthenticated(state),
  apiRoot: getConfig$1(state).apiRoot
}), { requestOAuthGrant, requestOAuthGrantImplicit }, null, { forwardRef: true }), _dec$3(_class$3 = (_temp2$3 = _class2$3 = class OAuthLoginButton extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleLogin = () => {
      /* prettier-ignore */
      const defaultImplicitGrantURI = `${this.props.apiRoot}/v1/admin/oauth/authorize`;

      const OAuthURI = this.props.OAuthURI || (this.props.mode === 'implicit' ? defaultImplicitGrantURI : undefined);

      const grantFn = {
        implicit: this.props.requestOAuthGrantImplicit,
        authCode: this.props.requestOAuthGrant
      }[this.props.mode];

      grantFn({
        OAuthURI,
        responseType: this.props.responseType,
        scope: this.props.scope,
        clientId: this.props.clientId,
        redirectUri: this.props.redirectUri,
        onSuccess: this.props.onAuthSuccess,
        onFailure: this.props.onAuthFailure
      });
    }, _temp;
  }

  render() {
    return !this.props.userIsAuthenticated && React__default.createElement(OAuthLoginButton$1, _extends$1({}, this.props, { onClick: this.handleLogin }));
  }
}, _class2$3.propTypes = {
  requestOAuthGrant: func.isRequired,
  requestOAuthGrantImplicit: func.isRequired,
  userIsAuthenticated: bool.isRequired,
  mode: oneOf(['implicit', 'authCode']),
  onAuthSuccess: func,
  onAuthFailure: func,
  apiRoot: string.isRequired,
  OAuthURI: string,
  // required params for implicit grant only:
  responseType: string,
  scope: string,
  redirectUri: string,
  clientId: string
}, _class2$3.defaultProps = {
  mode: 'implicit'
}, _temp2$3)) || _class$3);
OAuthLoginButton.displayName = 'OAuthLoginButton';


const OAuthLoginButtonWidget = widget(OAuthLoginButton);

const getAllParentId = (item, folderDataFlatten) => {
  if (_isEmpty(item) || _isNil(item)) {
    return [];
  } else {
    if (_isNil(item.parentId)) {
      return [{
        id: item.id,
        name: item.name
      }];
    } else {
      return [{
        id: item.id,
        name: item.name
      }, ...getAllParentId(folderDataFlatten.byId[item.parentId], folderDataFlatten)];
    }
  }
};

function FolderTreeWrapper({
  type = 'watchlist',
  workSpace = 'folderTree',
  isEnableShowContent = false,
  isEnableSearch,
  isEnableSelectRoot,
  isEnableShowRootFolder,
  selectable = true,
  showingType = ['org'],
  showAll = false,
  onSelectMenuItem,
  folderAction,
  handleSelectedFoler,
  initFolder,
  expandFolder,
  foldersData,
  searchValue,
  originFolderData,
  onSelectFolder,
  initSuccess,
  onSelectAllFolder,
  initialStatus,
  selectedFolders = {},
  fetchingFolderStatus,
  fetchedFolderStatus,
  errorStatus,
  processingFolder,
  folderById,
  rootFolderIds,
  createFolder,
  deleteFolder,
  editFolder,
  searchFolder,
  initFolderFromApp,
  unSelectFolder,
  unSelectAllFolder,
  unSelectCurrentFolder,
  clearSearchData,
  eventSelector,
  setEventData
}) {
  const [openNew, setOpenNew] = useState(false);
  const [selectedFolder, setSelected] = useState({});
  const [openModify, setOpenModify] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [fromNewButton, setStatus] = useState(false);
  const [modifyFromAction, setModifyFromAction] = useState(false);
  const [currentFolderForAction, setCurrentFolderForAction] = useState({});
  const [selectedInModify, setSelectedInModify] = useState({});
  const [defaultOpening, setDefaultOpening] = useState([]);
  const [folderSelectedFromApp, setFolderSelectedFromApp] = useState();
  const [folderInitFromApp, setFolderInitFromApp] = useState();
  const [event, setEvent] = useState({});

  useEffect(() => {
    if (initialStatus && !_isEmpty(selectedFolders)) {
      const selectedWithSpace = _get(selectedFolders, [workSpace], {});
      setSelected(selectedWithSpace);
    }
  }, [selectedFolders]);

  useEffect(() => {
    const config = {
      type,
      isEnableShowContent,
      selectable,
      showingType,
      workSpace
    };
    if (!initialStatus) {
      initFolder(config);
    }
  }, []);

  useEffect(() => {
    if (!_isEmpty(foldersData.byId) && !_isNil(foldersData.byId)) {
      setDefaultOpening(foldersData.rootIds);
    }
  }, [foldersData]);

  useEffect(() => {
    const currentEvent = _get(eventSelector, [workSpace], {});
    if (event.eventType !== currentEvent.eventType && currentEvent.eventType !== '') {
      setEvent(currentEvent);
      const { eventType, data } = currentEvent;
      processEventReducer(eventType, data);
      setEventData(workSpace, '', null);
      setEvent({});
    }
  }, [eventSelector, event]);

  useEffect(() => {
    if (isEnableSelectRoot) {
      if (initialStatus && _isEmpty(selectedFolder)) {
        const rootFolder = foldersData.rootIds.length ? foldersData.rootIds[0] : [];
        if (!selectable) {
          onSelectFolder(workSpace, {
            [rootFolder]: true
          });
        } else {
          onSelectAllFolder(workSpace);
        }
      }
    }
  }, [initialStatus]);

  useEffect(() => {
    if (initialStatus && folderInitFromApp) {
      initFolderFromApp(folderInitFromApp);
    }
  }, [initialStatus, folderInitFromApp]);

  useEffect(() => {
    if (initialStatus) {
      initSuccess({
        foldersData
      });
    }
  }, [initialStatus]);

  useEffect(() => {
    const folder = _get(foldersData, ['byId', folderInitFromApp]);
    if (folderInitFromApp && initialStatus && !_isNil(folder)) {
      const parentId = getAllParentId(folder, originFolderData).map(item => item.id);
      setDefaultOpening(parentId);
    }
  }, [initialStatus, foldersData, folderInitFromApp]);

  useEffect(() => {
    const pathList = !selectable ? getPathList(selectedFolder) : [];
    const selectedFolderId = _Object$keys(selectedFolder);
    const folder = !selectable ? _get(foldersData, ['byId', selectedFolderId[0]]) : {};
    handleSelectedFoler({
      selectedFolder,
      folder,
      pathList
    });
  }, [selectedFolder, originFolderData]);

  useEffect(() => {
    if (!_isEmpty(folderSelectedFromApp) && !_isNil(folderSelectedFromApp)) {
      onSelectFolder(workSpace, folderSelectedFromApp);
      const pathList = getPathList(folderSelectedFromApp);
      setDefaultOpening(pathList.map(item => item.id));
    }
  }, [folderSelectedFromApp]);

  const getPathList = selectedFolder => {
    if (selectable) {
      return [];
    }
    const folderId = _Object$keys(selectedFolder);
    const folder = folderById(folderId[0]);
    return _flattenDeep(getAllParentId(folder, originFolderData)).reverse();
  };

  const onSelectMenu = (item, action) => {
    setCurrentFolderForAction(item);
    switch (action) {
      case 'edit':
        setOpenEdit(true);
        setOpenModify(true);
        break;
      case 'delete':
        setOpenDelete(true);
        break;
      case 'move':
        setOpenModify(true);
        setModifyFromAction(true);
        break;
      default:
        break;
    }
  };

  const onChange = selectedfolder => {
    onSelectFolder(workSpace, selectedfolder);
  };

  const onExpand = folderId => {
    expandFolder(folderId);
  };

  //search folder
  const onSearch = data => {
    searchFolder(data);
  };

  //clear search
  const onClearSearch = () => {
    if (searchValue) {
      clearSearchData();
    }
  };

  //new folder
  const handleSubmitNewFolder = (data, parentId) => {
    createFolder(data, parentId);
    handleCloseNewFolder();
  };

  const handleCloseNewFolder = () => {
    setOpenNew(false);
    setStatus(false);
  };

  //modify folder
  const handleSubmitModify = (selectedFolder = {}, folderName) => {
    handleCloseModify();
    const currentFolderId = currentFolderForAction.id;
    const newParentId = _Object$keys(selectedFolder)[0];
    if (openEdit) {
      editFolder(currentFolderId, folderName, true, false);
    } else {
      editFolder(currentFolderId, folderName, false, true, newParentId);
    }
  };

  const handleCloseModify = () => {
    setOpenModify(false);
    setTimeout(() => {
      setOpenEdit(false);
    }, 500);
  };

  //delete folder
  const handleSubmitDeleteFolder = data => {
    deleteFolder(data.id, workSpace);
    handleCloseDeleteFolder();
  };

  const handleCloseDeleteFolder = () => {
    setOpenDelete(false);
  };

  const getFolderSeleted = selectedFolder => {
    const selectedFolderId = _Object$keys(selectedFolder);
    const data = folderById(selectedFolderId[0]) || folderById(rootFolderIds[0]) || {};
    return data;
  };

  const newParentFolder = () => {
    return fromNewButton ? getFolderSeleted(selectedInModify) : getFolderSeleted(selectedFolder) || {};
  };

  const handerClickNewFolder = selectedfolder => {
    const setData = async () => {
      await setStatus(true);
      await setSelectedInModify(selectedfolder);
      await setOpenNew(true);
    };
    setData();
  };

  const handlerOpenFolder = () => {
    if (!selectable) {
      setStatus(false);
      setOpenNew(true);
    } else {
      setOpenModify(true);
      setModifyFromAction(false);
      setStatus(false);
    }
  };

  const initFolderSelectedFromApp = folderId => {
    setFolderInitFromApp(folderId);
  };

  const unSelectCurentFolderWrapper = () => {
    unSelectCurrentFolder(workSpace);
  };

  const processEventReducer = (eventType, data) => {
    switch (eventType) {
      case 'action/newfolder':
        handlerOpenFolder();
        break;
      case 'action/select':
        setFolderSelectedFromApp({
          [data]: true
        });
        break;
      case 'action/initselect':
        initFolderSelectedFromApp(data);
        break;
      case 'action/unSelectCurrent':
        unSelectCurentFolderWrapper();
        break;
      default:
        break;
    }
  };

  const getModifyType = () => {
    return openEdit ? 3 : openModify && modifyFromAction ? 2 : 1;
  };
  return React__default.createElement(
    'div',
    { 'data-test': 'folderTree' },
    isEnableSearch && React__default.createElement(SearchBox, {
      onSearch: onSearch,
      onClearSearch: onClearSearch,
      placeholder: 'Search Folders'
    }),
    fetchingFolderStatus && React__default.createElement(LoadingState, null),
    fetchedFolderStatus && foldersData.allId.length === 0 && React__default.createElement(FolderNullState, {
      message: errorStatus ? 'Something wrong' : 'No content in this org'
    }),
    React__default.createElement(FolderTree$1, {
      selectable: selectable,
      errorStatus: errorStatus,
      loaded: fetchedFolderStatus,
      selected: selectedFolder,
      foldersData: showAll ? originFolderData : foldersData,
      onChange: onChange,
      onExpand: onExpand,
      isEnableShowContent: isEnableShowContent,
      folderAction: folderAction,
      onMenuClick: onSelectMenu,
      processingFolder: processingFolder,
      defaultOpening: defaultOpening,
      isEnableShowRootFolder: isEnableShowRootFolder
    }),
    React__default.createElement(DeleteFolder, {
      open: openDelete,
      folder: currentFolderForAction,
      handleClose: handleCloseDeleteFolder,
      handleSubmit: handleSubmitDeleteFolder
    }),
    React__default.createElement(EditFolder, {
      open: openModify,
      type: getModifyType(),
      isEnableEditName: !modifyFromAction || openEdit,
      isEnableEditFolder: !openEdit,
      isNewFolder: !modifyFromAction && !openEdit,
      handleClose: handleCloseModify,
      handleSubmit: handleSubmitModify,
      foldersData: originFolderData,
      onExpand: onExpand,
      selected: selectedFolder,
      defaultOpening: rootFolderIds,
      currentFolder: currentFolderForAction,
      handerClickNewFolder: handerClickNewFolder
    }),
    React__default.createElement(CreateFolder, {
      open: openNew,
      parentFolder: newParentFolder(),
      handleClose: handleCloseNewFolder,
      handleSubmit: handleSubmitNewFolder
    })
  );
}

FolderTreeWrapper.displayName = 'FolderTreeWrapper';
FolderTreeWrapper.propTypes = {
  type: string,
  workSpace: string,
  onSelectFolder: func,
  onSelectMenuItem: func,
  selectable: bool,
  isEnableShowContent: bool,
  isEnableSearch: bool,
  isEnableShowRootFolder: bool,
  isEnableSelectRoot: bool,
  showingType: arrayOf(string).isRequired,
  showAll: bool,
  folderAction: arrayOf(shape({
    id: number,
    type: string,
    name: string
  })),
  originFolderData: shape(Object),
  foldersData: shape(Object),
  searchValue: string,
  selectedFolders: shape(Object),
  initFolder: func,
  expandFolder: func,
  fetchingFolderStatus: bool,
  fetchedFolderStatus: bool,
  errorStatus: bool,
  handleSelectedFoler: func,
  processingFolder: arrayOf(string),
  folderById: func,
  rootFolderIds: arrayOf(string),
  createFolder: func,
  deleteFolder: func,
  editFolder: func,
  searchFolder: func,
  onSelectAllFolder: func,
  initialStatus: bool,
  initFolderFromApp: func,
  initSuccess: func,
  unSelectFolder: func,
  unSelectCurrentFolder: func,
  unSelectAllFolder: func,
  clearSearchData: func,
  eventSelector: shape({
    eventType: string,
    data: string
  }),
  setEventData: func
};

const FolderTree = connect(state => ({
  originFolderData: folderData(state),
  foldersData: foldersDataSelector(state),
  fetchingFolderStatus: folderFetchingStatus(state),
  fetchedFolderStatus: folderFetchedStatus(state),
  errorStatus: folderErrorStatus(state),
  selectedFolders: selectedFolder(state),
  folderById: folderById(state),
  rootFolderIds: rootFolderIds(state),
  processingFolder: processingFolderSelector(state),
  initialStatus: getInitialStatus(state),
  eventSelector: eventSelector(state),
  searchValue: searchValue$1(state)
}), {
  expandFolder: fetchMore,
  onSelectFolder: selectFolder,
  onSelectAllFolder: selectAllFolder,
  initFolder: initRootFolder,
  createFolder: createFolder,
  deleteFolder: deleteFolder,
  editFolder: modifyFolder,
  searchFolder: searchFolder,
  initFolderFromApp: initFolderFromApp,
  unSelectAllFolder: unSelectAllFolder,
  unSelectCurrentFolder: unSelectCurrentFolder,
  unSelectFolder: unSelectFolder,
  setEventData: eventChannel,
  clearSearchData: clearSearchData
}, null, { forwardRef: true })(FolderTreeWrapper);

const FolderTreeWidget = widget(FolderTree);

var styles$4 = {
  dataPickerPaper: {
    maxHeight: 'none !important',
    maxWidth: 'none !important',
    minWidth: 1090,
    minHeight: 520,
    margin: '0 !important'
  },
  dataPickerErrorSnack: {
    backgroundColor: '#d32f2f !important'
  }
};

var _dec$4, _dec2$2, _dec3$2, _class$4, _class2$4, _temp2$4, _dec4$1, _class3$2, _class4$1, _temp4$2;

/*
  Required parameters:
    onPick: (items) => { ... Logic to handle what you picked ... }
    enableFolders/enableUploads: bool (at least one of these are required)
    
    EITHER:
    open: bool (controlled component)
    renderButton

  Example usage:
  widget = new veritoneWidgets.DataPickerWidget({
    elId: YOUR_HTML_ELEMENT_ID,
    onPick: items => {
      console.log('Items picked: ');
      console.log(items);
    }
  });
  widget.pick(); // open Picker
  widget.cancel(); // close Picker
*/
let DataPicker = (_dec$4 = withStyles(styles$4), _dec2$2 = withPropsOnChange([], ({ id }) => ({
  id: id || guid()
})), _dec3$2 = connect((state$1, { id }) => ({
  // General State
  internalState: isOpen$1(state$1, id),
  pathList: currentPath(state$1, id),
  availablePickerTypes: availablePickerTypes(state$1, id),
  currentPickerType: currentPickerType(state$1, id),
  itemRefs: currentDirectoryItems(state$1, id),
  currentDirectoryLoadingState: currentDirectoryLoadingState(state$1, id),
  getItemByTypeAndId: getItemByTypeAndId(state$1),

  // Upload State
  percentByFiles: percentByFiles(state$1, id),
  uploadPickerState: state(state$1, id),
  uploadSuccess: didSucceed(state$1, id),
  uploadError: didError(state$1, id),
  uploadWarning: didWarn(state$1, id),
  uploadStatusMsg: statusMessage(state$1, id)
}), {
  // General Actions
  pick: pick$1,
  endPick: endPick$1,
  setPickerType: setPickerType,
  fetchPage: fetchPage,
  selectNode: selectNode,
  selectCrumb: selectCrumb,

  // Upload Actions
  uploadToTDO: uploadToTDO,
  abortRequest: abortRequest,
  retryRequest: retryRequest$1,
  retryDone: retryDone$1,

  // Search Actions
  setSearchValue: setSearchValue,
  clearSearch: clearSearch
}), _dec$4(_class$4 = _dec2$2(_class$4 = _dec3$2(_class$4 = (_temp2$4 = _class2$4 = class DataPicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      showError: false,
      errorMsg: ''
    }, this.handlePick = () => {
      const {
        id,
        pick,
        enableFolders,
        enableStreams,
        enableUploads
      } = this.props;
      id && pick && pick(id, {
        enableFolders,
        enableStreams,
        enableUploads
      });
    }, this.handleOnPick = (pickedRefs = []) => {
      const { id, onPick, getItemByTypeAndId, endPick } = this.props;
      const items = pickedRefs.map(ref => getItemByTypeAndId(ref.type, ref.id));
      if (items.length && onPick) {
        onPick(items);
        endPick(id);
      }
    }, this.handleOnCancel = () => {
      const { id, abortRequest, endPick } = this.props;
      id && endPick && endPick(id);
      id && abortRequest && abortRequest(id);
    }, this.handleSetPickerType = pickerType => {
      const { id, setPickerType } = this.props;
      id && pickerType && setPickerType && setPickerType(id, pickerType);
    }, this.triggerPagination = () => {
      const { id, fetchPage, currentDirectoryLoadingState } = this.props;
      const { nodeOffset = 0, leafOffset = 0 } = currentDirectoryLoadingState;
      id && (nodeOffset >= 0 || leafOffset >= 0) && fetchPage && fetchPage(id);
    }, this.handleNodeSelection = (selectedNodes = []) => {
      const { id, selectNode, fetchPage } = this.props;
      // Don't do anything if mixed types are present
      const mixedSelection = _Object$keys(selectedNodes.reduce((acc, node) => {
        acc[node.type] = true;
        return acc;
      }, {})).length > 1;
      if (mixedSelection || !selectedNodes.length) {
        return;
      }
      const type = _get(selectedNodes, '[0].type');
      // Determine whether to "select" or "pick" the nodes
      if (type !== 'tdo' && selectedNodes.length === 1) {
        id && selectNode && selectNode(id, selectedNodes);
        id && fetchPage && fetchPage(id);
      } else if (type === 'tdo') {
        // Selected an item to open (tdo for now)
        this.handleOnPick(selectedNodes);
      }
    }, this.handleCrumbSelection = crumb => {
      const { id, selectCrumb } = this.props;
      id && crumb && selectCrumb && selectCrumb(id, Number(crumb.index));
    }, this.handleUploadToTDO = (uploadedFiles = []) => {
      const { id, onPick, uploadToTDO } = this.props;
      uploadToTDO && uploadToTDO(id, uploadedFiles, onPick);
    }, this.handleRetryDone = () => {
      const { id, onPick, retryDone } = this.props;
      retryDone && retryDone(id, onPick);
    }, this.handleRetry = () => {
      const { id, retryRequest, onPick } = this.props;
      retryRequest && retryRequest(id, onPick);
    }, this.handleAbort = fileKey => {
      const { id, abortRequest } = this.props;
      abortRequest && abortRequest(id, fileKey);
    }, this.handleOnSearch = searchValue => {
      const { id, setSearchValue } = this.props;
      setSearchValue && setSearchValue(id, searchValue);
    }, this.handleOnClear = () => {
      const { clearSearch } = this.props;
      clearSearch && clearSearch();
    }, this.handleShowErrorMsg = errorMsg => () => {
      this.setState({
        showError: true,
        errorMsg
      });
    }, this.handleCloseErrorMsg = () => {
      this.setState({
        showError: false,
        errorMsg: ''
      });
    }, _temp;
  }

  render() {
    const {
      currentDirectoryLoadingState,
      itemRefs,
      getItemByTypeAndId,
      classes,
      height = 1,
      width = 1
    } = this.props;
    const { showError, errorMsg } = this.state;
    const { open, internalState, fullScreen } = this.props;
    const items = itemRefs.map(item => getItemByTypeAndId(item.type, item.id));
    const dimensionOverride = fullScreen ? {} : {
      height,
      width
    };

    const openState = open === undefined ? internalState : open;
    return React__default.createElement(
      Fragment$1,
      null,
      React__default.createElement(
        Dialog,
        {
          open: openState || false,
          fullScreen: fullScreen,
          classes: { paper: classes.dataPickerPaper },
          PaperProps: { style: dimensionOverride }
        },
        React__default.createElement(DataPicker$1, _extends$1({}, this.props, {
          items: items,
          onErrorMsg: this.handleShowErrorMsg,
          isError: currentDirectoryLoadingState.error,
          isLoading: currentDirectoryLoadingState.isLoading,
          isLoaded: currentDirectoryLoadingState.isLoaded,
          onUpload: this.handleUploadToTDO,
          handleAbort: this.handleAbort,
          onRetryDone: this.handleRetryDone,
          retryRequest: this.handleRetry,
          setPickerType: this.handleSetPickerType,
          triggerPagination: this.triggerPagination,
          onCancel: this.handleOnCancel,
          onSelectItem: this.handleNodeSelection,
          onCrumbClick: this.handleCrumbSelection,
          onSearch: this.handleOnSearch,
          onClear: this.handleOnClear
        }))
      ),
      this.props.renderButton && this.props.renderButton({ handlePickFiles: this.handlePick }),
      React__default.createElement(
        Snackbar,
        {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          open: showError,
          autoHideDuration: 5000,
          onClose: this.handleCloseErrorMsg
        },
        React__default.createElement(SnackbarContent, {
          className: classes.dataPickerErrorSnack,
          message: errorMsg,
          action: [React__default.createElement(
            IconButton,
            { key: 'close-btn', onClick: this.handleCloseErrorMsg },
            React__default.createElement(CloseIcon, null)
          )]
        })
      )
    );
  }
}, _class2$4.propTypes = {
  id: string.isRequired,
  fullScreen: bool,
  open: bool,
  internalState: bool,
  pick: func,
  onPick: func.isRequired,
  endPick: func.isRequired,
  abortRequest: func.isRequired,
  setPickerType: func.isRequired,
  selectCrumb: func.isRequired,
  onPickCancelled: func,
  enableFolders: bool,
  enableStreams: bool,
  enableUploads: bool,
  uploadToTDO: func.isRequired,
  retryDone: func.isRequired,
  retryRequest: func.isRequired,
  setSearchValue: func.isRequired,
  clearSearch: func.isRequired,
  renderButton: func,
  multiple: bool,
  maxItems: number,
  acceptedFileTypes: arrayOf(string),
  availablePickerTypes: arrayOf(string),
  currentPickerType: oneOf(['folder', 'stream', 'upload']),
  currentViewType: oneOf(['list', 'grid']),
  pathList: arrayOf(shape({
    id: string.isRequired,
    name: string.isRequired
  })).isRequired,
  sortCriteria: arrayOf(shape({
    field: string, // Default 'name'
    direction: oneOf(['asc', 'desc']) // Default 'asc'
  })),
  itemRefs: arrayOf(shape({
    id: string,
    type: string
  })),
  items: arrayOf(shape({
    id: string.isRequired,
    type: oneOf(['folder', 'source', 'program', 'tdo']).isRequired,
    name: string,
    startDateTime: string,
    stopDateTime: string,
    thumbnailUrl: string,
    sourceImageUrl: string,
    primaryAsset: shape({
      name: string,
      contentType: string.isRequired,
      signedUri: string.isRequired
    }),
    streams: arrayOf(shape({
      uri: string.isRequired,
      protocol: string.isRequired
    })),
    createdDateTime: string.isRequired,
    modifiedDateTime: string.isRequired
  })),
  currentDirectoryLoadingState: shape({
    isLoading: bool,
    nodeOffset: number,
    leafOffset: number,
    error: string
  }),
  fetchPage: func.isRequired,
  selectNode: func.isRequired,
  getItemByTypeAndId: func.isRequired,
  height: number,
  width: number,
  classes: shape({ any })
}, _class2$4.defaultProps = {
  onPickCancelled: _noop,
  availablePickerTypes: [],
  currentDirectoryLoadingState: {
    isLoading: false,
    nodeOffset: -1,
    leafOffset: -1
  },
  itemRefs: []
}, _temp2$4)) || _class$4) || _class$4) || _class$4);
DataPicker.displayName = 'DataPicker';
let DataPickerWidgetComponent = (_dec4$1 = connect(null, {
  pick: pick$1,
  endPick: endPick$1
}, null, { forwardRef: true }), _dec4$1(_class3$2 = (_temp4$2 = _class4$1 = class DataPickerWidgetComponent extends React__default.Component {
  constructor(...args) {
    var _temp3;

    return _temp3 = super(...args), this.pickCallback = _noop, this.pick = (callback = _noop) => {
      const {
        _widgetId,
        pick,
        enableFolders,
        enableStreams,
        enableUploads
      } = this.props;
      this.pickCallback = callback;
      pick && pick(_widgetId, {
        enableFolders,
        enableStreams,
        enableUploads
      });
    }, this.cancel = () => {
      this.props.endPick(this.props._widgetId);
      this.callCancelledCallback();
    }, this.callCancelledCallback = () => {
      this.pickCallback(null);
    }, this.onPick = items => {
      this.pickCallback && this.pickCallback(items);
    }, _temp3;
  }

  render() {
    return React__default.createElement(DataPicker, _extends$1({
      id: this.props._widgetId,
      onPick: this.onPick
    }, this.props));
  }
}, _class4$1.propTypes = {
  _widgetId: string.isRequired,
  pick: func.isRequired,
  endPick: func.isRequired,
  enableFolders: bool,
  enableStreams: bool,
  enableUploads: bool
}, _temp4$2)) || _class3$2);
DataPickerWidgetComponent.displayName = 'DataPickerWidgetComponent';


const DataPickerWidget = widget(DataPickerWidgetComponent);

var Search = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.default = _default;
});

var SearchIcon = unwrapExports(Search);

const muiTextStyles = {
  'display4': {
    'font-weight': 300,
    'font-size': '112px',
    'line-height': '112px'
  },
  'display3': {
    'font-weight': 400,
    'font-size': '56px',
    'line-height': '56px'
  },
  'display2': {
    'font-weight': 400,
    'font-size': '45px',
    'line-height': '48px'
  },
  'display1': {
    'font-weight': 400,
    'font-size': '34px',
    'line-height': '40px'
  },
  'headline': {
    'font-weight': 400,
    'font-size': '24px',
    'line-height': '32px'
  },
  'title': {
    'font-weight': 400,
    'font-size': '20px',
    'line-height': '28px'
  },
  'subhead': {
    'font-weight': 400,
    'font-size': '16px',
    'line-height': '24px'
  },
  'body2': {
    'font-weight': 500,
    'font-size': '14px',
    'line-height': '20px'
  },
  'body1': {
    'font-weight': 400,
    'font-size': '14px',
    'line-height': '20px'
  },
  'caption': {
    'font-weight': 400,
    'font-size': '12px',
    'line-height': '16px'
  },
  'menu': {
    'font-weight': 500,
    'font-size': '13px',
    'line-height': '17px'
  },
  'button': {
    'font-weight': 500,
    'font-size': '14px',
    'line-height': '18px'
  }
};

const muiText = muiName => {
  const muiStyles = muiTextStyles[muiName];
  const css = {
    fontWeight: `${muiStyles['font-weight']} !important`,
    fontSize: `${muiStyles['font-size']} !important`,
    lineHeight: `${muiStyles['line-height']} !important`
  };

  if (muiName === 'button') {
    css['textTransform'] = 'uppercase';
  }

  return css;
};

const height = 73;
const iconSize = '22px !important';
const body1Text = muiText('body1');

var styles$5 = {
  selectBar: _extends$1({}, body1Text, {
    display: 'flex',
    alignItems: 'center',
    color: lightBlack,
    padding: '15px 0 10px 5px',
    minHeight: height,
    maxHeight: height
  }),
  selectBarIcons: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 'auto',
    padding: '0 20px'
  },
  searchBar: {
    width: 285
  },
  searchBarIcon: {
    height: iconSize,
    width: iconSize,
    verticalAlign: 'bottom'
  },
  searchBarInput: _extends$1({}, body1Text),
  searchBarUnderline: {
    '&:before': {
      height: '1px !important'
    }
  },
  actionMenuDividerContainer: {
    padding: '0 20px'
  },
  actionMenuDivider: {
    borderRight: `1px solid ${lightBlack}`,
    width: 1,
    height: 28
  }
};

var _class$5, _temp2$5;

let SearchBar = (_temp2$5 = _class$5 = class SearchBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      searchQuery: this.props.searchQuery
    }, this.handleToggleSearch = () => {
      this.props.onToggleSearch(this.props.id);

      if (this.props.isOpen && this.props.searchQuery) {
        this.props.onClearSearch(this.props.id);
      }
    }, this.handleChange = event => {
      this.setState({
        searchQuery: event.target.value
      });

      this.props.onSearch(event.target.value);
    }, _temp;
  }

  render() {
    const { classes } = this.props;

    return this.props.isOpen ? React__default.createElement(TextField$1, {
      className: classes.searchBar,
      placeholder: 'Search by engine name',
      value: this.state.searchQuery,
      onChange: this.handleChange,
      inputProps: {
        className: classes.searchBarInput
      },
      InputProps: {
        classes: {
          underline: classes.searchBarUnderline
        },
        endAdornment: React__default.createElement(
          InputAdornment,
          { className: classes.searchBarIcon, position: 'end' },
          React__default.createElement(
            IconButton,
            {
              className: classes.searchBarIcon,
              onClick: this.handleToggleSearch
            },
            React__default.createElement(CloseIcon, null)
          )
        )
      }
    }) : React__default.createElement(
      IconButton,
      {
        onClick: this.handleToggleSearch,
        className: classes.searchBarIcon
      },
      React__default.createElement(SearchIcon, null)
    );
  }
}, _class$5.propTypes = {
  id: string.isRequired,
  searchQuery: string,
  onToggleSearch: func.isRequired,
  isOpen: bool,
  onSearch: func.isRequired,
  onClearSearch: func.isRequired,
  classes: shape({ any })
}, _class$5.defaultProps = {
  isOpen: false,
  searchQuery: ''
}, _temp2$5);
SearchBar.displayName = 'SearchBar';


var SearchBar$1 = withStyles(styles$5)(SearchBar);

var _class$6, _temp;

let SelectBar = (_temp = _class$6 = class SelectBar extends React__default.Component {

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.selectBar },
      React__default.createElement(Checkbox, {
        color: 'primary',
        checked: !!this.props.isChecked,
        onChange: this.props.onCheckAll,
        disabled: !this.props.count
      }),
      React__default.createElement(
        'div',
        null,
        'Select All (',
        this.props.count,
        ')'
      ),
      React__default.createElement(
        'div',
        { className: classes.selectBarIcons },
        React__default.createElement(SearchBar$1, {
          key: this.props.id + this.props.isSearchOpen + this.props.currentTab,
          id: this.props.id,
          onSearch: this.props.onSearch,
          onClearSearch: this.props.onClearSearch,
          onToggleSearch: this.props.onToggleSearch,
          searchQuery: this.props.searchQuery,
          isOpen: this.props.isSearchOpen
        }),
        this.props.actionMenuItems && React__default.createElement(
          'div',
          { className: classes.actionMenuDividerContainer },
          React__default.createElement('div', { className: classes.actionMenuDivider })
        ),
        this.props.actionMenuItems && this.props.actionMenuItems.map(({ buttonText, iconClass, onClick }) => buttonText ? React__default.createElement(
          Button,
          {
            key: `${buttonText}-${iconClass}`,
            onClick: onClick,
            color: 'primary'
          },
          buttonText
        ) : React__default.createElement(
          IconButton,
          {
            key: `${buttonText}-${iconClass}`,
            onClick: onClick
          },
          React__default.createElement('i', { className: iconClass })
        ))
      )
    );
  }
}, _class$6.propTypes = {
  id: string.isRequired,
  currentTab: string.isRequired,
  onCheckAll: func.isRequired,
  searchQuery: string,
  onSearch: func.isRequired,
  onClearSearch: func.isRequired,
  isChecked: bool.isRequired,
  isSearchOpen: bool.isRequired,
  onToggleSearch: func.isRequired,
  actionMenuItems: arrayOf(shape({
    buttonText: string,
    iconClass: string,
    onClick: func.isRequired
  })),
  count: number.isRequired,
  classes: shape({ any })
}, _temp);
SelectBar.displayName = 'SelectBar';


var SelectBar$1 = withStyles(styles$5)(SelectBar);

const dimensions = '24px !important';
const width = 250;
const iconSize$1 = '50px !important';
const body1Text$1 = muiText('body1');

const checkboxCss = {
  height: dimensions,
  width: dimensions,
  marginRight: '8px !important'
};

var styles$6 = {
  sideBar: {
    minWidth: width,
    maxWidth: width,
    borderRight: `1px solid ${grey4}`
  },
  isFetching: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 0'
  },
  failedToFetchIcon: {
    height: iconSize$1,
    width: iconSize$1,
    color: 'rgba(0, 0, 0, 0.26)'
  },
  failedToFetchMessage: {
    fontSize: '18px',
    color: lightBlack,
    fontWeight: '200',
    margin: '15px 0'
  },
  inlineFilter: {
    display: 'inline-flex',
    alignItems: 'center',
    marginBottom: '10px'
  },
  filterContainer: _extends$1({}, body1Text$1, {
    padding: '10px 20px',
    color: fullBlack
  }),
  title: {
    fontWeight: 500,
    marginBottom: 10
  },
  rcSliderHandle: {
    border: `2px solid ${blue1} !important`,
    backgroundColor: `${blue1} !important`
  },
  rcSliderTrack: {
    backgroundColor: `${blue1} !important`
  },
  checkbox: _extends$1({}, checkboxCss),
  radio: _extends$1({}, checkboxCss)
};

var ErrorOutline = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

exports.default = _default;
});

var ErrorOutlineIcon = unwrapExports(ErrorOutline);

var Refresh = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
}), 'Refresh');

exports.default = _default;
});

var RefreshIcon = unwrapExports(Refresh);

var blue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var _default = blue;
exports.default = _default;
});

var blue = unwrapExports(blue_1);

const headlineText = muiText('headline');

var styles$7 = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 100,
    '& $message': _extends$1({}, headlineText, {
      fontWeight: '200 !important',
      color: lightBlack,
      margin: '15px 0'
    }),
    '& $errorIcon': {
      height: 105,
      width: 105,
      color: 'rgba(0, 0, 0, 0.26)'
    },
    '& $button': {
      backgroundColor: fullWhite
    },
    '& $icon': {
      marginRight: 10
    }
  },
  message: {},
  errorIcon: {},
  button: {},
  icon: {}
};

const useStyles$3 = makeStyles(styles$7);

const FailureScreen = ({
  message = 'Oops! Something went wrong.',
  classes,
  onRetry
}) => {
  const muiClasses = useStyles$3();
  const classesProps = classes ? classes : {
    errorOutlineIcon: {
      root: muiClasses.errorIcon
    },
    message: {
      root: muiClasses.message
    },
    button: {
      root: muiClasses.button
    }
  };

  return React__default.createElement(
    'div',
    { className: muiClasses.container },
    React__default.createElement(ErrorOutlineIcon, { classes: classesProps.errorOutlineIcon }),
    React__default.createElement(
      Typography,
      { variant: 'h5', classes: classesProps.message },
      message
    ),
    React__default.createElement(
      Button,
      { variant: 'contained', classes: classesProps.button, onClick: onRetry },
      React__default.createElement(RefreshIcon, { htmlColor: blue[500], className: muiClasses.icon }),
      'Retry'
    )
  );
};

FailureScreen.displayName = 'FailureScreen';
FailureScreen.propTypes = {
  message: string,
  classes: shape({
    errorIcon: objectOf(oneOfType([string, number])),
    message: objectOf(oneOfType([string, number])),
    button: objectOf(oneOfType([string, number]))
  }),
  onRetry: func.isRequired
};

var _dec$5, _dec2$3, _class$7, _class2$5, _temp2$6;
const { engine: engineModule$1 } = modules;

let CategoriesFilter = (_dec$5 = withStyles(styles$6), _dec2$3 = connect((state, { id }) => ({
  engineCategories: engineModule$1.getEngineCategories(state),
  isFetchingEngineCategories: engineModule$1.isFetchingEngineCategories(state),
  failedToFetchEngineCategories: engineModule$1.failedToFetchEngineCategories(state)
}), {
  fetchEngineCategories: engineModule$1.fetchEngineCategories
}), _dec$5(_class$7 = _dec2$3(_class$7 = (_temp2$6 = _class2$5 = class CategoriesFilter extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.addCategory = category => {
      this.props.filterBy(this.props.id, {
        type: 'category',
        value: [...this.props.filters.category, category]
      });
    }, this.removeCategory = category => {
      this.props.filterBy(this.props.id, {
        type: 'category',
        value: _without(this.props.filters.category, category)
      });
    }, this.handleClick = category => {
      if (this.props.filters.category && this.props.filters.category.includes(category)) {
        this.removeCategory(category);
      } else {
        this.addCategory(category);
      }
    }, this.handleRefetchCategories = () => {
      this.props.fetchEngineCategories();
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    if (this.props.isFetchingEngineCategories) {
      return React__default.createElement(
        'div',
        { className: classes.isFetching },
        React__default.createElement(CircularProgress, { size: 50 })
      );
    }

    if (this.props.failedToFetchEngineCategories) {
      return React__default.createElement(FailureScreen, {
        message: 'Failed to fetch categories.',
        classes: {
          errorOutlineIcon: {
            root: classes.failedToFetchIcon
          },
          message: {
            root: classes.failedToFetchMessage
          }
        },
        onRetry: this.handleRefetchCategories
      });
    }

    return React__default.createElement(
      'div',
      { className: classes.filterContainer },
      React__default.createElement(
        'div',
        null,
        _sortBy(this.props.engineCategories, ['name']).map(category => React__default.createElement(
          'div',
          { key: category.name },
          React__default.createElement(
            'div',
            { className: classes.inlineFilter },
            React__default.createElement(Checkbox, {
              color: 'primary',
              classes: { root: classes.checkbox },
              checked: this.props.filters.category.includes(category.name),
              onClick: () => this.handleClick(category.name) // eslint-disable-line
            }),
            category.name
          )
        ))
      )
    );
  }
}, _class2$5.propTypes = {
  id: string.isRequired,
  filters: shape({
    category: arrayOf(string).isRequired
  }).isRequired,
  filterBy: func.isRequired,
  engineCategories: arrayOf(shape({
    name: string.isRequired
  })),
  fetchEngineCategories: func.isRequired,
  isFetchingEngineCategories: bool.isRequired,
  failedToFetchEngineCategories: bool.isRequired,
  classes: shape({ any })
}, _temp2$6)) || _class$7) || _class$7);
CategoriesFilter.displayName = 'CategoriesFilter';


var CategoriesFilter$1 = {
  label: 'Categories',
  id: 'categories',
  component: CategoriesFilter
};

var _class$8, _temp2$7;

let DeploymentModelFilter = (_temp2$7 = _class$8 = class DeploymentModelFilter extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleChange = event => {
      this.props.filterBy(this.props.id, {
        type: 'deploymentModel',
        value: event.target.value
      });
    }, _temp;
  }

  render() {
    const deploymentModels = {
      FullyNetworkIsolated: 'Network Isolated',
      MostlyNetworkIsolated: 'External Access',
      NonNetworkIsolated: 'External Processing',
      HumanReview: 'Human Review'
    };
    const { classes } = this.props;

    return React__default.createElement(
      'div',
      { className: classes.filterContainer },
      _Object$keys(deploymentModels).map(deploymentModel => React__default.createElement(
        'div',
        { className: classes.inlineFilter, key: deploymentModel },
        React__default.createElement(Radio, {
          color: 'primary',
          classes: { root: classes.radio },
          checked: this.props.filters.deploymentModel === deploymentModel,
          onChange: this.handleChange,
          value: deploymentModel,
          'aria-label': deploymentModel
        }),
        deploymentModels[deploymentModel]
      ))
    );
  }
}, _class$8.propTypes = {
  id: string.isRequired,
  filters: shape({
    deploymentModel: string
  }).isRequired,
  filterBy: func.isRequired,
  classes: shape({ any })
}, _temp2$7);
DeploymentModelFilter.displayName = 'DeploymentModelFilter';


var DeploymentModelFilter$1 = {
  label: 'Deployment Model',
  id: 'deploymentModel',
  component: withStyles(styles$6)(DeploymentModelFilter)
};



var Filters = /*#__PURE__*/Object.freeze({
	Categories: CategoriesFilter$1,
	DeploymentModel: DeploymentModelFilter$1
});

var _dec$6, _dec2$4, _class$9, _class2$6, _temp2$8;

let EnginesSideBar = (_dec$6 = withStyles(styles$6), _dec2$4 = connect((state, { id }) => ({
  filters: getEngineFilters(state, id),
  activeSidebarPath: getActiveSidebarPath(state, id)
}), {
  addEngineFilter: addEngineFilter,
  removeEngineFilter: removeEngineFilter,
  clearAllFilters: clearAllFilters,
  setActiveSidebarPath: setActiveSidebarPath
}), _dec$6(_class$9 = _dec2$4(_class$9 = (_temp2$8 = _class2$6 = class EnginesSideBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleFiltersNavigate = newPath => {
      this.props.setActiveSidebarPath(this.props.id, newPath);
    }, this.handleClearFilter = id => {
      const { filter, value } = JSON.parse(id);
      const { filters } = this.props;

      if (!filters[filter].length) {
        return;
      }

      if (_isArray$1(filters[filter])) {
        this.props.addEngineFilter(this.props.id, {
          type: filter,
          value: _without(filters[filter], value)
        });
      }

      if (_isString(filters[filter])) {
        this.props.removeEngineFilter(this.props.id, {
          type: filter,
          value
        });
      }
    }, this.handleClearAllFilters = () => {
      this.props.clearAllFilters(this.props.id);
    }, this.getSelectedFilters = filters => {
      const selectedFilters = [];

      _Object$keys(filters).map((filter, i) => {
        if (!filters[filter].length) {
          return;
        }

        if (_isArray$1(filters[filter])) {
          if (filter === 'rating') {
            selectedFilters.push({
              id: _JSON$stringify({ filter, value: filters[filter] }),
              label: `Rating: ${filters[filter][0]} & Up`
            });
          } else {
            filters[filter].map(value => selectedFilters.push({
              id: _JSON$stringify({ filter, value }),
              label: value
            }));
          }
        }

        if (_isString(filters[filter])) {
          selectedFilters.push({
            id: _JSON$stringify({ filter, value: filters[filter] }),
            label: filters[filter]
          });
        }
      });

      return selectedFilters;
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    const engineFilters = {
      children: _Object$values(Filters).map(({ label, id }) => {
        return {
          label,
          children: [{ formComponentId: id }]
        };
      })
    };

    const formComponents = _Object$values(Filters).reduce((acc, { id, component: Component }) => _extends$1({}, acc, {
      [id]: React__default.createElement(Component, {
        id: this.props.id,
        filters: this.props.filters,
        filterBy: this.props.addEngineFilter
      })
    }), {});

    return React__default.createElement(
      'div',
      { className: classes.sideBar },
      React__default.createElement(DiscoverySideBarPure, {
        tabs: ['Filters'],
        clearAllFilters: false,
        onClearFilter: this.handleClearFilter,
        onClearAllFilters: this.handleClearAllFilters,
        filtersSections: engineFilters,
        formComponents: formComponents,
        selectedFilters: this.getSelectedFilters(this.props.filters),
        selectedTab: 'Filters',
        onSelectTab: _noop,
        filtersActivePath: this.props.activeSidebarPath,
        onFiltersNavigate: this.handleFiltersNavigate
      })
    );
  }
}, _class2$6.propTypes = {
  id: string.isRequired,
  filters: shape({
    category: arrayOf(string)
  }).isRequired,
  activeSidebarPath: arrayOf(number),
  addEngineFilter: func.isRequired,
  removeEngineFilter: func.isRequired,
  clearAllFilters: func.isRequired,
  setActiveSidebarPath: func.isRequired,
  classes: shape({ any })
}, _temp2$8)) || _class$9) || _class$9);
EnginesSideBar.displayName = 'EnginesSideBar';

var KeyboardBackspace = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
}), 'KeyboardBackspace');

exports.default = _default;
});

var BackIcon = unwrapExports(KeyboardBackspace);

const body1Text$2 = muiText('body1');
const body2Text = muiText('body2');

var styles$8 = {
  addRemoveSelectedBar: _extends$1({}, body1Text$2, {
    display: 'inline-flex',
    width: '100%',
    height: 49,
    padding: '0 30px',
    color: lightBlack,
    borderBottom: `1px solid ${grey4}`,
    backgroundColor: '#f6fbff',
    alignItems: 'center'
  }),
  back: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  selectedCountText: _extends$1({}, body1Text$2, {
    color: darkBlack,
    marginLeft: 10
  }),
  selectMessage: _extends$1({
    color: blue1
  }, body2Text),
  selectedCount: {
    fontWeight: '500 !important'
  },
  bulkActions: {
    display: 'inline-flex',
    marginLeft: 'auto'
  }
};

const useStyles$4 = makeStyles(styles$8);

function SelectedActionBar({
  id,
  selectedEngines,
  currentResultsCount,
  allEngines,
  onBack,
  onAddSelected,
  onRemoveSelected,
  onSelectAll,
  disabledSelectAllMessage
}) {
  const classes = useStyles$4();
  const handleAddSelected = () => {
    onAddSelected(id, selectedEngines);
    onBack(id);
  };
  const handleRemoveSelected = () => {
    onRemoveSelected(id, selectedEngines);
    onBack(id);
  };

  const handleSelectAll = e => {
    e.preventDefault();
    onSelectAll(id, allEngines);
  };

  const displaySelectAllMessage = false; // disabled for now
  // !disabledSelectAllMessage &&
  // selectedEngines.length === currentResultsCount &&
  // selectedEngines.length < allEngines.length;

  return React__default.createElement(
    'div',
    { className: classes.addRemoveSelectedBar },
    React__default.createElement(
      'div',
      { className: classes.back },
      React__default.createElement(
        IconButton,
        { onClick: onBack },
        React__default.createElement(BackIcon, null)
      ),
      React__default.createElement(
        'div',
        { className: classes.selectedCountText },
        displaySelectAllMessage && React__default.createElement(
          'div',
          null,
          'All',
          ' ',
          React__default.createElement(
            'span',
            { className: classes.selectedCount },
            `${selectedEngines.length}`
          ),
          ' ',
          'engines on this page are selected.',
          ' ',
          React__default.createElement(
            'a',
            {
              href: '#',
              onClick: handleSelectAll // eslint-disable-line
            },
            'Select all',
            ' ',
            React__default.createElement(
              'span',
              { className: classes.selectedCount },
              `${allEngines.length}`
            ),
            ' ',
            'available engines.'
          )
        ),
         React__default.createElement(
          'div',
          { className: classes.selectMessage },
          selectedEngines.length,
          ' selected'
        )
      )
    ),
    React__default.createElement(
      'div',
      { className: classes.bulkActions },
      React__default.createElement(
        Button,
        {
          color: 'primary',
          onClick: handleAddSelected // eslint-disable-line
          , disabled: disabledSelectAllMessage
        },
        'Add Selected'
      ),
      React__default.createElement(
        Button,
        {
          color: 'primary',
          onClick: handleRemoveSelected // eslint-disable-line
        },
        'Remove Selected'
      )
    )
  );
}

SelectedActionBar.displayName = 'SelectedActionBar';
SelectedActionBar.propTypes = {
  id: string.isRequired,
  selectedEngines: arrayOf(string).isRequired,
  currentResultsCount: number.isRequired,
  allEngines: arrayOf(string).isRequired,
  onBack: func.isRequired,
  onAddSelected: func.isRequired,
  onRemoveSelected: func.isRequired,
  onSelectAll: func.isRequired,
  disabledSelectAllMessage: bool.isRequired
};

var networkIsolatedLogo = "data:image/png;base64,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";

var externalAccessLogo = "data:image/png;base64,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";

var externalProcessingLogo = "data:image/png;base64,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";

var humanReviewLogo = "data:image/png;base64,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";

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var Clear = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

exports.default = _default;
});

var ClearIcon = unwrapExports(Clear);

var styles$9 = {
  default: {
    borderRadius: '4px !important',
    border: '1px solid transparent !important'
  },
  remove: {
    border: '1px solid rgba(0, 0, 0, 0.26) !important',
    minWidth: '143px !important'
  },
  icon: {
    marginRight: 5
  }
};

var _class$a, _temp2$9;
let ToggleButton = (_temp2$9 = _class$a = class ToggleButton extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleAdd = () => this.props.onAdd(this.props.id, [this.props.engineId]), this.handleRemove = () => this.props.onRemove(this.props.id, [this.props.engineId]), _temp;
  }

  render() {
    const { classes } = this.props;
    const buttonClasses = classnames(classes.default, {
      [classes.remove]: this.props.isSelected
    });

    return React__default.createElement(
      Button,
      {
        className: buttonClasses,
        variant: this.props.isSelected ? 'text' : 'contained',
        color: this.props.isSelected ? 'default' : 'primary',
        onClick: this.props.isSelected ? this.handleRemove : this.handleAdd
      },
      React__default.createElement(ClearIcon, { className: classes.icon }),
      this.props.isSelected ? 'Remove' : 'Add Engine'
    );
  }
}, _class$a.propTypes = {
  id: string.isRequired,
  onAdd: func.isRequired,
  onRemove: func.isRequired,
  engineId: string.isRequired,
  isSelected: bool.isRequired,
  classes: shape({ any })
}, _temp2$9);
ToggleButton.displayName = 'ToggleButton';


var ToggleButton$1 = withStyles(styles$9)(ToggleButton);

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

const avatar = (dimensions = 137) => ({
  position: 'relative',
  width: dimensions,
  minWidth: dimensions,
  maxWidth: dimensions,
  height: dimensions,
  border: `1px solid ${faintBlack}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > i': {
    fontSize: 80,
    color: lightBlack
  }
});

var commonCss = {
  row: {
    display: 'flex',
    padding: '19px 0 40px',
    minHeight: 177
  },
  orgName: {
    marginBottom: 5,
    fontSize: 13,
    color: lightBlack
  },
  info: {
    display: 'flex',
    alignItems: 'center'
  },
  container: {
    display: 'inline-flex',
    paddingTop: 3,
    flexGrow: 1
  },
  title: {
    fontSize: 18,
    lineHeight: '21px',
    marginBottom: 5
  },
  primary: {
    flexGrow: 1,
    padding: '0 20px',
    display: 'inline-flex',
    flexDirection: 'column'
  },
  logo: {
    height: 16,
    alignItems: 'center',
    display: 'inline-flex',
    '& img': {
      height: 'auto'
    }
  },
  avatar: {
    display: 'inline-flex',
    flexDirection: 'column'
  },
  secondary: {
    display: 'inline-flex',
    flexDirection: 'column'
  },
  logos: {
    display: 'inline-flex'
  }
};

var styles$a = cjs(commonCss, {
  row: {
    paddingBottom: 20,
    maxHeight: 177,
    borderTop: `1px solid ${grey4}`
  },
  avatar: _extends$1({}, avatar()),
  engineSelect: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  primary: {
    borderRight: `2px solid ${grey4}`
  },
  icon: {
    height: '100%'
  },
  title: {
    '&:hover': {
      cursor: 'pointer',
      color: blue1
    }
  },
  secondary: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minWidth: '37%',
    maxWidth: '37%',
    padding: '0 20px',
    paddingRight: 0
  },
  description: {
    fontSize: 13,
    lineHeight: '20px',
    color: lightBlack,
    marginTop: 2
  },
  logos: {
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'space-between',
    width: 122,
    marginRight: 15
  },
  logo: {
    '&:first-child': {
      marginBottom: 20
    }
  },
  main: {
    display: 'flex',
    justifyContent: 'space-between'
  }
});

var _dec$7, _dec2$5, _class$b, _class2$7, _temp2$a;
const { engine: engineModule$2 } = modules;

let EngineSelectionRow = (_dec$7 = withStyles(styles$a), _dec2$5 = connect((state, ownProps) => ({
  isSelected: engineIsSelected(state, ownProps.engineId, ownProps.id),
  engine: engineModule$2.getEngine(state, ownProps.engineId),
  isChecked: engineIsChecked(state, ownProps.engineId, ownProps.id)
}), {
  selectEngines: selectEngines,
  deselectEngines: deselectEngines,
  checkEngine: checkEngine,
  uncheckEngine: uncheckEngine
}), _dec$7(_class$b = _dec2$5(_class$b = (_temp2$a = _class2$7 = class EngineSelectionRow extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleChange = () => {
      this.props.isChecked ? this.props.uncheckEngine(this.props.id, this.props.engine.id) : this.props.checkEngine(this.props.id, this.props.engine.id);
    }, this.handleClick = () => {
      this.props.onViewDetail(this.props.engine);
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    const { name, iconClass, color } = this.props.engine.category || {};

    const deploymentModelLogo = {
      FullyNetworkIsolated: networkIsolatedLogo,
      MostlyNetworkIsolated: externalAccessLogo,
      NonNetworkIsolated: externalProcessingLogo,
      HumanReview: humanReviewLogo
    };

    return React__default.createElement(
      'div',
      { className: classes.row },
      React__default.createElement(
        'div',
        { className: classes.avatar },
        this.props.engine.iconPath ? React__default.createElement('img', { className: classes.icon, src: this.props.engine.iconPath }) : React__default.createElement('i', { className: 'icon-engines' }),
        React__default.createElement(
          'div',
          { className: classes.engineSelect },
          React__default.createElement(Checkbox, {
            color: 'primary',
            onChange: this.handleChange,
            checked: this.props.isChecked
          })
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.container },
        React__default.createElement(
          'div',
          { className: classes.primary },
          React__default.createElement(
            'div',
            { className: classes.main },
            React__default.createElement(
              'div',
              { className: classes.headings },
              React__default.createElement(
                'div',
                { className: classes.title, onClick: this.handleClick },
                this.props.engine.name
              ),
              React__default.createElement(
                'div',
                { className: classes.orgName },
                _get(this.props, 'engine.ownerOrganization.name')
              )
            )
          ),
          React__default.createElement(
            'div',
            { className: classes.info },
            name && React__default.createElement(
              Lozenge,
              { iconClassName: iconClass, backgroundColor: color },
              name
            )
          ),
          React__default.createElement(
            'div',
            { className: classes.description },
            this.props.engine.description && React__default.createElement(
              Truncate,
              { clamp: 3 },
              this.props.engine.description
            )
          )
        ),
        React__default.createElement(
          'div',
          { className: classes.secondary },
          React__default.createElement(
            'div',
            { className: classes.logos },
            React__default.createElement(
              'div',
              { className: classes.logo },
              React__default.createElement('img', {
                className: classes.icon,
                src: deploymentModelLogo[this.props.engine.deploymentModel]
              })
            )
          ),
          React__default.createElement(
            'div',
            null,
            React__default.createElement(ToggleButton$1, {
              id: this.props.id,
              onAdd: this.props.selectEngines,
              onRemove: this.props.deselectEngines,
              engineId: this.props.engine.id,
              isSelected: this.props.isSelected
            })
          )
        )
      )
    );
  }
}, _class2$7.propTypes = {
  id: string.isRequired,
  engine: shape({
    id: string.isRequired,
    name: string.isRequired,
    category: object,
    description: string,
    iconPath: string,
    ownerOrganization: object
  }).isRequired,
  isSelected: bool.isRequired,
  isChecked: bool.isRequired,
  onViewDetail: func.isRequired,
  selectEngines: func.isRequired,
  deselectEngines: func.isRequired,
  checkEngine: func.isRequired,
  uncheckEngine: func.isRequired,
  classes: shape({ any })
}, _temp2$a)) || _class$b) || _class$b);
EngineSelectionRow.displayName = 'EngineSelectionRow';

var _class$c, _temp2$b;

// see https://github.com/bvaughn/react-virtualized/blob/master/docs/creatingAnInfiniteLoadingList.md
let EngineList = (_temp2$b = _class$c = class EngineList extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleLoadMoreRows = () => {
      if (this.props.isNextPageLoading) {
        return _noop;
      }

      return this.props.loadNextPage;
    }, this.isRowLoaded = ({ index }) => !this.props.hasNextPage || index < this.props.list.length, this.rowRenderer = ({ index, key, style }) => {
      let content;

      if (!this.isRowLoaded({ index })) {
        content = 'Loading...';
      } else {
        content = React__default.createElement(EngineSelectionRow, {
          id: this.props.id,
          engineId: this.props.list[index],
          onViewDetail: this.props.onViewDetail
        });
      }

      return React__default.createElement(
        'div',
        { key: key, style: style },
        content
      );
    }, _temp;
  }

  render() {
    const rowCount = this.props.hasNextPage ? this.props.list.length + 1 : this.props.list.length;

    return React__default.createElement(
      InfiniteLoader,
      {
        isRowLoaded: this.isRowLoaded,
        loadMoreRows: this.handleLoadMoreRows,
        rowCount: rowCount
      },
      ({ onRowsRendered, registerChild }) => React__default.createElement(
        AutoSizer,
        null,
        ({ width, height }) => React__default.createElement(List$1, {
          ref: registerChild,
          style: { outline: 0, padding: '0 20px' },
          height: height,
          onRowsRendered: onRowsRendered,
          rowCount: rowCount,
          rowHeight: 177,
          rowRenderer: this.rowRenderer,
          width: width
        })
      )
    );
  }
}, _class$c.propTypes = {
  id: string.isRequired,
  hasNextPage: bool.isRequired,
  isNextPageLoading: bool.isRequired,
  list: arrayOf(string).isRequired,
  loadNextPage: func,
  onViewDetail: func.isRequired
}, _temp2$b);
EngineList.displayName = 'EngineList';

const dimensions$1 = 110;
const display2Text = muiText('display2');
const subheadText = muiText('subhead');

var styles$b = {
  noEnabledEngines: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '130px 0'
  },
  noEnabledEnginesContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    height: 228,
    width: 715,
    border: `2px dashed ${faintBlack}`
  },
  noEnabledEnginesIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: dimensions$1,
    width: dimensions$1,
    borderRadius: '50%',
    border: `2px dashed ${faintBlack}`,
    marginTop: -(dimensions$1 / 2),
    marginBottom: 34,
    background: fullWhite,
    '& > i': {
      fontSize: 42,
      color: minBlack
    }
  },
  noEnabledEnginesText: {
    fontSize: 28,
    fontWeight: 300,
    color: lightBlack,
    marginBottom: 20
  },
  isFetching: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 0'
  },
  noResults: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& > i': _extends$1({}, display2Text, {
      color: minBlack
    })
  },
  noResultsMessage: _extends$1({}, subheadText, {
    fontWeight: '500 !important',
    color: minBlack
  })
};

var _dec$8, _dec2$6, _class$d, _class2$8, _temp2$c;

let EngineListContainer = (_dec$8 = withStyles(styles$b), _dec2$6 = connect((state, ownProps) => ({
  noFilterResultsFound: _isEmpty(ownProps.engineIds) && hasActiveFilters(state, ownProps.id)
}), {
  refetchEngines: refetchEngines
}), _dec$8(_class$d = _dec2$6(_class$d = (_temp2$c = _class2$8 = class EngineListContainer extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleExploreAllEnginesClick = e => {
      this.props.onExploreAllEnginesClick(e, 'explore');
    }, this.handleRefetchEngines = () => {
      this.props.refetchEngines(this.props.id);
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    if (this.props.failedToFetchEngines) {
      return React__default.createElement(FailureScreen, {
        message: 'Failed to fetch engines.',
        onRetry: this.handleRefetchEngines
      });
    }

    if (this.props.isFetchingEngines) {
      return React__default.createElement(
        'div',
        { className: classes.isFetching },
        React__default.createElement(CircularProgress, { size: 50 })
      );
    }

    if (this.props.currentTab === 'own' && this.props.noFilterResultsFound) {
      return React__default.createElement(
        'div',
        { className: classes.noResults },
        React__default.createElement('i', { className: 'icon-engines' }),
        React__default.createElement(
          'span',
          { className: classes.noResultsMessage },
          'You do not have any engines selected that match these filters.'
        )
      );
    }

    if (_isEmpty(this.props.engineIds)) {
      if (this.props.currentTab === 'explore') {
        return React__default.createElement(
          'div',
          { className: classes.noResults },
          React__default.createElement('i', { className: 'icon-engines' }),
          React__default.createElement(
            'span',
            { className: classes.noResultsMessage },
            'Your search returned no results.'
          )
        );
      }

      return React__default.createElement(
        'div',
        { className: classes.noEnabledEngines },
        React__default.createElement(
          'div',
          { className: classes.noEnabledEnginesContainer },
          React__default.createElement(
            'div',
            { className: classes.noEnabledEnginesIcon },
            React__default.createElement('i', { className: 'icon-engines' })
          ),
          React__default.createElement(
            'div',
            { className: classes.noEnabledEnginesText },
            'You have no enabled engines.'
          ),
          React__default.createElement(
            Button,
            {
              variant: 'contained',
              color: 'primary',
              onClick: this.handleExploreAllEnginesClick
            },
            'Explore all engines'
          )
        )
      );
    }

    return React__default.createElement(EngineList, {
      id: this.props.id,
      hasNextPage: false,
      isNextPageLoading: false,
      loadNextPage: _noop,
      onViewDetail: this.props.onViewDetail,
      list: this.props.engineIds
    });
  }
}, _class2$8.propTypes = {
  id: string.isRequired,
  currentTab: string.isRequired,
  engineIds: arrayOf(string),
  onExploreAllEnginesClick: func,
  noFilterResultsFound: bool.isRequired,
  onViewDetail: func.isRequired,
  isFetchingEngines: bool.isRequired,
  failedToFetchEngines: bool.isRequired,
  refetchEngines: func.isRequired,
  classes: shape({ any })
}, _temp2$c)) || _class$d) || _class$d);
EngineListContainer.displayName = 'EngineListContainer';

const body1Text$3 = muiText('body1');

var styles$c = {
  engineSelection: {
    display: 'flex',
    height: '100%',
    backgroundColor: 'white'
  },
  engineSelectionContent: {
    height: '100%',
    flexGrow: 1,
    background: 'white'
  },
  engineListContainer: {
    height: '100%',
    flexDirection: 'column',
    display: 'flex',
    background: 'white',
    padding: '0 20px',
    minHeight: 500
  },
  engineList: {
    flexGrow: 1
  },
  tabs: _extends$1({}, body1Text$3, {
    display: 'inline-flex',
    width: '100%',
    height: 49,
    padding: '0 30px',
    color: lightBlack,
    borderBottom: '1px solid $grey4'
  }),
  tab: {
    color: `${darkBlack} !important`
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '30px 50px',
    marginBottom: 'auto'
  },
  footerBtn: {
    fontWeight: 500
  }
};

var _dec$9, _dec2$7, _class$e, _class2$9, _temp2$d;
const { engine: engineModule$3 } = modules;

let EngineListView = (_dec$9 = withStyles(styles$c), _dec2$7 = connect((state, { id }) => ({
  currentResults: getCurrentResults(state, id),
  allEnginesChecked: allEnginesChecked(state, id),
  checkedEngineIds: getCheckedEngineIds(state, id),
  isFetchingEngines: engineModule$3.isFetchingEngines(state, id),
  failedToFetchEngines: engineModule$3.failedToFetchEngines(state, id),
  searchQuery: getSearchQuery(state, id),
  currentTab: getCurrentTab(state, id),
  isSearchOpen: isSearchOpen(state, id)
}), {
  selectEngines: selectEngines,
  deselectEngines: deselectEngines,
  searchEngines: searchEngines,
  checkAllEngines: checkAllEngines,
  uncheckAllEngines: uncheckAllEngines,
  clearSearch: clearSearch$1,
  changeTab: changeTab,
  toggleSearch: toggleSearch
}), _dec$9(_class$e = _dec2$7(_class$e = (_temp2$d = _class2$9 = class EngineListView extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {}, this.handleCheckAll = () => {
      const enginesToCheck = this.props.currentTab === 'explore' ? this.props.currentResults : this.props.selectedEngineIds;

      this.props.allEnginesChecked ? this.props.uncheckAllEngines(this.props.id) : this.props.checkAllEngines(this.props.id, enginesToCheck);
    }, this.handleSearch = _debounce(name => this.props.searchEngines(this.props.id, { name }), 300), this.handleTabChange = (event, tab) => {
      this.props.changeTab(this.props.id, tab);
    }, this.handleSave = () => {
      this.props.onSave();
    }, this.handleOnBack = () => {
      this.props.uncheckAllEngines(this.props.id);
    }, _temp;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (_isEmpty(prevProps.allEngines) && !_isEmpty(this.props.allEngines) && this.props.initialSelectedEngineIds) {
      this.props.selectEngines(this.props.id, this.props.initialSelectedEngineIds);
    }
  }

  render() {
    const { checkedEngineIds, currentTab, classes } = this.props;

    return React__default.createElement(
      'div',
      { className: classes.engineSelection },
      React__default.createElement(EnginesSideBar, { id: this.props.id }),
      React__default.createElement(
        'div',
        { className: classes.engineSelectionContent },
        !_isEmpty(checkedEngineIds) && React__default.createElement(SelectedActionBar, {
          id: this.props.id,
          selectedEngines: checkedEngineIds,
          disabledSelectAllMessage: currentTab === 'own',
          currentResultsCount: this.props.currentResults.length,
          onBack: this.handleOnBack,
          onAddSelected: this.props.selectEngines,
          onRemoveSelected: this.props.deselectEngines,
          onSelectAll: this.props.checkAllEngines,
          allEngines: _Object$keys(this.props.allEngines)
        }),
        _isEmpty(checkedEngineIds) && React__default.createElement(
          Tabs,
          {
            className: classes.tabs,
            value: this.props.currentTab,
            onChange: this.handleTabChange,
            indicatorColor: 'primary',
            textColor: 'primary',
            variant: 'fullWidth'
          },
          React__default.createElement(Tab, {
            classes: { selected: classes.tab },
            value: 'own',
            label: `Your Engines (${this.props.selectedEngineIds.length})`
          }),
          React__default.createElement(Tab, {
            classes: { selected: classes.tab },
            value: 'explore',
            label: 'Explore All Engines'
          })
        ),
        React__default.createElement(
          'div',
          { className: classes.engineListContainer },
          !this.props.failedToFetchEngines && React__default.createElement(SelectBar$1, {
            id: this.props.id,
            onCheckAll: this.handleCheckAll,
            searchQuery: this.props.searchQuery,
            onSearch: this.handleSearch,
            onClearSearch: this.props.clearSearch,
            onToggleSearch: this.props.toggleSearch,
            isSearchOpen: this.props.isSearchOpen,
            isChecked: this.props.allEnginesChecked,
            actionMenuItems: this.props.actionMenuItems,
            currentTab: currentTab,
            count: currentTab === 'explore' ? this.props.currentResults.length : this.props.selectedEngineIds.length
          }),
          React__default.createElement(
            'div',
            { className: classes.engineList },
            React__default.createElement(EngineListContainer, {
              id: this.props.id,
              currentTab: this.props.currentTab,
              engineIds: currentTab === 'explore' ? this.props.currentResults : this.props.selectedEngineIds,
              onViewDetail: this.props.onViewDetail,
              isFetchingEngines: this.props.isFetchingEngines,
              failedToFetchEngines: this.props.failedToFetchEngines,
              onExploreAllEnginesClick: this.handleTabChange
            })
          ),
          !this.props.hideActions && React__default.createElement(
            'div',
            { className: classes.footer },
            React__default.createElement(
              Button,
              {
                classes: { label: classes.footerBtn },
                onClick: this.props.onCancel
              },
              'Cancel'
            ),
            React__default.createElement(
              Button,
              {
                color: 'primary',
                classes: { label: classes.footerBtn },
                onClick: this.handleSave
              },
              'Save'
            )
          )
        )
      )
    );
  }
}, _class2$9.propTypes = {
  id: string.isRequired,
  allEngines: objectOf(object),
  currentResults: arrayOf(string),
  allEnginesChecked: bool.isRequired,
  selectedEngineIds: arrayOf(string).isRequired,
  checkedEngineIds: arrayOf(string).isRequired,
  initialSelectedEngineIds: arrayOf(string),
  onViewDetail: func.isRequired,
  searchQuery: string,
  isFetchingEngines: bool.isRequired,
  failedToFetchEngines: bool.isRequired,
  currentTab: string.isRequired,
  isSearchOpen: bool.isRequired,
  selectEngines: func.isRequired,
  deselectEngines: func.isRequired,
  searchEngines: func.isRequired,
  checkAllEngines: func.isRequired,
  uncheckAllEngines: func.isRequired,
  clearSearch: func.isRequired,
  changeTab: func.isRequired,
  toggleSearch: func.isRequired,
  onSave: func.isRequired,
  onCancel: func.isRequired,
  actionMenuItems: arrayOf(shape({
    buttonText: string,
    iconClass: string,
    onClick: func.isRequired
  })),
  hideActions: bool,
  classes: shape({ any })
}, _class2$9.defaultProps = {
  currentResults: []
}, _temp2$d)) || _class$e) || _class$e);
EngineListView.displayName = 'EngineListView';

const titleText = muiText('title');
const menuText = muiText('menu');
const cssAvatar = avatar(130);

var styles$d = cjs(commonCss, {
  detailsContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 100,
    backgroundColor: fullWhite
  },
  back: {
    display: 'flex',
    paddingTop: 20,
    paddingLeft: 28,
    fontSize: 20
  },
  backBtn: _extends$1({}, titleText, {
    fontWeight: '500 !important',
    color: darkBlack,
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& $span': {
      marginLeft: 10
    }
  }),
  content: {
    padding: '40px 60px'
  },
  description: {
    paddingBottom: 22
  },
  details: {
    paddingTop: 15
  },
  sectionHeading: _extends$1({}, menuText, {
    paddingBottom: 15,
    color: darkBlack
  }),
  detailsContent: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  logo: {
    marginRight: 20
  },
  avatar: _extends$1({}, cssAvatar, {
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.4)'
  }),
  info: {
    paddingBottom: 30
  },
  button: {
    paddingTop: 10
  }
});

const useStyles$5 = makeStyles(styles$d);

function InfoSection({ id, engine, onAdd, onRemove, isSelected }) {
  const classes = useStyles$5(styles$d);
  const deploymentModelLogo = {
    FullyNetworkIsolated: networkIsolatedLogo,
    MostlyNetworkIsolated: externalAccessLogo,
    NonNetworkIsolated: externalProcessingLogo,
    HumanReview: humanReviewLogo
  };

  const { name: orgName } = engine.ownerOrganization;
  const { name: categoryName, iconClass, color } = engine.category || {};

  return React__default.createElement(
    'div',
    { className: classes.row },
    React__default.createElement(
      'div',
      { className: classes.avatar },
      engine.iconPath ? React__default.createElement('img', { src: engine.iconPath }) : React__default.createElement('i', { className: 'icon-engines' })
    ),
    React__default.createElement(
      'div',
      { className: classes.container },
      React__default.createElement(
        'div',
        { className: classes.primary },
        React__default.createElement(
          'div',
          { className: classes.title },
          engine.name
        ),
        React__default.createElement(
          'div',
          { className: classes.orgName },
          orgName
        ),
        React__default.createElement(
          'div',
          { className: classes.info },
          categoryName && React__default.createElement(
            Lozenge,
            { iconClassName: iconClass, backgroundColor: color },
            categoryName
          )
        ),
        React__default.createElement(
          'div',
          { className: classes.logos },
          React__default.createElement(
            'div',
            { className: classes.logo },
            React__default.createElement('img', { src: deploymentModelLogo[engine.deploymentModel] })
          )
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.secondary },
        React__default.createElement(
          'div',
          { className: classes.button },
          React__default.createElement(ToggleButton$1, {
            id: id,
            onAdd: onAdd,
            onRemove: onRemove,
            engineId: engine.id,
            isSelected: isSelected
          })
        )
      )
    )
  );
}

InfoSection.displayName = 'InfoSection';
InfoSection.propTypes = {
  id: string.isRequired,
  engine: shape({
    id: string.isRequired,
    name: string.isRequired,
    category: object,
    description: string,
    iconPath: string,
    ownerOrganization: object
  }).isRequired,
  onAdd: func.isRequired,
  onRemove: func.isRequired,
  isSelected: bool.isRequired
};

var _dec$a, _dec2$8, _class$f, _class2$a, _temp$1;

let EngineDetailView = (_dec$a = withStyles(styles$d), _dec2$8 = connect((state, ownProps) => ({
  isSelected: engineIsSelected(state, ownProps.engine.id, ownProps.id)
}), {
  selectEngines: selectEngines,
  deselectEngines: deselectEngines
}), _dec$a(_class$f = _dec2$8(_class$f = (_temp$1 = _class2$a = class EngineDetailView extends React__default.Component {

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.detailsContainer },
      React__default.createElement(
        'div',
        { className: classes.back },
        React__default.createElement(
          'div',
          {
            className: classes.backBtn,
            onClick: this.props.onCloseDetailView
          },
          React__default.createElement(BackIcon, null),
          React__default.createElement(
            'span',
            null,
            'Back'
          )
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.content },
        React__default.createElement(InfoSection, {
          id: this.props.id,
          engine: this.props.engine,
          onAdd: this.props.selectEngines,
          onRemove: this.props.deselectEngines,
          isSelected: this.props.isSelected
        }),
        React__default.createElement(
          'div',
          { className: classes.description },
          React__default.createElement(
            'div',
            { className: classes.sectionHeading },
            'Description'
          ),
          React__default.createElement(
            'div',
            { className: classes.descriptionContent },
            this.props.engine.description
          )
        )
      )
    );
  }
}, _class2$a.propTypes = {
  id: string.isRequired,
  engine: shape({
    id: string.isRequired,
    name: string.isRequired,
    category: object,
    description: string,
    iconPath: string,
    ownerOrganization: object
  }).isRequired,
  isSelected: bool.isRequired,
  onCloseDetailView: func.isRequired,
  selectEngines: func.isRequired,
  deselectEngines: func.isRequired,
  classes: shape({ any })
}, _class2$a.defaultProps = {}, _temp$1)) || _class$f) || _class$f);
EngineDetailView.displayName = 'EngineDetailView';

var _dec$b, _class$g, _class2$b, _temp2$e;
const { engine: engineModule$4 } = modules;

let EngineSelection = (_dec$b = connect((state, { _widgetId }) => ({
  allEngines: engineModule$4.getEngines(state, _widgetId),
  deselectedEngineIds: getDeselectedEngineIds(state, _widgetId),
  selectedEngineIds: getSelectedEngineIds(state, _widgetId),
  filteredSelectedEngineIds: getFilteredSelectedEngineids(state, _widgetId)
}), {
  initializeWidget: initializeWidget,
  fetchEngines: refetchEngines,
  fetchEngineCategories: engineModule$4.fetchEngineCategories,
  selectEngines: selectEngines,
  setDeselectedEngineIds: setDeselectedEngineIds,
  setAllEnginesSelected: setAllEnginesSelected
}, null, { forwardRef: true }), _dec$b(_class$g = (_temp2$e = _class2$b = class EngineSelection extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      showDetailView: false,
      engineDetails: null
    }, this.save = () => {
      return this.props.onSave(this.props.allEnginesSelected ? this.props.deselectedEngineIds : this.props.selectedEngineIds);
    }, this.veritoneAppDidAuthenticate = () => {
      this.props.fetchEngines(this.props._widgetId);
      this.props.fetchEngineCategories();
    }, this.handleViewDetail = engine => {
      this.setState({
        showDetailView: true,
        engineDetails: engine
      });
    }, this.handleHideDetail = engineId => {
      this.setState({
        showDetailView: false,
        engineDetails: null
      });
    }, _temp;
  }

  UNSAFE_componentWillMount() {
    this.props.initializeWidget(this.props._widgetId);
  }

  componentDidMount() {
    this.props.setDeselectedEngineIds(this.props._widgetId, this.props.initialDeselectedEngineIds);
    this.props.setAllEnginesSelected(this.props._widgetId, this.props.allEnginesSelected);

    this.props.fetchEngineCategories();

    if (_isEmpty(this.props.allEngines)) {
      this.props.fetchEngines(this.props._widgetId);
    } else {
      this.props.selectEngines(this.props._widgetId, this.props.initialSelectedEngineIds);
    }
  }

  render() {
    return this.state.showDetailView ? React__default.createElement(EngineDetailView, {
      id: this.props._widgetId,
      onCloseDetailView: this.handleHideDetail,
      engine: this.state.engineDetails
    }) : React__default.createElement(EngineListView, {
      id: this.props._widgetId,
      onViewDetail: this.handleViewDetail,
      onSave: this.save,
      onCancel: this.props.onCancel,
      actionMenuItems: this.props.actionMenuItems,
      allEngines: this.props.allEngines,
      allEnginesSelected: this.props.allEnginesSelected,
      selectedEngineIds: this.props.filteredSelectedEngineIds,
      hideActions: this.props.hideActions,
      initialSelectedEngineIds: this.props.initialSelectedEngineIds
    });
  }
}, _class2$b.propTypes = {
  _widgetId: string.isRequired,
  onSave: func.isRequired,
  onCancel: func.isRequired,
  actionMenuItems: arrayOf(shape({
    buttonText: string,
    iconClass: string,
    onClick: func.isRequired
  })),
  fetchEngines: func.isRequired,
  setAllEnginesSelected: func.isRequired,
  setDeselectedEngineIds: func.isRequired,
  initializeWidget: func.isRequired,
  allEnginesSelected: bool,
  initialDeselectedEngineIds: arrayOf(string),
  initialSelectedEngineIds: arrayOf(string),
  filteredSelectedEngineIds: arrayOf(string),
  selectedEngineIds: arrayOf(string),
  deselectedEngineIds: arrayOf(string),
  allEngines: objectOf(object),
  selectEngines: func.isRequired,
  fetchEngineCategories: func.isRequired,
  hideActions: bool
}, _class2$b.defaultProps = {
  allEngines: {},
  selectedEngineIds: [],
  initialSelectedEngineIds: [],
  initialDeselectedEngineIds: [],
  allEnginesSelected: false,
  hideActions: false
}, _temp2$e)) || _class$g);
EngineSelection.displayName = 'EngineSelection';


const EngineSelectionWidget = widget(EngineSelection);

var _class$h, _temp2$f;

let Table = (_temp2$f = _class$h = class Table extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.getRowData = i => {
      return this.props.data[i];
    }, _temp;
  }

  render() {
    const TableComp = this.props.paginate ? PaginatedTable : Table$1;
    const tableProps = _omit(this.props, ['data', 'columns', 'paginate']);
    const tableColumns = this.props.columns.map(column => {
      if (column.menu) {
        return React__default.createElement(MenuColumn, _extends$1({
          key: column.dataKey
        }, _omit(column, ['transform', 'menu'])));
      }

      return React__default.createElement(Column, _extends$1({}, _omit(column, ['menu', 'onSelectItem', 'transform']), {
        cellRenderer: column.transform,
        key: column.dataKey
      }));
    });

    return React__default.createElement(
      TableComp,
      _extends$1({
        rowGetter: this.getRowData,
        rowCount: this.props.data.length
      }, tableProps),
      tableColumns
    );
  }
}, _class$h.propTypes = {
  data: arrayOf(object).isRequired,
  columns: arrayOf(shape({
    transform: func,
    menu: bool,
    onSelectItem: func
  })),
  paginate: bool
}, _class$h.defaultProps = {
  paginate: false
}, _temp2$f);
Table.displayName = 'Table';


const TableWidget = widget(Table);

var _dec$c, _class$i, _class2$c, _temp$2;

let GlobalNotificationDialog = (_dec$c = connect(state => ({
  open: selectDialogNotificationState(state).open,
  message: selectDialogNotificationState(state).message,
  title: selectDialogNotificationState(state).title
}), {
  onClose: hideDialogNotification
}), _dec$c(_class$i = (_temp$2 = _class2$c = class GlobalNotificationDialog extends React__default.Component {

  render() {
    return React__default.createElement(
      Dialog,
      { open: this.props.open, onClose: this.props.onClose },
      React__default.createElement(
        DialogTitle,
        null,
        this.props.title
      ),
      React__default.createElement(
        DialogContent,
        null,
        React__default.createElement(
          DialogContentText,
          null,
          this.props.message
        )
      ),
      React__default.createElement(
        DialogActions,
        null,
        React__default.createElement(
          Button,
          { onClick: this.props.onClose, color: 'primary', autoFocus: true },
          'Close'
        )
      )
    );
  }
}, _class2$c.propTypes = {
  open: bool,
  message: string.isRequired,
  title: string,
  onClose: func.isRequired
}, _class2$c.defaultProps = {
  title: ''
}, _temp$2)) || _class$i);
GlobalNotificationDialog.displayName = 'GlobalNotificationDialog';

var _dec$d, _class$j, _class2$d, _temp$3;

let GlobalSnackBar = (_dec$d = connect(state => ({
  open: selectSnackbarNotificationState(state).open,
  message: selectSnackbarNotificationState(state).message
}), {
  onClose: hideSnackbarNotification
}), _dec$d(_class$j = (_temp$3 = _class2$d = class GlobalSnackBar extends React__default.Component {

  render() {
    return React__default.createElement(Snackbar, _extends$1({ autoHideDuration: 4000 }, this.props));
  }
}, _class2$d.propTypes = {
  open: bool,
  message: string.isRequired,
  onClose: func.isRequired
}, _temp$3)) || _class$j);
GlobalSnackBar.displayName = 'GlobalSnackBar';

var _class$k, _temp$4;

let MediaPlayerComponent = (_temp$4 = _class$k = class MediaPlayerComponent extends React__default.Component {

  render() {
    const _props = this.props,
          { myForwardedRef } = _props,
          rest = _objectWithoutProperties(_props, ['myForwardedRef']);
    return React__default.createElement(MediaPlayer$1, _extends$1({
      myForwardedRef: myForwardedRef
    }, rest));
  }
}, _class$k.propTypes = {
  src: string,
  streams: arrayOf(shape({
    protocol: string,
    uri: string
  })),
  overlayContentClassName: string,
  reactPlayerClassName: string,
  boundingPolySeries: arrayOf(shape({
    startTimeMs: number.isRequired,
    stopTimeMs: number.isRequired,
    object: shape({
      id: string.isRequired,
      overlayObjectType: string,
      boundingPoly: arrayOf(shape({ x: number.isRequired, y: number.isRequired })).isRequired
    })
  })),
  onAddBoundingBox: func,
  onDeleteBoundingBox: func,
  onChangeBoundingBox: func,
  onPlayerRefReady: func,
  defaultBoundingBoxStyles: objectOf(any),
  stagedBoundingBoxStyles: objectOf(any),
  stylesByObjectType: objectOf(objectOf(any)),
  actionMenuItems: arrayOf(shape({
    label: string.isRequired,
    onClick: func.isRequired
  })),
  readOnly: bool,
  addOnly: bool,
  autoCommit: bool,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  // fluid = 100% width by default, see video-react docs
  fluid: bool,
  videoHeight: number,
  videoWidth: number,
  hasStarted: bool,
  isActive: bool,
  paused: bool,
  currentTime: number,
  autofocus: bool,
  myForwardedRef: objectOf(any)
}, _class$k.contextTypes = {
  // need to pass our app's redux store to the Player, or else it will create
  // its own internal store that we can't integrate with
  store: object
}, _class$k.defaultProps = {
  fluid: true,
  onAddBoundingBox: _noop,
  onDeleteBoundingBox: _noop,
  onChangeBoundingBox: _noop
}, _temp$4);
MediaPlayerComponent.displayName = 'MediaPlayerComponent';


const MediaPlayerComponentWrapper = connect(state => ({
  videoHeight: state.player.videoHeight,
  videoWidth: state.player.videoWidth,
  hasStarted: state.player.hasStarted,
  isActive: state.player.isActive,
  currentTime: state.player.currentTime,
  paused: state.player.paused,
  isFullscreen: state.player.isFullscreen
}), null, null, { forwardRef: true })(MediaPlayerComponent);

const MediaPlayer = forwardRef((props, ref) => {
  return React__default.createElement(MediaPlayerComponentWrapper, _extends$1({}, props, { myForwardedRef: ref }));
});
MediaPlayer.displayName = 'MediaPlayer';

var styles$e = {
  '@global': {
    '.video-react': {
      '@global': {
        '.video-react-control-bar.mediaPlayerControls': {
          position: 'relative !important'
        },
        '.mediaPlayerControls': {
          fontFamily: 'Roboto, sans-serif',
          outline: 'none !important',
          '& .video-react-control': {
            width: '3em'
          },
          '& .video-react-time-control': {
            paddingLeft: '0.5em',
            paddingRight: '0.5em'
          },
          '& .video-react-control-text, .video-react-mouse-display, .video-react-mouse-display::after, .video-react-play-progress::after': {
            fontFamily: 'Roboto !important'
          },
          '& .video-react-slider:focus': {
            textShadow: 'none',
            boxShadow: 'none'
          }
        }
      }
    }
  },
  externalStyles: {
    top: 'unset !important',
    bottom: 'unset !important',
    position: 'static !important'
  }
};

var _dec$e, _dec2$9, _class$l, _class2$e, _temp$5;

let DefaultControlBar = (_dec$e = withStyles(styles$e), _dec2$9 = connect(state => ({
  playerState: state.player,
  hasStarted: state.player.hasStarted
}), dispatch => ({
  videoReactActions: bindActionCreators(_extends$1({}, playerActions, videoActions), dispatch)
})), _dec$e(_class$l = _dec2$9(_class$l = (_temp$5 = _class2$e = class DefaultControlBar extends React__default.Component {

  render() {
    const manager = _get(this.props.playerRef, 'current.manager');
    let player, actions, store;
    if (manager) {
      player = manager.getState().player;
      actions = manager.getActions();
      store = manager.store;
    }

    if (!manager) {
      return null;
    }

    const {
      hasStarted,
      btnRestart,
      btnReplay,
      btnForward,
      btnPlayToggle,
      btnVolume,
      btnFullscreenToggle,
      ctrlProgress,
      displayTime,
      autoHide,
      autoHideTime,
      classes
    } = this.props;

    return React__default.createElement(
      'div',
      {
        className: classnames('video-react', {
          'video-react-has-started': hasStarted || _get(player, 'hasStarted', false)
        }, classes.externalStyles),
        'data-test': 'DefaultControlBar'
      },
      React__default.createElement(
        ControlBar,
        {
          className: classnames('mediaPlayerControls')
          // need to provide these manually because ControlBar is
          // supposed to be a child of Player and get them automatically
          , autoHide: autoHide,
          autoHideTime: autoHideTime,
          player: player,
          manager: manager,
          actions: actions,
          store: store,
          disableDefaultControls: true
        },
        btnRestart && React__default.createElement(RestartMediaButton, { order: 1.1 }),
        btnReplay && React__default.createElement(ReplayControl, { seconds: 10, order: 1.2 }),
        btnForward && React__default.createElement(ForwardControl, { seconds: 10, order: 1.3 }),
        btnPlayToggle && React__default.createElement(PlayToggle, { order: 2 }),
        displayTime && React__default.createElement(CurrentTimeDisplay, { player: player, order: 3.1 }),
        displayTime && React__default.createElement(TimeDivider, { order: 3.2 }),
        displayTime && React__default.createElement(DurationDisplay, { player: player, order: 3.3 }),
        ctrlProgress && React__default.createElement(ProgressControl, { order: 6 }),
        btnVolume && React__default.createElement(VolumeMenuButton, { vertical: ctrlProgress, order: 7 }),
        btnFullscreenToggle && React__default.createElement(FullscreenToggle, { order: 8 })
      )
    );
  }
}, _class2$e.propTypes = {
  playerRef: shape({
    current: objectOf(any)
  }),
  hasStarted: bool,
  btnRestart: bool,
  btnReplay: bool,
  btnForward: bool,
  btnPlayToggle: bool,
  btnVolume: bool,
  btnFullscreenToggle: bool,
  ctrlProgress: bool,
  displayTime: bool,
  autoHide: bool,
  autoHideTime: number,
  classes: shape({ any })
}, _class2$e.defaultProps = {
  btnRestart: true,
  btnReplay: true,
  btnForward: true,
  btnPlayToggle: true,
  btnVolume: true,
  btnFullscreenToggle: true,
  ctrlProgress: true,
  displayTime: true,
  autoHide: true,
  autoHideTime: 1000
}, _temp$5)) || _class$l) || _class$l);
DefaultControlBar.displayName = 'DefaultControlBar';

var styles$f = {
  popupContainer: {
    width: '90vw',
    height: '90vh',
    margin: '0 auto',
    backgroundColor: darkBlack,
    '& > div:first-child': {
      display: 'contents',
      '& > $boundingPolyContent': {
        height: '100%',
        '& > $reactPlayer': {
          height: '100%',
          display: 'contents'
        }
      }
    },
    '& > $liveLabel': {
      top: 20,
      left: 20,
      position: 'absolute',
      borderRadius: '3px',
      padding: '1px 8px',
      fontSize: 12,
      color: fullWhite,
      pointerEvents: 'none',
      backgroundColor: red500
    }
  },
  boundingPolyContent: {},
  reactPlayer: {},
  liveLabel: {}
};

var _class$m, _temp2$g, _initialiseProps;

let MediaPlayerLightbox = (_temp2$g = _class$m = class MediaPlayerLightbox extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), _initialiseProps.call(this), _temp;
  }

  componentDidMount() {
    if (this.props.autoPlay) {
      setTimeout(() => {
        this.playerRef && this.playerRef.current.actions.play();
      });
    }
  }

  render() {
    const _props = this.props,
          { live, open, fullscreen, onClose, classes } = _props,
          props = _objectWithoutProperties(_props, ['live', 'open', 'fullscreen', 'onClose', 'classes']);

    return React__default.createElement(
      Lightbox,
      { open: open, fullscreen: fullscreen, onClose: onClose },
      React__default.createElement(
        'div',
        { className: classes.popupContainer, 'data-test': 'popupContainer' },
        React__default.createElement(MediaPlayer, _extends$1({}, props, {
          ref: this.playerRef,
          reactPlayerClassName: classes.reactPlayer,
          overlayContentClassName: classes.boundingPolyContent,
          onAddBoundingBox: this.handleOnAddBoundingBox,
          onDeleteBoundingBox: this.handleOnDeleteBoundingBox,
          onChangeBoundingBox: this.handleOnChangeBoundingBox
        })),
        React__default.createElement(DefaultControlBar, {
          btnRestart: !live,
          btnReplay: !live,
          btnForward: !live,
          btnPlayToggle: !live,
          ctrlProgress: !live,
          displayTime: !live,
          btnFullscreenToggle: false,
          playerRef: this.playerRef
        }),
        live && React__default.createElement(
          'div',
          { className: classes.liveLabel, 'data-test': 'liveLabel' },
          'LIVE'
        )
      )
    );
  }
}, _class$m.propTypes = {
  src: string,
  streams: arrayOf(shape({
    protocol: string,
    uri: string
  })),
  live: bool,
  open: bool,
  autoPlay: bool,
  fullscreen: bool,
  onClose: func,
  readOnly: bool,
  onAddBoundingBox: func,
  onDeleteBoundingBox: func,
  onChangeBoundingBox: func,
  classes: shape({ any })
}, _class$m.defaultProps = {
  open: true,
  fullscreen: true,
  readOnly: true
}, _initialiseProps = function () {
  this.playerRef = React__default.createRef();

  this.handleOnAddBoundingBox = (...args) => {
    this.props.onAddBoundingBox && this.props.onAddBoundingBox(...args);
  };

  this.handleOnDeleteBoundingBox = (...args) => {
    this.props.onDeleteBoundingBox && this.props.onDeleteBoundingBox(...args);
  };

  this.handleOnChangeBoundingBox = (...args) => {
    this.props.onChangeBoundingBox && this.props.onChangeBoundingBox(...args);
  };
}, _temp2$g);
MediaPlayerLightbox.displayName = 'MediaPlayerLightbox';


var MediaPlayerLightbox$1 = withStyles(styles$f)(MediaPlayerLightbox);

const MediaPlayerLightboxWidget = widget(MediaPlayerLightbox$1);

const titleText$1 = muiText('title');
const body1Text$4 = muiText('body1');
const captionText = muiText('caption');

var styles$g = {
  engineOutputExport: {
    height: '100%'
  },
  engineOutputExportHeader: {
    height: 110,
    backgroundColor: '#1f2532',
    color: darkWhite,
    '& $title': _extends$1({}, titleText$1, {
      padding: '20px 0 0 20px'
    }),
    '& $subtitle': _extends$1({}, body1Text$4, {
      padding: '5px 20px 0'
    }),
    '& $closeButton': {
      marginTop: 5,
      marginRight: 10,
      float: 'right'
    }
  },
  engineOutputExportContent: {
    padding: '25px 100px',
    overflowY: 'auto'
  },
  engineOutputExportActions: {
    padding: '0 100px',
    '& $actionButton': {
      margin: '20px 0'
    }
  },
  formatSelection: {
    marginBottom: 20
  },
  exportFormatTitle: _extends$1({}, titleText$1, {
    marginBottom: '15px !important'
  }),
  exportFormatSubHeader: _extends$1({}, captionText, {
    color: lightBlack
  }),
  expandIcon: {
    marginRight: '10px !important'
  },
  engineListItem: {
    backgroundColor: grey1,
    '& $engineLogo': {
      marginLeft: 30,
      width: 24,
      height: 24,
      backgroundColor: grey3,
      marginTop: 16
    },
    '& $defaultEngineIcon': {
      marginLeft: 30
    },
    '& $engineNameText': _extends$1({}, body1Text$4, {
      alignItems: 'center',
      marginTop: 16,
      '& $allEnginesText': {
        display: 'flex',
        alignItems: 'center',
        '& $allEnginesInfoIcon': {
          fontSize: '16px !important',
          marginLeft: 5,
          color: grey5
        }
      }
    }),
    '& $customizeOutputBox': _extends$1({}, body1Text$4, {
      width: '100%',
      marginLeft: '30px',
      marginRight: 5,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(33, 150, 243, 0.1)',
      padding: '15px 5px 15px 15px',
      '& $customizeSettingsIcon': {
        color: grey5,
        marginRight: 5,
        flex: 'none'
      },
      '& $customizeSettingsText': {
        flex: 'auto'
      },
      '& $customizeButton': {
        flex: 'none'
      }
    })
  },
  engineConfigInput: {
    width: '65%',
    marginRight: 5
  },
  formControl: {
    minWidth: '60% !important',
    top: 0
  },
  selectStyles: {
    width: '100% !important'
  },
  exportFormatSelected: {
    backgroundColor: 'transparent !important'
  },
  subtitleConfigInfo: _extends$1({}, captionText),
  subtitleConfigField: {
    marginTop: 25,
    '& $subtitleFieldLabel': _extends$1({}, captionText, {
      color: lightBlack
    }),
    '& $subtitleFieldInput': _extends$1({}, body1Text$4, {
      paddingBottom: 4,
      height: '1.1875em'
    }),
    '& $subtitleFieldLabelShrink': {
      transform: 'translate(0, 1.5px)',
      transformOrigin: 'top left'
    }
  },
  errorSnackBar: {
    backgroundColor: `${red500} !important`
  },
  loadingConfigsContainer: {
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  engineNameListText: {
    marginTop: 20,
    padding: '0 10px'
  },
  title: {},
  subtitle: {},
  closeButton: {},
  actionButton: {},
  engineLogo: {},
  defaultEngineIcon: {},
  engineNameText: {},
  allEnginesText: {},
  allEnginesInfoIcon: {},
  customizeOutputBox: {},
  customizeSettingsIcon: {},
  customizeSettingsText: {},
  customizeButton: {},
  subtitleFieldLabel: {},
  subtitleFieldInput: {},
  subtitleFieldLabelShrink: {}
};

var ExpandLess = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

exports.default = _default;
});

var ExpandLessIcon = unwrapExports(ExpandLess);

var ExpandMore = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

exports.default = _default;
});

var ExpandMoreIcon = unwrapExports(ExpandMore);

var ClosedCaption = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
}), 'ClosedCaption');

exports.default = _default;
});

var ClosedCaptionIcon = unwrapExports(ClosedCaption);

var RecordVoiceOver = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "4"
}), _react.default.createElement("path", {
  d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
})), 'RecordVoiceOver');

exports.default = _default;
});

var RecordVoiceOverIcon = unwrapExports(RecordVoiceOver);

var Info = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), 'Info');

exports.default = _default;
});

var InfoIcon = unwrapExports(Info);

var _dec$f, _dec2$a, _class$n, _class2$f, _temp$6;
const { user: userModule$4 } = modules;

let EngineConfigItem = (_dec$f = withStyles(styles$g), _dec2$a = connect((state, { engineId, categoryId }) => ({
  engine: getEngineById(state, engineId),
  category: getCategoryById(state, categoryId),
  exportClosedCaptionsEnabled: userModule$4.hasFeature(state, 'exportClosedCaptions')
}), {
  selectFileType: selectFileType
}, null, { forwardRef: true }), _dec$f(_class$n = _dec2$a(_class$n = (_temp$6 = _class2$f = class EngineConfigItem extends Component {

  render() {
    const {
      engine,
      engineId,
      categoryId,
      category,
      formats,
      selectFileType,
      exportClosedCaptionsEnabled,
      classes
    } = this.props;

    const selectedFileExtensions = formats.map(format => format.extension);

    return React__default.createElement(
      ListItem,
      {
        className: classes.engineListItem,
        'data-veritone-component': 'engine-config-list-item'
      },
      engine && engine.signedIconPath ? React__default.createElement('img', { className: classes.engineLogo, src: engine.signedIconPath, 'data-test': 'engineLogo' }) : React__default.createElement(Icon, { className: classnames(classes['defaultEngineicon'], 'icon-engines') }),
      React__default.createElement(ListItemText, {
        className: classes.engineNameListText,
        classes: { primary: classes.engineNameText },
        primary: engine ? engine.name : React__default.createElement(
          'span',
          { className: classes.allEnginesText },
          React__default.createElement(
            'span',
            null,
            'All Engines'
          ),
          React__default.createElement(
            Tooltip,
            {
              title: 'Export will include formats selected for all available\xA0engines in this category',
              placement: 'bottom-start'
            },
            React__default.createElement(InfoIcon, { className: classes.allEnginesInfoIcon })
          )
        ),
        inset: !engine
      }),
      React__default.createElement(
        FormControl,
        { className: classes.formControl },
        React__default.createElement(
          InputLabel,
          { htmlFor: 'engine-export' },
          selectedFileExtensions.length ? "" : "Select export format"
        ),
        React__default.createElement(
          Select,
          {
            multiple: true,
            className: classes.selectStyles,
            value: selectedFileExtensions
            // eslint-disable-next-line
            , onChange: evt => selectFileType(evt.target.value, categoryId || _get(engine, 'category.id'), engineId)
            // eslint-disable-next-line
            , renderValue: value => `.${value.join(', .')}`,
            input: React__default.createElement(Input, {
              classes: {
                root: classes.engineConfigInput
              }
            }),
            inputProps: {
              name: 'engine-export',
              id: 'engine-export'
            },
            MenuProps: {
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
              },
              getContentAnchorEl: null,
              'data-veritone-element': 'export-format-select-menu'
            },
            'data-veritone-element': 'export-format-select'
          },
          category.exportFormats.map(format => {
            if (includes(format.types, 'subtitle') && !exportClosedCaptionsEnabled) {
              return null;
            }

            return React__default.createElement(
              MenuItem,
              {
                key: `format-${engineId}-${format.format}`,
                value: format.format,
                classes: {
                  selected: classes.exportFormatSelected
                },
                'data-veritone-element': `${format.format}-export-format`
              },
              React__default.createElement(Checkbox, {
                color: 'primary',
                checked: includes(selectedFileExtensions, format.format)
              }),
              React__default.createElement(ListItemText, { primary: `.${format.format} (${format.label})` })
            );
          })
        )
      )
    );
  }
}, _class2$f.propTypes = {
  engineId: string,
  categoryId: string.isRequired,
  engine: shape({
    id: string,
    name: string.isRequired,
    signedIconPath: string
  }),
  category: shape({
    exportFormats: arrayOf(shape({
      label: string,
      format: string.isRequired,
      types: arrayOf(string)
    })).isRequired
  }).isRequired,
  formats: arrayOf(shape({
    extension: string.isRequired,
    options: shape({
      linesPerScreen: number,
      maxLinesPerCaptionLine: number,
      newLineOnPunctuation: bool
    })
  })).isRequired,
  selectFileType: func,
  exportClosedCaptionsEnabled: bool,
  classes: shape({ any })
}, _temp$6)) || _class$n) || _class$n);
EngineConfigItem.displayName = 'EngineConfigItem';

const useStyles$6 = makeStyles(styles$g);

const SubtitleConfigForm = reduxForm({
  form: 'subtitleConfig',
  initialValues: {}
})(({ handleSubmit, onCancel, children, submitting, invalid }) => {
  const classes = useStyles$6();

  return React__default.createElement(
    'form',
    { onSubmit: handleSubmit, 'data-veritone-component': 'subtitle-config-form' },
    React__default.createElement(
      'div',
      { className: classes.subtitleConfigField },
      React__default.createElement(
        FormControl,
        { fullWidth: true },
        React__default.createElement(
          Grid,
          { container: true, spacing: 4, alignItems: 'flex-end' },
          React__default.createElement(
            Grid,
            { item: true, className: classes.subtitleFieldLabel },
            'Max Characters per Caption Line'
          ),
          React__default.createElement(
            Grid,
            { item: true },
            React__default.createElement(Field, {
              type: 'number',
              name: 'maxCharacterPerLine',
              style: { width: 50 },
              component: formComponents.TextField
              // eslint-disable-next-line
              , normalize: value => parseInt(value),
              InputLabelProps: {
                classes: {
                  root: classes.subtitleFieldLabel,
                  shrink: classes.subtitleFieldLabelShrink
                }
              },
              InputProps: {
                classes: {
                  input: classes.subtitleFieldInput
                }
              },
              'data-veritone-element': 'max-characters-per-line-input'
            })
          )
        )
      )
    ),
    React__default.createElement(
      'div',
      { className: classes.subtitleConfigField },
      React__default.createElement(
        FormControl,
        { fullWidth: true },
        React__default.createElement(
          Grid,
          { container: true, spacing: 4, alignItems: 'flex-end' },
          React__default.createElement(
            Grid,
            { item: true, className: classes.subtitleFieldLabel },
            'Number of Lines per Screen'
          ),
          React__default.createElement(
            Grid,
            { item: true },
            React__default.createElement(
              Field,
              {
                component: formComponents.Select,
                name: 'linesPerScreen',
                style: { width: 50 },
                classes: {
                  select: classes.subtitleFieldInput
                },
                MenuProps: {
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                  },
                  getContentAnchorEl: null
                },
                'data-veritone-element': 'lines-per-screen-select'
              },
              React__default.createElement(
                MenuItem,
                { value: 1 },
                '1'
              ),
              React__default.createElement(
                MenuItem,
                { value: 2 },
                '2'
              ),
              React__default.createElement(
                MenuItem,
                { value: 3 },
                '3'
              )
            )
          )
        )
      )
    ),
    React__default.createElement(
      'div',
      { className: classes.subtitleConfigField },
      React__default.createElement(Field, {
        component: formComponents.Switch,
        color: 'primary',
        name: 'newLineOnPunctuation',
        label: 'New Caption Line on Punctuation',
        'data-veritone-element': 'new-line-on-punctuation-switch'
      })
    ),
    React__default.createElement('br', null),
    React__default.createElement(
      DialogActions,
      null,
      React__default.createElement(
        Button,
        {
          onClick: onCancel,
          'data-veritone-element': 'subtitle-config-form-cancel-button'
        },
        'Cancel'
      ),
      React__default.createElement(
        Button,
        {
          type: 'submit',
          color: 'primary',
          disabled: submitting || invalid,
          'data-veritone-element': 'subtitle-config-form-save-button'
        },
        'Save'
      )
    )
  );
});

SubtitleConfigForm.propTypes = {
  handleCancel: func,
  initialValues: shape({
    linesPerScreen: number,
    maxLinesPerCaptionLine: number,
    newLineOnPunctuation: bool
  }),
  onSubmit: func
};

var _dec$g, _dec2$b, _class$o, _class2$g, _temp2$h;

let EngineCategoryConfig = (_dec$g = withStyles(styles$g), _dec2$b = connect((state, { categoryId }) => ({
  category: getCategoryById(state, categoryId),
  transcriptCategoryType: transcriptCategoryType(state),
  initialSubtitleConfig: getSubtitleConfig(state, categoryId),
  initialSpeakerToggle: getSpeakerToggle(state, categoryId),
  hasSpeakerData: hasSpeakerData(state)
}), {
  applySubtitleConfigs: applySubtitleConfigs,
  applySpeakerToggle: applySpeakerToggle,
  storeSpeakerToggle: storeSpeakerToggle
}, null, { forwardRef: true }), _dec$g(_class$o = _dec2$b(_class$o = (_temp2$h = _class2$g = class EngineCategoryConfig extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      dialogOpen: false
    }, this.openCustomizeSubtitles = () => {
      this.setState({
        dialogOpen: true
      });
    }, this.handleCloseDialog = () => {
      this.setState({
        dialogOpen: false
      });
    }, this.handleFormSubmit = values => {
      this.props.applySubtitleConfigs(this.props.category.id, values);
      this.setState({
        dialogOpen: false
      });
    }, this.handleSpeakerToggle = (event, values) => {
      this.props.applySpeakerToggle(this.props.category.id, values);
      this.props.storeSpeakerToggle(this.props.category.id, {
        [this.props.category.id]: {
          withSpeakerData: values
        }
      });
    }, _temp;
  }

  render() {
    const {
      category,
      engineCategoryConfigs,
      onExpandConfigs,
      expanded,
      initialSubtitleConfig,
      initialSpeakerToggle,
      transcriptCategoryType,
      classes
    } = this.props;
    const isTranscriptionCategory = category.categoryType === transcriptCategoryType;

    let hasSubtitleFormatsSelected = false;
    _forEach(engineCategoryConfigs, config => {
      if (_get(config, 'formats.length')) {
        _forEach(config.formats, format => {
          const exportFormat = _find(category.exportFormats, {
            format: format.extension
          });
          if (exportFormat && includes(exportFormat.types, 'subtitle')) {
            hasSubtitleFormatsSelected = true;
          }
        });
      }
    });
    const hasSpeakerData = _get(this.props, 'hasSpeakerData');

    const defaultSubtitleConfig = {
      linesPerScreen: 2,
      maxCharacterPerLine: 32,
      newLineOnPunctuation: false
    };

    return React__default.createElement(
      'div',
      { 'data-veritone-component': 'engine-category-config' },
      React__default.createElement(
        ListItem,
        {
          'data-veritone-element': `${_kebabCase(category.name)}-engine-category`
        },
        React__default.createElement(
          ListItemIcon,
          null,
          React__default.createElement(Icon, { className: category.iconClass })
        ),
        React__default.createElement(ListItemText, {
          id: 'engineCategoryName',
          primary: `${category.name} (${engineCategoryConfigs.length})`
        }),
        React__default.createElement(
          ListItemIcon,
          { classes: { root: classes.expandIcon } },
          React__default.createElement(
            IconButton,
            {
              'aria-label': 'Expand Category'
              // eslint-disable-next-line
              , onClick: () => onExpandConfigs(category.id),
              'data-veritone-element': 'engine-category-config-more-less-button'
            },
            expanded ? React__default.createElement(ExpandLessIcon, null) : React__default.createElement(ExpandMoreIcon, null)
          )
        )
      ),
      React__default.createElement(
        Collapse,
        { 'in': expanded, timeout: 'auto', unmountOnExit: true },
        React__default.createElement(
          List$2,
          { disablePadding: true },
          engineCategoryConfigs.map(config => {
            return React__default.createElement(EngineConfigItem, {
              key: `engine-config-item-${config.engineId || config.categoryId}`,
              engineId: config.engineId,
              categoryId: category.id,
              formats: config.formats
            });
          }),
          hasSpeakerData && isTranscriptionCategory && React__default.createElement(
            ListItem,
            { className: classes.engineListItem },
            React__default.createElement(
              'div',
              { className: classes.customizeOutputBox },
              React__default.createElement(RecordVoiceOverIcon, {
                className: classes.customizeSettingsIcon
              }),
              React__default.createElement(
                'span',
                { className: classes.customizeSettingsText },
                'Include speaker separation results'
              ),
              React__default.createElement(Switch, {
                className: classes.customizeButton,
                color: 'primary',
                checked: initialSpeakerToggle.withSpeakerData,
                onChange: this.handleSpeakerToggle,
                'data-veritone-element': 'with-speaker-data'
              })
            )
          ),
          hasSubtitleFormatsSelected && React__default.createElement(
            ListItem,
            { className: classes.engineListItem },
            React__default.createElement(
              'div',
              { className: classes.customizeOutputBox },
              React__default.createElement(ClosedCaptionIcon, { className: classes.customizeSettingsIcon }),
              React__default.createElement(
                'span',
                { className: classes.customizeSettingsText },
                'Subtitle formats have been selected, adjust the format and display settings here'
              ),
              React__default.createElement(
                Button,
                {
                  color: 'primary',
                  className: classes.customizeButton,
                  onClick: this.openCustomizeSubtitles,
                  'data-veritone-element': 'customize-subtitle-formats-button'
                },
                'Customize'
              )
            )
          )
        )
      ),
      React__default.createElement(
        Dialog,
        {
          open: this.state.dialogOpen,
          onClose: this.handleCloseDialog,
          'aria-labelledby': 'customize-dialog-title',
          'data-veritone-element': 'customize-subtitle-formats-dialog'
        },
        React__default.createElement(
          DialogTitle,
          { id: 'customize-dialog-title' },
          'Subtitle Format Settings'
        ),
        React__default.createElement(
          DialogContent,
          null,
          React__default.createElement(
            DialogContentText,
            { className: classes.subtitleConfigInfo },
            'Adjust the format and display settings for your subtitle export for maximum readability.'
          ),
          React__default.createElement(SubtitleConfigForm, {
            onCancel: this.handleCloseDialog,
            initialValues: initialSubtitleConfig || defaultSubtitleConfig,
            onSubmit: this.handleFormSubmit
          })
        )
      )
    );
  }
}, _class2$g.propTypes = {
  transcriptCategoryType: string,
  category: shape({
    id: string.isRequired,
    iconClass: string.isRequired,
    name: string.isRequired
  }).isRequired,
  engineCategoryConfigs: arrayOf(shape({
    engineId: string,
    categoryId: string,
    formats: arrayOf(shape({
      extension: string.isRequired,
      options: shape({
        maxCharacterPerLine: number,
        newLineOnPunctuation: bool,
        linesPerScreen: number
      })
    }))
  })).isRequired,
  applySubtitleConfigs: func,
  expanded: bool,
  onExpandConfigs: func,
  initialSubtitleConfig: shape({
    maxCharacterPerLine: number,
    newLineOnPunctuation: bool,
    linesPerScreen: number
  }),
  applySpeakerToggle: func,
  storeSpeakerToggle: func,
  initialSpeakerToggle: shape({
    withSpeakerData: bool
  }),
  classes: shape({ any })
}, _temp2$h)) || _class$o) || _class$o);
EngineCategoryConfig.displayName = 'EngineCategoryConfig';

var _dec$h, _dec2$c, _class$p, _class2$h, _temp$7;

let EngineCategoryConfigList = (_dec$h = withStyles(styles$g), _dec2$c = connect(state => ({
  outputConfigsByCategoryId: outputConfigsByCategoryId(state),
  expandedCategories: expandedCategories(state),
  fetchingEngineRuns: fetchingEngineRuns(state),
  speakerCategoryType: speakerCategoryType(state),
  hasSpeakerData: hasSpeakerData(state)
}), {
  fetchEngineRuns: fetchEngineRuns,
  toggleConfigExpand: toggleConfigExpand,
  setHasSpeakerData: setHasSpeakerData
}, null, { forwardRef: true }), _dec$h(_class$p = _dec2$c(_class$p = (_temp$7 = _class2$h = class EngineCategoryConfigList extends Component {

  componentDidMount() {
    this.props.fetchEngineRuns(this.props.tdos);
  }

  componentDidUpdate() {
    // Detect if speaker data is available
    const { speakerCategoryType, outputConfigsByCategoryId } = this.props;
    let hasSpeakerDataBeenSet = this.props.hasSpeakerData;
    _Object$keys(outputConfigsByCategoryId).forEach(categoryId => {
      const categoryEngines = outputConfigsByCategoryId[categoryId];
      categoryEngines.forEach(engine => {
        const isSpeakerCategory = engine.categoryType === speakerCategoryType;
        if (isSpeakerCategory && !hasSpeakerDataBeenSet) {
          hasSpeakerDataBeenSet = true;
          this.props.setHasSpeakerData(true);
        }
      });
    });
  }

  render() {
    const {
      fetchingEngineRuns,
      outputConfigsByCategoryId,
      expandedCategories,
      toggleConfigExpand,
      speakerCategoryType,
      classes
    } = this.props;

    // Temporary bypass of speaker category since we are planning
    // to separate it from transcription output in the future
    const modifiedOutputConfigsByCategoryId = _Object$keys(outputConfigsByCategoryId).filter(categoryId => outputConfigsByCategoryId[categoryId].find(engine => engine.categoryType !== speakerCategoryType));

    return React__default.createElement(
      'div',
      { 'data-veritone-component': 'engine-category-config-list' },
      !fetchingEngineRuns ? React__default.createElement(
        List$2,
        { disablePadding: true },
        modifiedOutputConfigsByCategoryId.map((key, index) => React__default.createElement(
          Fragment$1,
          { key: `engine-output-config-${key}` },
          React__default.createElement(EngineCategoryConfig, {
            categoryId: key,
            engineCategoryConfigs: outputConfigsByCategoryId[key],
            expanded: expandedCategories[key],
            onExpandConfigs: toggleConfigExpand
          }),
          index !== _Object$keys(outputConfigsByCategoryId).length - 1 && React__default.createElement(Divider, null)
        ))
      ) : React__default.createElement(
        'div',
        { className: classes.loadingConfigsContainer },
        React__default.createElement(CircularProgress, { size: 50, thickness: 2.5 })
      )
    );
  }
}, _class2$h.propTypes = {
  tdos: arrayOf(shape({
    tdoId: string.isRequired,
    mentionId: string,
    startOffsetMs: number,
    stopOffsetMs: number
  })).isRequired,
  outputConfigsByCategoryId: objectOf(arrayOf(shape({
    engineId: string,
    categoryId: string
  }))).isRequired,
  expandedCategories: objectOf(bool),
  fetchEngineRuns: func,
  fetchingEngineRuns: bool,
  toggleConfigExpand: func,
  setHasSpeakerData: func,
  hasSpeakerData: bool,
  speakerCategoryType: string,
  classes: shape({ any })
}, _temp$7)) || _class$p) || _class$p);
EngineCategoryConfigList.displayName = 'EngineCategoryConfigList';

var _dec$i, _dec2$d, _class$q, _class2$i, _temp2$i, _class3$3, _temp4$3;

let EngineOutputExport = (_dec$i = withStyles(styles$g), _dec2$d = connect(state => ({
  includeMedia: getIncludeMedia(state),
  outputConfigsByCategoryId: outputConfigsByCategoryId(state),
  expandedCategories: expandedCategories(state),
  fetchingEngineRuns: fetchingEngineRuns(state),
  fetchingCategoryExportFormats: fetchingCategoryExportFormats(state),
  errorSnackBars: errorSnackBars(state),
  fetchEngineRunsFailed: fetchEngineRunsFailed(state)
}), {
  setIncludeMedia: setIncludeMedia,
  exportAndDownload: exportAndDownload,
  closeSnackBar: closeSnackBar
}, null, { forwardRef: true }), _dec$i(_class$q = _dec2$d(_class$q = (_temp2$i = _class2$i = class EngineOutputExport extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleIncludeMediaChange = event => {
      this.props.setIncludeMedia(event.target.checked);
    }, this.handleExportAndDownload = () => {
      this.props.exportAndDownload(this.props.tdos).then(response => {
        const createExportRequest = _get(response, 'createExportRequest');
        this.props.onExport(createExportRequest);
        return createExportRequest;
      });
    }, _temp;
  }

  render() {
    const {
      tdos,
      includeMedia,
      fetchingEngineRuns,
      fetchingCategoryExportFormats,
      open,
      onCancel,
      errorSnackBars,
      closeSnackBar,
      fetchEngineRunsFailed,
      classes
    } = this.props;

    const disableExportButton = fetchingEngineRuns || fetchingCategoryExportFormats || fetchEngineRunsFailed;

    const snackBarClasses = {
      error: classes.errorSnackBar
    };

    return React__default.createElement(
      Dialog,
      {
        fullScreen: true,
        open: open,
        'data-veritone-component': 'export-and-download-dialog'
      },
      React__default.createElement(
        Grid,
        {
          container: true,
          direction: 'column',
          justify: 'flex-start',
          className: classes.engineOutputExport
        },
        React__default.createElement(
          Grid,
          { item: true, className: classes.engineOutputExportHeader, container: true },
          React__default.createElement(
            Grid,
            { item: true, xs: 11 },
            React__default.createElement(
              'div',
              { className: classes.title },
              `${tdos.length > 1 ? 'Bulk ' : ''}Export and Download`
            ),
            React__default.createElement(
              'div',
              { className: classes.subtitle },
              'Select the category, engine, and format type you would like to export with the option to download the corresponding file.'
            )
          ),
          React__default.createElement(
            Grid,
            { item: true, xs: 1 },
            React__default.createElement(
              IconButton,
              {
                className: classes.closeButton,
                color: 'inherit',
                onClick: onCancel,
                'aria-label': 'Close',
                'data-veritone-element': 'export-and-download-close-button'
              },
              React__default.createElement(CloseIcon, null)
            )
          )
        ),
        React__default.createElement(
          Grid,
          {
            item: true,
            xs: true,
            className: classes.engineOutputExportContent,
            container: true,
            direction: 'column',
            alignItems: 'center'
          },
          React__default.createElement(
            Grid,
            { item: true, xs: 12 },
            React__default.createElement(
              Card,
              { className: classes.formatSelection },
              React__default.createElement(CardHeader, {
                title: 'Export Format Selection',
                subheader: 'Select the preferred engine categories and engines that have processed the file(s). Then choose the applicable format(s) to include in your export.',
                classes: {
                  title: classes.exportFormatTitle,
                  subheader: classes.exportFormatSubHeader
                }
              }),
              React__default.createElement(EngineCategoryConfigList, { tdos: tdos })
            ),
            React__default.createElement(
              Card,
              null,
              React__default.createElement(CardHeader, {
                title: 'Enable File Download',
                action: React__default.createElement(Switch, {
                  checked: includeMedia,
                  onChange: this.handleIncludeMediaChange,
                  color: 'primary',
                  'data-veritone-element': 'export-and-download-include-media-switch'
                }),
                subheader: 'Include the media file with your format export. Downloading the file may increase the wait time.',
                classes: {
                  title: classes.exportFormatTitle,
                  subheader: classes.exportFormatSubHeader
                }
              })
            )
          )
        ),
        React__default.createElement(
          Grid,
          {
            item: true,
            container: true,
            justify: 'flex-end',
            alignItems: 'center',
            className: classes.engineOutputExportActions,
            'data-veritone-element': 'export-and-download-action-buttons'
          },
          React__default.createElement(
            Button,
            {
              className: classes.actionButton,
              onClick: onCancel,
              'data-veritone-element': 'export-and-download-cancel-button'
            },
            'Cancel'
          ),
          React__default.createElement(
            Button,
            {
              variant: 'contained',
              color: 'primary',
              className: classes.actionButton,
              onClick: this.handleExportAndDownload,
              disabled: disableExportButton,
              'data-veritone-element': 'export-and-download-export-button'
            },
            'Export'
          )
        )
      ),
      _isArray$1(errorSnackBars) && errorSnackBars.map(snackBar => {
        return React__default.createElement(
          Snackbar,
          {
            key: `snack-bar-${snackBar.id}`,
            anchorOrigin: snackBar.anchorOrigin,
            open: snackBar.open,
            autoHideDuration: 5000
            // eslint-disable-next-line
            , onClose: () => closeSnackBar(snackBar.id),
            'data-veritone-element': 'export-and-download-snackbar'
          },
          React__default.createElement(SnackbarContent, {
            className: snackBarClasses[snackBar.variant],
            message: React__default.createElement(
              'span',
              { id: 'message-id' },
              snackBar.message
            ),
            action: [React__default.createElement(
              IconButton,
              {
                key: 'close',
                'aria-label': 'Close',
                color: 'inherit'
                // eslint-disable-next-line
                , onClick: () => closeSnackBar(snackBar.id),
                'data-veritone-element': 'export-and-download-snackbar-close-button'
              },
              React__default.createElement(CloseIcon, null)
            )]
          })
        );
      })
    );
  }
}, _class2$i.propTypes = {
  tdos: arrayOf(shape({
    tdoId: string.isRequired,
    mentionId: string,
    startOffsetMs: number,
    stopOffsetMs: number
  })).isRequired,
  open: bool,
  onCancel: func,
  onExport: func,
  includeMedia: bool,
  setIncludeMedia: func,
  fetchingEngineRuns: bool,
  fetchingCategoryExportFormats: bool,
  exportAndDownload: func.isRequired,
  errorSnackBars: arrayOf(shape({})),
  closeSnackBar: func,
  fetchEngineRunsFailed: bool,
  classes: shape({ any })
}, _temp2$i)) || _class$q) || _class$q);
EngineOutputExport.displayName = 'EngineOutputExport';
let EngineOutputExportWidgetComponent = (_temp4$3 = _class3$3 = class EngineOutputExportWidgetComponent extends Component {
  constructor(...args) {
    var _temp3;

    return _temp3 = super(...args), this.state = {
      open: false
    }, this.open = () => {
      this.setState({
        open: true
      });
    }, this.handleCancel = () => {
      this.props.onCancel();
      this.setState({
        open: false
      });
    }, this.handleExport = response => {
      this.props.onExport(response);
      this.setState({
        open: false
      });
    }, _temp3;
  }

  render() {
    return React__default.createElement(EngineOutputExport, _extends$1({
      id: this.props._widgetId,
      open: this.state.open
    }, this.props, {
      onExport: this.handleExport,
      onCancel: this.handleCancel
    }));
  }
}, _class3$3.propTypes = {
  _widgetId: string.isRequired,
  tdos: arrayOf(shape({
    tdoId: string.isRequired,
    startOffsetMs: number,
    stopOffsetMs: number
  })).isRequired,
  onExport: func.isRequired,
  onCancel: func
}, _temp4$3);
EngineOutputExportWidgetComponent.displayName = 'EngineOutputExportWidgetComponent';


const EngineOutputExportWidget = widget(EngineOutputExportWidgetComponent);

var styles$h = {
  rowLoader: {
    height: '100% !important',
    width: '100% !important',
    textAlign: 'center',
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'center'
  },
  firstLoader: {
    width: '100%',
    textAlign: 'center',
    borderTop: '1px solid #ccc',
    padding: '0.5em'
  },
  infinitePickerContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  errorMessage: {
    display: 'table-row !important',
    textAlign: 'center'
  },
  rowLoaderSpinner: {
    width: '100% !important',
    border: '0 !important',
    textAlign: 'center !important'
  },
  infiniteScrollContainer: {
    flexGrow: '1 !important',
    height: '100%',
    overflow: 'auto',
    display: 'block !important'
  },
  infiniteScrollHeader: {
    width: '100% !important',
    '& tr': {
      display: 'block'
    }
  },
  pickerTitle: {
    display: 'flex',
    padding: '24px 0 12px 24px'
  },
  pickerTitleContainer: {
    width: '50%',
    display: 'flex',
    alignItems: 'center'
  },
  pickerSearchContainer: {
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  tableContainer: {
    width: '100% !important',
    flexGrow: '1 !important',
    height: '100% !important'
  },
  table: {
    width: '100%',
    height: 'calc(100% - 1px)'
  },
  columnRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  selected: {
    backgroundColor: 'rgba(33, 150, 243, 0.6)'
  },
  textSpace: {
    marginRight: '0.1em !important'
  },
  textLineHeight: {
    lineHeight: '2.2 !important'
  }
};

var _class$r, _temp2$j, _class2$j, _temp4$4;

let StatefulExpandableInputField = (_temp2$j = _class$r = class StatefulExpandableInputField extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      value: ''
    }, this.onChange = evt => {
      this.setState({ value: evt.target.value });
    }, this.onReset = evt => {
      this.setState({ value: '' }, () => {
        if (this.props.onReset) {
          this.props.onReset();
        }
      });
    }, _temp;
  }

  render() {
    return React__default.createElement(ExpandableInputField, {
      onSearch: this.props.onSearch,
      icon: React__default.createElement(SearchIcon, null),
      value: this.state.value,
      onChange: this.onChange,
      onReset: this.onReset
    });
  }
}, _class$r.propTypes = {
  onSearch: func,
  onReset: func
}, _temp2$j);
StatefulExpandableInputField.displayName = 'StatefulExpandableInputField';
let InfiniteTablePicker = (_temp4$4 = _class2$j = class InfiniteTablePicker extends React__default.Component {
  constructor(...args) {
    var _temp3;

    return _temp3 = super(...args), this.getToggleSelectionHandler = id => evt => {
      if (this.props.toggleGlobally) {
        this.props.toggleSelection({ rowId: id });
      } else {
        this.props.toggleSelection({ id: this.props.id, rowId: id });
      }
    }, this.handleScroll = evt => {
      evt.persist();
      if (this.props.hasMorePages && !this.props.loading) {
        this.debouncedScroll(evt, this.props.id);
      }
    }, this.onReset = evt => {
      this.props.fetchMore({ id: this.props.id });
    }, this.debouncedScroll = _debounce((evt, id) => {
      if (evt.target.scrollHeight - evt.target.scrollTop - this.props.infiniteScrollMargin < evt.target.clientHeight) {
        this.props.fetchMore({
          id,
          search: this.props.lastSearch
        });
      }
    }, this.props.infiniteScrollDebounceTimeMs), this.retry = evt => {
      this.props.fetchMore({
        id: this.props.id
      });
    }, this.onSearch = value => {
      if (this.props.lastSearch !== value) {
        this.props.fetchMore({
          id: this.props.id,
          search: value
        });
      }
    }, this.isSelectionDisabled = rowId => {
      // selected rows can always be unselected
      if (this.props.selected && this.props.selected.hasOwnProperty(rowId)) {
        return false;
      }

      return !this.props.canSelectMore;
    }, _temp3;
  }

  componentDidMount() {
    this.props.fetchMore({ id: this.props.id });
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      Paper,
      { elevation: 4, style: { height: this.props.pickerHeight } },
      React__default.createElement(
        'div',
        { className: classes.infinitePickerContainer },
        React__default.createElement(
          'div',
          { className: classes.pickerTitle },
          React__default.createElement(
            'div',
            { className: classes.pickerTitleContainer },
            React__default.createElement(
              Typography,
              { variant: 'h5' },
              this.props.pickerTitle
            )
          ),
          React__default.createElement(
            'div',
            { className: classes.pickerSearchContainer },
            React__default.createElement(StatefulExpandableInputField, {
              onSearch: this.onSearch,
              onReset: this.onReset
            })
          )
        ),
        React__default.createElement(
          'div',
          { className: classes.tableContainer, onScroll: this.handleScroll },
          React__default.createElement(
            Table$2,
            { className: classes.table },
            React__default.createElement(
              TableHead,
              { className: classes.infiniteScrollHeader },
              React__default.createElement(
                TableRow,
                null,
                this.props.columns.map(column => React__default.createElement(
                  TableCell,
                  {
                    key: `header_${column.name}`,
                    style: {
                      width: column.width,
                      paddingRight: '8px',
                      minWidth: column.width,
                      paddingLeft: column.paddingLeft
                    }
                  },
                  React__default.createElement(
                    Typography,
                    { variant: 'subtitle1' },
                    column.name
                  )
                ))
              )
            ),
            React__default.createElement(
              TableBody,
              { className: classes.infiniteScrollContainer },
              this.props.loadingFailed && React__default.createElement(
                TableRow,
                { className: classes.rowLoader },
                React__default.createElement(
                  TableCell,
                  {
                    colSpan: this.props.columns.length,
                    className: classes.rowLoaderSpinner
                  },
                  React__default.createElement(
                    Typography,
                    { variant: 'subtitle1', gutterBottom: true },
                    this.props.failedToLoadMessage
                  ),
                  React__default.createElement(
                    Button,
                    {
                      variant: 'contained',
                      color: 'primary',
                      onClick: this.retry
                    },
                    'Retry'
                  )
                )
              ),
              this.props.rows && this.props.rows.map(row => React__default.createElement(
                TableRow,
                {
                  key: `infinite_row_${row.id}`,
                  style: { height: this.props.rowHeight },
                  selected: this.props.selected && row.id in this.props.selected,
                  classes: { selected: classes.selected }
                },
                this.props.maxSelections === 1 ? React__default.createElement(
                  TableCell,
                  {
                    style: { minWidth: this.props.columns[0].width }
                  },
                  React__default.createElement(Radio, {
                    disabled: this.isSelectionDisabled(row.id),
                    value: row.id,
                    onChange: this.getToggleSelectionHandler(row.id)
                  })
                ) : React__default.createElement(
                  TableCell,
                  {
                    style: { minWidth: this.props.columns[0].width }
                  },
                  React__default.createElement(Checkbox, {
                    disabled: this.isSelectionDisabled(row.id),
                    value: row.id,
                    checked: this.props.selected && row.id in this.props.selected,
                    onChange: this.getToggleSelectionHandler(row.id)
                  })
                ),
                this.props.renderRow(row)
              )),
              this.props.loading && (!this.props.rows || this.props.rows.length === 0) && React__default.createElement(
                TableRow,
                { className: classes.rowLoader },
                React__default.createElement(
                  TableCell,
                  {
                    colSpan: this.props.columns.length,
                    className: classes.rowLoaderSpinner
                  },
                  React__default.createElement(CircularProgress, { size: 60 })
                )
              )
            )
          )
        ),
        this.props.loading && this.props.rows && this.props.rows.length > 0 && React__default.createElement(
          'div',
          { className: classes.firstLoader },
          React__default.createElement(CircularProgress, { size: 60 })
        )
      )
    );
  }
}, _class2$j.propTypes = {
  rowHeight: string,
  pickerHeight: string,
  pickerTitle: string,
  infiniteScrollDebounceTimeMs: number,
  infiniteScrollMargin: number,
  failedToLoadMessage: string,
  rows: arrayOf(object),
  loading: bool.isRequired,
  loadingFailed: bool.isRequired,
  lastSearch: string.isRequired,
  canSelectMore: bool,
  toggleGlobally: bool,
  hasMorePages: bool.isRequired,
  selected: objectOf(any),
  id: string,
  renderRow: func.isRequired,
  fetchMore: func.isRequired,
  toggleSelection: func,
  columns: arrayOf({
    name: string,
    width: string,
    paddingLeft: string
  }),
  maxSelections: number,
  classes: shape({ any })
}, _class2$j.defaultProps = {
  infiniteScrollMargin: 100,
  infiniteScrollDebounceTimeMs: 250,
  rowHeight: '65px',
  pickerHeight: '100%',
  failedToLoadMessage: 'Failed to load',
  id: guid(),
  maxSelections: 1
}, _temp4$4);
InfiniteTablePicker.displayName = 'InfiniteTablePicker';


const InfinitePicker = withStyles(styles$h)(InfiniteTablePicker);

// https://github.com/tc39/proposal-object-values-entries

var $entries = _objectToArray(true);

_export(_export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

var entries = _core.Object.entries;

var entries$1 = createCommonjsModule(function (module) {
module.exports = { "default": entries, __esModule: true };
});

var _Object$entries = unwrapExports(entries$1);

var Star = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

exports.default = _default;
});

var StarIcon = unwrapExports(Star);

var Delete = createCommonjsModule(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault(React__default);

var _createSvgIcon = interopRequireDefault(createSvgIcon_1);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');

exports.default = _default;
});

var DeleteIcon = unwrapExports(Delete);

var _dec$j, _dec2$e, _class$s, _class2$k, _temp2$k;

let SelectionInfoPanel = (_dec$j = withStyles(styles$h), _dec2$e = connect((state, { ids }) => {
  return {
    selectedEngines: selectedEngines(state)
  };
}), _dec$j(_class$s = _dec2$e(_class$s = (_temp2$k = _class2$k = class SelectionInfoPanel extends React__default.PureComponent {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.getRemoveHandler = engineId => () => {
      if (engineId === this.props.baselineEngineId) {
        this.props.selectBaseline(undefined);
      }
      this.props.toggleEngineSelection({ rowId: engineId });
    }, this.getSelectionHandler = engineId => () => this.props.selectBaseline(engineId), _temp;
  }

  render() {
    const { classes } = this.props;

    return React__default.createElement(
      Paper,
      { elevation: 4, style: { height: '100%', minHeight: '300px' } },
      React__default.createElement(
        'div',
        { className: classes.pickerTitle },
        React__default.createElement(
          Typography,
          { variant: 'h5', className: classes.textSpace },
          'Selected Engines'
        ),
        React__default.createElement(
          Typography,
          {
            variant: 'subtitle1',
            className: classes.textLineHeight
          },
          _Object$keys(this.props.selectedEngines).length,
          ' / ',
          this.props.maxSelections
        )
      ),
      React__default.createElement(
        List$2,
        null,
        _Object$entries(this.props.selectedEngines).map(([engineId, engine]) => {
          return engine && React__default.createElement(
            ListItem,
            { key: engine.id, divider: true },
            React__default.createElement(
              Grid,
              {
                container: true,
                spacing: 1
              },
              React__default.createElement(
                Grid,
                { item: true, xs: 12, sm: 8 },
                React__default.createElement(
                  Grid,
                  {
                    container: true,
                    direction: 'row',
                    justify: 'flex-start',
                    alignItems: 'center'
                  },
                  React__default.createElement(
                    Grid,
                    { item: true, xs: 1 },
                    engine.owned && React__default.createElement(
                      ListItemIcon,
                      null,
                      React__default.createElement(StarIcon, null)
                    )
                  ),
                  React__default.createElement(
                    Grid,
                    { item: true, xs: this.props.selectBaseline ? 8 : 9 },
                    React__default.createElement(
                      Typography,
                      { variant: 'subtitle1' },
                      engine.name
                    ),
                    React__default.createElement(
                      Typography,
                      { variant: 'caption' },
                      engine.ownerOrganization.name
                    )
                  )
                )
              ),
              React__default.createElement(
                Grid,
                { item: true, xs: 12, sm: 4, className: classes.columnRight },
                this.props.selectBaseline && React__default.createElement(
                  SelectionButton,
                  {
                    selected: this.props.baselineEngineId === engine.id,
                    toggleSelection: this.getSelectionHandler(engine.id)
                  },
                  'Baseline'
                ),
                React__default.createElement(
                  ListItemIcon,
                  null,
                  React__default.createElement(
                    IconButton,
                    {
                      'aria-label': 'unselect_engine',
                      onClick: this.getRemoveHandler(engine.id)
                    },
                    React__default.createElement(DeleteIcon, null)
                  )
                )
              )
            )
          );
        })
      )
    );
  }
}, _class2$k.propTypes = {
  selectedEngines: objectOf(any),
  toggleEngineSelection: func,
  selectBaseline: func,
  baselineEngineId: string,
  maxSelections: number,
  classes: shape({ any })
}, _class2$k.defaultProps = {
  maxSelections: 6
}, _temp2$k)) || _class$s) || _class$s);
SelectionInfoPanel.displayName = 'SelectionInfoPanel';


const SelectionInfoPanelWidget = widget(SelectionInfoPanel);

var _dec$k, _dec2$f, _class$t, _class2$l, _temp2$l;

const columns = [{ name: 'Benchmark', width: '100px' }, { name: 'Engine', width: '100%', paddingLeft: '40px' }, { name: 'Build Version', width: '150px' }];

let EnginePicker = (_dec$k = withPropsOnChange([], ({ id }) => ({
  id: id || guid()
})), _dec2$f = connect((state, { id, selected, canSelectMore: canSelectMore$1 }) => {
  return {
    rows: engines(state, id),
    loading: loadingEngines(state, id),
    loadingFailed: loadingEnginesFailed(state, id),
    lastSearch: lastSearch(state, id),
    selected: selected || selectedEngines(state, id),
    hasMorePages: hasMorePages(state, id),
    canSelectMore: canSelectMore$1 || canSelectMore(state, id)
  };
}, {
  fetchMore: fetchEngines,
  toggleSelection: toggleEngine
}, (stateProps, dispatchProps, ownProps) => _extends$1({}, stateProps, ownProps, dispatchProps)), _dec$k(_class$t = _dec2$f(_class$t = (_temp2$l = _class2$l = class EnginePicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.fetchMore = ({ id, search = '' }) => {
      this.props.fetchMore({
        id,
        category: 'transcript',
        engineName: search,
        owned: this.props.onlyShowMyEngines
      });
    }, this.renderRow = engine => [React__default.createElement(
      TableCell,
      { key: columns[1].name, style: { width: columns[1].width } },
      React__default.createElement(
        Typography,
        { variant: 'subtitle1' },
        engine.name
      ),
      React__default.createElement(
        Typography,
        { variant: 'caption' },
        !this.props.onlyShowMyEngines && engine.ownerOrganization.name
      )
    ), React__default.createElement(
      TableCell,
      { key: columns[2].name, style: { width: columns[2].width } },
      React__default.createElement(
        Typography,
        { variant: 'subtitle1' },
        engine.deployedVersion
      )
    )], _temp;
  }

  render() {
    return React__default.createElement(InfinitePicker, _extends$1({
      renderRow: this.renderRow
    }, this.props, {
      columns: columns,
      failedToLoadMessage: 'Oops! Something went wrong.',
      pickerTitle: this.props.title,
      fetchMore: this.fetchMore,
      maxSelections: this.props.maxSelections
    }));
  }
}, _class2$l.propTypes = {
  failedToLoadMessage: string,
  rows: arrayOf(object),
  loading: bool.isRequired,
  loadingFailed: bool.isRequired,
  lastSearch: string.isRequired,
  canSelectMore: bool,
  hasMorePages: bool.isRequired,
  selected: objectOf(any),
  id: string,
  fetchMore: func,
  toggleGlobally: bool,
  onlyShowMyEngines: bool,
  maxSelections: number,
  title: string
}, _class2$l.defaultProps = {
  failedToLoadMessage: 'Failed to load',
  id: guid(),
  onlyShowMyEngines: false,
  title: 'Available Engines',
  toggleGlobally: false
}, _temp2$l)) || _class$t) || _class$t);
EnginePicker.displayName = 'EnginePicker';


const EnginePickerWidget = widget(EnginePicker);

window.regeneratorRuntime = runtime_1;

export { AppBar, AppBarWidget, DataPicker, DataPickerWidget, EngineOutputExport, EngineOutputExportWidget, EnginePicker, EnginePickerWidget, EngineSelectionWidget, FilePicker, FilePickerWidget, FolderTree, FolderTreeWidget, GlobalNotificationDialog, GlobalSnackBar, InfinitePicker, MediaPlayer, DefaultControlBar as MediaPlayerControlBar, MediaPlayerLightbox$1 as MediaPlayerLightbox, MediaPlayerLightboxWidget, OAuthLoginButton, OAuthLoginButtonWidget, SelectionInfoPanel, SelectionInfoPanelWidget, TableWidget, UserProfileWidget, VeritoneApp, index$1 as dataPickerModule, dataPickerReducer, root$2 as dataPickerSaga, index$4 as engineOutputExportModule, engineOutputExportReducer, root$4 as engineOutputExportSaga, index as filePickerModule, filePickerReducer, root$1 as filePickerSaga, index$5 as folderTreeModule, folderReducer as folderTreeReducer, formNameSpace, formReducer, index$2 as multipleEngineSelectionModule, reducer$2 as multipleEngineSelectionReducer, index$3 as notificationsModule, reducer$3 as notificationsReducer, reducers, root$6 as rootSaga };



//////////////////
// WEBPACK FOOTER
// ./~/veritone-widgets/dist/bundle-es.js
// module id = jfDy
// module chunks = 22